/* tslint:disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ALLERGEN {
  CELERY = "CELERY",
  CRUSTACEANS = "CRUSTACEANS",
  EGGS = "EGGS",
  FISH = "FISH",
  GLUTEN = "GLUTEN",
  LUPIN = "LUPIN",
  MILK = "MILK",
  MOLLUSCS = "MOLLUSCS",
  MUSTARD = "MUSTARD",
  NUTS = "NUTS",
  PEANUTS = "PEANUTS",
  SESAME = "SESAME",
  SOYBEANS = "SOYBEANS",
  SULPHITES = "SULPHITES",
  SULPHUR_DIOXIDE = "SULPHUR_DIOXIDE",
}

export enum BAEMINGO_PRODUCT {
  ACCOUNTING = "ACCOUNTING",
  APP = "APP",
  BANK = "BANK",
  BOOKINGS = "BOOKINGS",
  CASH_DRAWER = "CASH_DRAWER",
  CUSTOMER_DISPLAY = "CUSTOMER_DISPLAY",
  EPOS = "EPOS",
  GIFTCARD = "GIFTCARD",
  HANDHELD_ORDER = "HANDHELD_ORDER",
  HANDHELD_PAY = "HANDHELD_PAY",
  HANDHELD_PRO = "HANDHELD_PRO",
  INSIGHTS = "INSIGHTS",
  INSIGHTS_YEAR = "INSIGHTS_YEAR",
  INVENTORY = "INVENTORY",
  KDS = "KDS",
  KIT_BASIC = "KIT_BASIC",
  KIT_EXTENDED = "KIT_EXTENDED",
  LIGHT = "LIGHT",
  LOYALTY_PRO = "LOYALTY_PRO",
  QSR = "QSR",
  RECEIPT_PAPER = "RECEIPT_PAPER",
  RECEIPT_PRINTER = "RECEIPT_PRINTER",
  S1F2 = "S1F2",
  STAFF_LEDGER = "STAFF_LEDGER",
  SUPPORT_SUNRISE = "SUPPORT_SUNRISE",
  SUPPORT_SUNSET = "SUPPORT_SUNSET",
  TABLET = "TABLET",
  TABLET_STAND = "TABLET_STAND",
  TSR = "TSR",
  WAITER_AID = "WAITER_AID",
  WASTE = "WASTE",
}

export enum BILL_PAYMENT_TYPE {
  EVERYTHING = "EVERYTHING",
  OWN_ITEMS = "OWN_ITEMS",
  PICK_ITEMS = "PICK_ITEMS",
  SPLIT_EQUAL = "SPLIT_EQUAL",
}

export enum BookingLanguage {
  EN = "EN",
  ES = "ES",
  NO = "NO",
  SV = "SV",
}

export enum BookingSource {
  BOOKING = "BOOKING",
  CHOICE = "CHOICE",
}

export enum BookingStatus {
  ACCEPTED = "ACCEPTED",
  CANCELED = "CANCELED",
  DENIED = "DENIED",
  FINISHED = "FINISHED",
  INCOMING = "INCOMING",
  NO_SHOW = "NO_SHOW",
  STARTED = "STARTED",
}

export enum COMPETITION_STATUS {
  FINISHED = "FINISHED",
  ONGOING = "ONGOING",
  UPCOMING = "UPCOMING",
}

export enum COMPETITION_TYPE {
  SALES_AMOUNT = "SALES_AMOUNT",
  SALES_AVERAGE = "SALES_AVERAGE",
  SALES_COUNT = "SALES_COUNT",
  TIPS_AMOUNT = "TIPS_AMOUNT",
  TIPS_AVERAGE = "TIPS_AVERAGE",
  TIPS_COUNT = "TIPS_COUNT",
}

export enum CONTENT_STATUS {
  DISABLED = "DISABLED",
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}

export enum CONTENT_TYPE {
  HERO = "HERO",
  NEWSLETTER = "NEWSLETTER",
  SIDEBAR = "SIDEBAR",
  VENUE = "VENUE",
}

export enum CURRENCY {
  AED = "AED",
  DKK = "DKK",
  EUR = "EUR",
  GBP = "GBP",
  NOK = "NOK",
  SEK = "SEK",
  TRY = "TRY",
  USD = "USD",
}

export enum DAY_OF_WEEK {
  FRIDAY = "FRIDAY",
  MONDAY = "MONDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
  THURSDAY = "THURSDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
}

export enum DEVICE_OS {
  ANDROID = "ANDROID",
  IOS = "IOS",
}

export enum DISCOUNT_TYPE {
  FIXED = "FIXED",
  PERCENTAGE = "PERCENTAGE",
  PRICE = "PRICE",
}

export enum EPOS_SERVICE_TYPE {
  EAT_HERE = "EAT_HERE",
  TAKE_AWAY = "TAKE_AWAY",
}

export enum ExpenseOrderByInput {
  amount_ASC = "amount_ASC",
  amount_DESC = "amount_DESC",
  createdAt_ASC = "createdAt_ASC",
  createdAt_DESC = "createdAt_DESC",
  id_ASC = "id_ASC",
  id_DESC = "id_DESC",
  paymentType_ASC = "paymentType_ASC",
  paymentType_DESC = "paymentType_DESC",
}

export enum GENERATED_REPORT_TYPE {
  INVENTORY = "INVENTORY",
  PAYOUTS = "PAYOUTS",
  SALES = "SALES",
  STAFF = "STAFF",
}

export enum GIFTCARD_STATUS {
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  INACTIVE = "INACTIVE",
}

export enum HotelChargeTargetKind {
  PM_ACCOUNT = "PM_ACCOUNT",
  RESERVATION = "RESERVATION",
}

export enum HotelRoomChargeOutcome {
  CHARGED = "CHARGED",
  NOT_CHARGED = "NOT_CHARGED",
}

export enum INVOICE_TYPE {
  COMPANY = "COMPANY",
  PRIVATE = "PRIVATE",
}

export enum ITEM_SIZE_TYPE {
  LE_CROISSANT_CUP_SIZE = "LE_CROISSANT_CUP_SIZE",
  PIZZABAKEREN_DEFAULT_PIZZA = "PIZZABAKEREN_DEFAULT_PIZZA",
}

export enum IntegrationsCustomerType {
  COMPANY = "COMPANY",
  PRIVATE = "PRIVATE",
  UNKNOWN = "UNKNOWN",
}

export enum InvoiceTargetType {
  COMPANY = "COMPANY",
  PRIVATE = "PRIVATE",
}

export enum LICENSE_PROVIDER {
  AFP = "AFP",
  BAEMINGO = "BAEMINGO",
  STRIPE = "STRIPE",
}

export enum LICENSE_STATUS {
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
  PAUSED = "PAUSED",
  UNPAID = "UNPAID",
}

export enum LOGIN_METHOD {
  BANKID = "BANKID",
  EMAIL = "EMAIL",
  PHONE = "PHONE",
}

export enum LOG_LEVEL {
  ACTION = "ACTION",
  DEBUG = "DEBUG",
  ERROR = "ERROR",
  FATAL = "FATAL",
  INFO = "INFO",
  TIMER = "TIMER",
  WARN = "WARN",
}

export enum LOG_TYPE {
  CREATE = "CREATE",
  DELETE = "DELETE",
  PROMOTE = "PROMOTE",
  READ = "READ",
  REJECT = "REJECT",
  UPDATE = "UPDATE",
  UPLOAD = "UPLOAD",
}

export enum MEMBERSHIP_PERIOD {
  MONTH = "MONTH",
  WEEK = "WEEK",
  YEAR = "YEAR",
}

export enum MEMBERSHIP_SOURCE_TYPE {
  CARD_TRADEIN = "CARD_TRADEIN",
  DEFAULT = "DEFAULT",
  POINTS = "POINTS",
  PROMO_CODE = "PROMO_CODE",
  VENUE_MANAGER = "VENUE_MANAGER",
}

export enum MODIFICATION_GROUP_TYPE {
  MULTIPLE = "MULTIPLE",
  SINGLE = "SINGLE",
}

export enum NOTIFICATION_TARGET {
  APP = "APP",
  OM = "OM",
}

export enum OFFER_CONTEXT {
  APP = "APP",
  POS = "POS",
}

export enum OFFER_TYPE {
  BUNDLE = "BUNDLE",
  ITEM_DISCOUNT = "ITEM_DISCOUNT",
  ORDER_DISCOUNT = "ORDER_DISCOUNT",
  STAGED_BUNDLE = "STAGED_BUNDLE",
  STAGED_INDIVIDUAL = "STAGED_INDIVIDUAL",
  VISUAL = "VISUAL",
}

export enum ONBOARDING_EVENT_STEP {
  ADDED_CATEGORIES = "ADDED_CATEGORIES",
  ADDED_COURSE_TYPES = "ADDED_COURSE_TYPES",
  ADDED_PRODUCTS = "ADDED_PRODUCTS",
  CLAIMED_DEVICE = "CLAIMED_DEVICE",
  CREATED_FLOOR_PLAN = "CREATED_FLOOR_PLAN",
  CREATED_POS_LAYOUT = "CREATED_POS_LAYOUT",
  CREATED_STAFF = "CREATED_STAFF",
  CREATED_STATION = "CREATED_STATION",
  FILLED_IN_COMPANY_INFORMATION = "FILLED_IN_COMPANY_INFORMATION",
  FIRST_SALE = "FIRST_SALE",
}

export enum ORDER_ORIGIN {
  APP = "APP",
  EXPRESS = "EXPRESS",
  POS = "POS",
  THIRD_PARTY = "THIRD_PARTY",
}

export enum ORDER_STATUS {
  ACCEPTED = "ACCEPTED",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  DELIVERING = "DELIVERING",
  FINALIZING = "FINALIZING",
  PENDING = "PENDING",
  READY = "READY",
  REFUNDED = "REFUNDED",
  REJECTED = "REJECTED",
  SCHEDULED = "SCHEDULED",
}

export enum PAYMENT_STATUS {
  FAILED = "FAILED",
  PENDING = "PENDING",
  REFUNDED = "REFUNDED",
  SUCCESS = "SUCCESS",
}

export enum POINTS_SOURCE_TYPE {
  MANUAL_INPUT = "MANUAL_INPUT",
  PURCHASE = "PURCHASE",
  RECEIPT_SCAN = "RECEIPT_SCAN",
  VENUE_MANAGER = "VENUE_MANAGER",
}

export enum POS_DISCOUNT_SOURCE {
  MANAGER = "MANAGER",
  MEMBERSHIP = "MEMBERSHIP",
  TERMINAL = "TERMINAL",
}

export enum PREDEFINED_REASON_TYPE {
  CORRECTION = "CORRECTION",
  WASTE = "WASTE",
}

export enum PRODUCT_TYPE {
  BOOKINGS = "BOOKINGS",
  CUSTOMER_DISPLAY = "CUSTOMER_DISPLAY",
  GIFTCARD = "GIFTCARD",
  HANDHELD_ORDER = "HANDHELD_ORDER",
  HANDHELD_PAY = "HANDHELD_PAY",
  HANDHELD_PRO = "HANDHELD_PRO",
  INSIGHTS = "INSIGHTS",
  INSIGHTS_YEAR = "INSIGHTS_YEAR",
  KDS = "KDS",
  MC_PRINT_2 = "MC_PRINT_2",
  MC_PRINT_3 = "MC_PRINT_3",
  PHYSICAL_GIFTCARD = "PHYSICAL_GIFTCARD",
  POS_PRO = "POS_PRO",
  QSR = "QSR",
  S1F2 = "S1F2",
  SUPPORT_SUNRISE = "SUPPORT_SUNRISE",
  TSR = "TSR",
  V400M = "V400M",
  ZETTLE_TERMINAL = "ZETTLE_TERMINAL",
}

export enum REJECT_REASON {
  CLOSING_SOON = "CLOSING_SOON",
  DELIVERY_IS_NOT_AVAILABLE = "DELIVERY_IS_NOT_AVAILABLE",
  NO_ANSWER = "NO_ANSWER",
  OUT_OF_SUPPLIES = "OUT_OF_SUPPLIES",
  TOO_MANY_ORDERS = "TOO_MANY_ORDERS",
}

export enum RELEASE_TYPE {
  FEATURE = "FEATURE",
  RELEASE_NOTES = "RELEASE_NOTES",
}

export enum REPORTING_CHANNEL {
  APP = "APP",
  EXPRESS = "EXPRESS",
  POS = "POS",
  THIRD_PARTY = "THIRD_PARTY",
}

export enum REPORT_TYPE {
  Z = "Z",
}

export enum ROLE {
  CONTENT_ADMIN = "CONTENT_ADMIN",
  REGULAR = "REGULAR",
  SUPER_ADMIN = "SUPER_ADMIN",
}

export enum SEGMENT_PERIOD {
  DAY = "DAY",
  MONTH = "MONTH",
  WEEK = "WEEK",
}

export enum SERVICE_TYPE {
  BOOKING = "BOOKING",
  DELIVERY = "DELIVERY",
  EAT_HERE = "EAT_HERE",
  INSTANT_BUY = "INSTANT_BUY",
  LOCAL_DELIVERY = "LOCAL_DELIVERY",
  POS = "POS",
  SHIPPED = "SHIPPED",
  TABLE_SERVICE = "TABLE_SERVICE",
  TAKE_AWAY = "TAKE_AWAY",
}

export enum SOCIAL_MEDIA {
  FACEBOOK = "FACEBOOK",
  INSTAGRAM = "INSTAGRAM",
}

export enum SOURCE_TYPE {
  ORDER = "ORDER",
  ORDER_REFUND = "ORDER_REFUND",
}

export enum STAFF_PERMISSIONS {
  ADD_ITEM_TO_TABLE = "ADD_ITEM_TO_TABLE",
  ANALYTICS = "ANALYTICS",
  ASSUME_ROLE = "ASSUME_ROLE",
  CLOSE_DAY = "CLOSE_DAY",
  CREATE_CHEQUE = "CREATE_CHEQUE",
  CREATE_INVOICE_TARGET = "CREATE_INVOICE_TARGET",
  GIFT_CARDS = "GIFT_CARDS",
  HISTORY = "HISTORY",
  INVOICE_PURCHASE = "INVOICE_PURCHASE",
  LOG_OUT = "LOG_OUT",
  MAKE_PAYMENT = "MAKE_PAYMENT",
  MANUAL_DISCOUNT = "MANUAL_DISCOUNT",
  PRESET_DISCOUNT = "PRESET_DISCOUNT",
  REFUND = "REFUND",
  REPORTS = "REPORTS",
  SETTINGS = "SETTINGS",
  VOID_PAYMENT = "VOID_PAYMENT",
}

export enum STATION_TYPE {
  DISPLAY = "DISPLAY",
  PRINTER = "PRINTER",
}

export enum SUBSCRIPTION_PAYMENT_STATUS {
  OVERDUE = "OVERDUE",
  PAID = "PAID",
  UNKNOWN = "UNKNOWN",
  UNPAID = "UNPAID",
}

export enum SurfboardPaymentStatus {
  PAYMENT_CANCELLED = "PAYMENT_CANCELLED",
  PAYMENT_COMPLETED = "PAYMENT_COMPLETED",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  PAYMENT_INITIATED = "PAYMENT_INITIATED",
  PAYMENT_PROCESSED = "PAYMENT_PROCESSED",
  PAYMENT_PROCESSING = "PAYMENT_PROCESSING",
}

export enum TicketLayoutElementType {
  COVERAGE = "COVERAGE",
  DATE = "DATE",
  DELIVERY_LOCATION = "DELIVERY_LOCATION",
  DESIRED_TIME = "DESIRED_TIME",
  DEVICE = "DEVICE",
  DIVIDER = "DIVIDER",
  FLOORPLAN = "FLOORPLAN",
  MAIN_CONTENT = "MAIN_CONTENT",
  ORDER_COMMENT = "ORDER_COMMENT",
  PRINT_ID = "PRINT_ID",
  SERVICE_TYPE = "SERVICE_TYPE",
  SPACE = "SPACE",
  STAFF_NAME = "STAFF_NAME",
  STATION = "STATION",
  TICKET_MESSAGE = "TICKET_MESSAGE",
  TITLE = "TITLE",
}

export enum UserOrderByInput {
  activated_ASC = "activated_ASC",
  activated_DESC = "activated_DESC",
  blocked_ASC = "blocked_ASC",
  blocked_DESC = "blocked_DESC",
  createdAt_ASC = "createdAt_ASC",
  createdAt_DESC = "createdAt_DESC",
  deleted_ASC = "deleted_ASC",
  deleted_DESC = "deleted_DESC",
  email_ASC = "email_ASC",
  email_DESC = "email_DESC",
  facebookId_ASC = "facebookId_ASC",
  facebookId_DESC = "facebookId_DESC",
  id_ASC = "id_ASC",
  id_DESC = "id_DESC",
  image_ASC = "image_ASC",
  image_DESC = "image_DESC",
  language_ASC = "language_ASC",
  language_DESC = "language_DESC",
  lastLogin_ASC = "lastLogin_ASC",
  lastLogin_DESC = "lastLogin_DESC",
  meta_ASC = "meta_ASC",
  meta_DESC = "meta_DESC",
  name_ASC = "name_ASC",
  name_DESC = "name_DESC",
  ofLegalAge_ASC = "ofLegalAge_ASC",
  ofLegalAge_DESC = "ofLegalAge_DESC",
  password_ASC = "password_ASC",
  password_DESC = "password_DESC",
  personalNumber_ASC = "personalNumber_ASC",
  personalNumber_DESC = "personalNumber_DESC",
  phone_ASC = "phone_ASC",
  phone_DESC = "phone_DESC",
  referralCode_ASC = "referralCode_ASC",
  referralCode_DESC = "referralCode_DESC",
  role_ASC = "role_ASC",
  role_DESC = "role_DESC",
  shouldUpdatePassword_ASC = "shouldUpdatePassword_ASC",
  shouldUpdatePassword_DESC = "shouldUpdatePassword_DESC",
  updatedAt_ASC = "updatedAt_ASC",
  updatedAt_DESC = "updatedAt_DESC",
  username_ASC = "username_ASC",
  username_DESC = "username_DESC",
  venueLimited_ASC = "venueLimited_ASC",
  venueLimited_DESC = "venueLimited_DESC",
}

export enum VARIATION_CLASS {
  ALLERGENS = "ALLERGENS",
  ALTERNATE_INGREDIENTS = "ALTERNATE_INGREDIENTS",
  DEFAULT_INGREDIENTS = "DEFAULT_INGREDIENTS",
  EXTRA_INGREDIENTS = "EXTRA_INGREDIENTS",
  INGREDIENTS = "INGREDIENTS",
  SIZES = "SIZES",
}

export enum VARIATION_TYPE {
  MULTIPLE = "MULTIPLE",
  SINGLE = "SINGLE",
}

export interface AccessLevelCreateInput {
  id?: string ;
  name: string;
  permissions?: AccessLevelCreatepermissionsInput ;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutAccessLevelsInput;
}

export interface AccessLevelCreateManyWithoutCompanyInput {
  create?: AccessLevelCreateWithoutCompanyInput[] ;
  connect?: AccessLevelWhereUniqueInput[] ;
}

export interface AccessLevelCreateOneInput {
  create?: AccessLevelCreateInput ;
  connect?: AccessLevelWhereUniqueInput ;
}

export interface AccessLevelCreateWithoutCompanyInput {
  id?: string ;
  name: string;
  permissions?: AccessLevelCreatepermissionsInput ;
  deleted?: boolean ;
}

export interface AccessLevelCreatepermissionsInput {
  set?: STAFF_PERMISSIONS[] ;
}

export interface AccessLevelWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  company?: CompanyWhereInput ;
  AND?: AccessLevelWhereInput[] ;
  OR?: AccessLevelWhereInput[] ;
  NOT?: AccessLevelWhereInput[] ;
}

export interface AccessLevelWhereUniqueInput {
  id?: string ;
}

export interface ActionLogCreateOneWithoutLogInput {
  create?: ActionLogCreateWithoutLogInput ;
  connect?: ActionLogWhereUniqueInput ;
}

export interface ActionLogCreateWithoutLogInput {
  id?: string ;
  nodeId?: string ;
  type?: LOG_TYPE ;
}

export interface ActionLogWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  nodeId?: string ;
  nodeId_not?: string ;
  nodeId_in?: string[] ;
  nodeId_not_in?: string[] ;
  nodeId_lt?: string ;
  nodeId_lte?: string ;
  nodeId_gt?: string ;
  nodeId_gte?: string ;
  nodeId_contains?: string ;
  nodeId_not_contains?: string ;
  nodeId_starts_with?: string ;
  nodeId_not_starts_with?: string ;
  nodeId_ends_with?: string ;
  nodeId_not_ends_with?: string ;
  type?: LOG_TYPE ;
  type_not?: LOG_TYPE ;
  type_in?: LOG_TYPE[] ;
  type_not_in?: LOG_TYPE[] ;
  log?: LogWhereInput ;
  AND?: ActionLogWhereInput[] ;
  OR?: ActionLogWhereInput[] ;
  NOT?: ActionLogWhereInput[] ;
}

export interface ActionLogWhereUniqueInput {
  id?: string ;
}

export interface AddToScoreInput {
  sales?: SalesScoreInput ;
  tips?: TipScoreInput ;
}

export interface AdvancedSearchOrdersInput {
  venueIds?: string[] ;
  userIds?: string[] ;
  staffIds?: string[] ;
  tableIds?: string[] ;
  invoiceTargetIds?: string[] ;
  zoneIds?: string[] ;
  bookingIds?: string[] ;
  discountIds?: string[] ;
  discountSources?: string[] ;
  serviceTypes?: string[] ;
  origins?: ORDER_ORIGIN[] ;
  paymentMethods?: string[] ;
  easyIds?: string[] ;
  createdAt_gt?: any ;
  createdAt_lt?: any ;
  amount?: IntRangeInput ;
  discount?: IntRangeInput ;
  tip?: IntRangeInput ;
  hasDiscount?: boolean ;
  hasTip?: boolean ;
  includeTipInAmount?: boolean ;
  first?: number ;
  skip?: number ;
  includeTotalCount?: boolean ;
}

/**
 * One line on the invoice Klarna (or any other buy-now-pay-later method) sends
 * the shopper. Adyen rejects a BNPL payment link that has none.
 */
export interface AdyenPaymentLinkLineItemInput {
  id?: string ;
  description: string;
  quantity: number;
  amountIncludingTax: number;
  vatRate?: number ;
}

/**
 * One returned line on a partial refund of an open invoice payment.
 */
export interface AdyenRefundLineItemInput {
  id?: string ;
  description: string;
  quantity: number;
  amountIncludingTax: number;
  taxPercentage?: number ;
}

export interface AppMetadataCreateOneWithoutCompanyInput {
  create?: AppMetadataCreateWithoutCompanyInput ;
  connect?: AppMetadataWhereUniqueInput ;
}

export interface AppMetadataCreateWithoutCompanyInput {
  id?: string ;
  au1day?: number ;
  au7day?: number ;
  au30day?: number ;
}

export interface AppMetadataWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  au1day?: number ;
  au1day_not?: number ;
  au1day_in?: number[] ;
  au1day_not_in?: number[] ;
  au1day_lt?: number ;
  au1day_lte?: number ;
  au1day_gt?: number ;
  au1day_gte?: number ;
  au7day?: number ;
  au7day_not?: number ;
  au7day_in?: number[] ;
  au7day_not_in?: number[] ;
  au7day_lt?: number ;
  au7day_lte?: number ;
  au7day_gt?: number ;
  au7day_gte?: number ;
  au30day?: number ;
  au30day_not?: number ;
  au30day_in?: number[] ;
  au30day_not_in?: number[] ;
  au30day_lt?: number ;
  au30day_lte?: number ;
  au30day_gt?: number ;
  au30day_gte?: number ;
  AND?: AppMetadataWhereInput[] ;
  OR?: AppMetadataWhereInput[] ;
  NOT?: AppMetadataWhereInput[] ;
}

export interface AppMetadataWhereUniqueInput {
  id?: string ;
}

export interface AppliedMenuCreateManyWithoutMembershipLevelsInput {
  create?: AppliedMenuCreateWithoutMembershipLevelsInput[] ;
  connect?: AppliedMenuWhereUniqueInput[] ;
}

export interface AppliedMenuCreateManyWithoutMenuInput {
  create?: AppliedMenuCreateWithoutMenuInput[] ;
  connect?: AppliedMenuWhereUniqueInput[] ;
}

export interface AppliedMenuCreateManyWithoutVenueInput {
  create?: AppliedMenuCreateWithoutVenueInput[] ;
  connect?: AppliedMenuWhereUniqueInput[] ;
}

export interface AppliedMenuCreateWithoutMembershipLevelsInput {
  id?: string ;
  menu?: MenuCreateOneWithoutApplicationsInput ;
  serviceType: SERVICE_TYPE;
  venue?: VenueCreateOneWithoutMenusInput ;
}

export interface AppliedMenuCreateWithoutMenuInput {
  id?: string ;
  serviceType: SERVICE_TYPE;
  venue?: VenueCreateOneWithoutMenusInput ;
  membershipLevels?: MembershipLevelCreateManyWithoutMenusInput ;
}

export interface AppliedMenuCreateWithoutVenueInput {
  id?: string ;
  menu?: MenuCreateOneWithoutApplicationsInput ;
  serviceType: SERVICE_TYPE;
  membershipLevels?: MembershipLevelCreateManyWithoutMenusInput ;
}

export interface AppliedMenuWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  menu?: MenuWhereInput ;
  serviceType?: SERVICE_TYPE ;
  serviceType_not?: SERVICE_TYPE ;
  serviceType_in?: SERVICE_TYPE[] ;
  serviceType_not_in?: SERVICE_TYPE[] ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  venue?: VenueWhereInput ;
  membershipLevels_every?: MembershipLevelWhereInput ;
  membershipLevels_some?: MembershipLevelWhereInput ;
  membershipLevels_none?: MembershipLevelWhereInput ;
  AND?: AppliedMenuWhereInput[] ;
  OR?: AppliedMenuWhereInput[] ;
  NOT?: AppliedMenuWhereInput[] ;
}

export interface AppliedMenuWhereUniqueInput {
  id?: string ;
}

export interface AppliedVariationCreateManyWithoutGroupInput {
  create?: AppliedVariationCreateWithoutGroupInput[] ;
  connect?: AppliedVariationWhereUniqueInput[] ;
}

export interface AppliedVariationCreateManyWithoutItemInput {
  create?: AppliedVariationCreateWithoutItemInput[] ;
  connect?: AppliedVariationWhereUniqueInput[] ;
}

export interface AppliedVariationCreateManyWithoutVariationInput {
  create?: AppliedVariationCreateWithoutVariationInput[] ;
  connect?: AppliedVariationWhereUniqueInput[] ;
}

export interface AppliedVariationCreateWithoutGroupInput {
  default?: boolean ;
  id?: string ;
  item?: ItemCreateOneWithoutAppliedVariationsInput ;
  variation?: VariationCreateOneWithoutAppliedVariationsInput ;
  required?: boolean ;
  expandedByDefault?: boolean ;
}

export interface AppliedVariationCreateWithoutItemInput {
  default?: boolean ;
  id?: string ;
  variation?: VariationCreateOneWithoutAppliedVariationsInput ;
  group?: VariationGroupCreateOneWithoutApplicationsInput ;
  required?: boolean ;
  expandedByDefault?: boolean ;
}

export interface AppliedVariationCreateWithoutVariationInput {
  default?: boolean ;
  id?: string ;
  item?: ItemCreateOneWithoutAppliedVariationsInput ;
  group?: VariationGroupCreateOneWithoutApplicationsInput ;
  required?: boolean ;
  expandedByDefault?: boolean ;
}

export interface AppliedVariationWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  default?: boolean ;
  default_not?: boolean ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  item?: ItemWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  variation?: VariationWhereInput ;
  group?: VariationGroupWhereInput ;
  required?: boolean ;
  required_not?: boolean ;
  expandedByDefault?: boolean ;
  expandedByDefault_not?: boolean ;
  AND?: AppliedVariationWhereInput[] ;
  OR?: AppliedVariationWhereInput[] ;
  NOT?: AppliedVariationWhereInput[] ;
}

export interface AppliedVariationWhereUniqueInput {
  id?: string ;
}

export interface ArticleMapCreateManyWithoutItemInput {
  create?: ArticleMapCreateWithoutItemInput[] ;
  connect?: ArticleMapWhereUniqueInput[] ;
}

export interface ArticleMapCreateOneWithoutSizeInput {
  create?: ArticleMapCreateWithoutSizeInput ;
  connect?: ArticleMapWhereUniqueInput ;
}

export interface ArticleMapCreateOneWithoutVariationInput {
  create?: ArticleMapCreateWithoutVariationInput ;
  connect?: ArticleMapWhereUniqueInput ;
}

export interface ArticleMapCreateWithoutItemInput {
  id?: string ;
  size?: ItemSizeCreateOneWithoutArticleMapInput ;
  variation?: VariationCreateOneWithoutArticleMapInput ;
  externalId: string;
}

export interface ArticleMapCreateWithoutSizeInput {
  id?: string ;
  item: ItemCreateOneWithoutArticleMapsInput;
  variation?: VariationCreateOneWithoutArticleMapInput ;
  externalId: string;
}

export interface ArticleMapCreateWithoutVariationInput {
  id?: string ;
  item: ItemCreateOneWithoutArticleMapsInput;
  size?: ItemSizeCreateOneWithoutArticleMapInput ;
  externalId: string;
}

export interface ArticleMapWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  item?: ItemWhereInput ;
  size?: ItemSizeWhereInput ;
  variation?: VariationWhereInput ;
  externalId?: string ;
  externalId_not?: string ;
  externalId_in?: string[] ;
  externalId_not_in?: string[] ;
  externalId_lt?: string ;
  externalId_lte?: string ;
  externalId_gt?: string ;
  externalId_gte?: string ;
  externalId_contains?: string ;
  externalId_not_contains?: string ;
  externalId_starts_with?: string ;
  externalId_not_starts_with?: string ;
  externalId_ends_with?: string ;
  externalId_not_ends_with?: string ;
  AND?: ArticleMapWhereInput[] ;
  OR?: ArticleMapWhereInput[] ;
  NOT?: ArticleMapWhereInput[] ;
}

export interface ArticleMapWhereUniqueInput {
  id?: string ;
}

export interface AvailabilityCreateManyWithoutOfferTokenInput {
  create?: AvailabilityCreateWithoutOfferTokenInput[] ;
  connect?: AvailabilityWhereUniqueInput[] ;
}

export interface AvailabilityCreateManyWithoutVenueInput {
  create?: AvailabilityCreateWithoutVenueInput[] ;
  connect?: AvailabilityWhereUniqueInput[] ;
}

export interface AvailabilityCreateWithoutOfferTokenInput {
  dayOfWeek?: DAY_OF_WEEK ;
  id?: string ;
  timeRange?: TimeRangeCreateOneWithoutAvailabilitiesInput ;
  venue?: VenueCreateOneWithoutAvailabilitiesInput ;
}

export interface AvailabilityCreateWithoutVenueInput {
  dayOfWeek?: DAY_OF_WEEK ;
  id?: string ;
  timeRange?: TimeRangeCreateOneWithoutAvailabilitiesInput ;
  offerToken?: OfferTokenCreateOneWithoutAvailabilitiesInput ;
}

export interface AvailabilityWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  dayOfWeek?: DAY_OF_WEEK ;
  dayOfWeek_not?: DAY_OF_WEEK ;
  dayOfWeek_in?: DAY_OF_WEEK[] ;
  dayOfWeek_not_in?: DAY_OF_WEEK[] ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  timeRange?: TimeRangeWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  venue?: VenueWhereInput ;
  offerToken?: OfferTokenWhereInput ;
  AND?: AvailabilityWhereInput[] ;
  OR?: AvailabilityWhereInput[] ;
  NOT?: AvailabilityWhereInput[] ;
}

export interface AvailabilityWhereUniqueInput {
  id?: string ;
}

export interface CampaignCreateManyWithoutDiscountsInput {
  create?: CampaignCreateWithoutDiscountsInput[] ;
  connect?: CampaignWhereUniqueInput[] ;
}

export interface CampaignCreateWithoutDiscountsInput {
  end: any;
  id?: string ;
  name: string;
  start: any;
  description: string;
}

export interface CampaignWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  discounts_every?: DiscountWhereInput ;
  discounts_some?: DiscountWhereInput ;
  discounts_none?: DiscountWhereInput ;
  end?: any ;
  end_not?: any ;
  end_in?: any[] ;
  end_not_in?: any[] ;
  end_lt?: any ;
  end_lte?: any ;
  end_gt?: any ;
  end_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  start?: any ;
  start_not?: any ;
  start_in?: any[] ;
  start_not_in?: any[] ;
  start_lt?: any ;
  start_lte?: any ;
  start_gt?: any ;
  start_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  description?: string ;
  description_not?: string ;
  description_in?: string[] ;
  description_not_in?: string[] ;
  description_lt?: string ;
  description_lte?: string ;
  description_gt?: string ;
  description_gte?: string ;
  description_contains?: string ;
  description_not_contains?: string ;
  description_starts_with?: string ;
  description_not_starts_with?: string ;
  description_ends_with?: string ;
  description_not_ends_with?: string ;
  AND?: CampaignWhereInput[] ;
  OR?: CampaignWhereInput[] ;
  NOT?: CampaignWhereInput[] ;
}

export interface CampaignWhereUniqueInput {
  id?: string ;
}

export interface CardDesignCreateManyWithoutCompanyInput {
  create?: CardDesignCreateWithoutCompanyInput[] ;
  connect?: CardDesignWhereUniqueInput[] ;
}

export interface CardDesignCreateOneWithoutMembershipsInput {
  create?: CardDesignCreateWithoutMembershipsInput ;
  connect?: CardDesignWhereUniqueInput ;
}

export interface CardDesignCreateWithoutCompanyInput {
  id?: string ;
  slug: string;
  memberships?: MembershipLevelCreateManyWithoutDesignInput ;
}

export interface CardDesignCreateWithoutMembershipsInput {
  id?: string ;
  slug: string;
  company: CompanyCreateOneWithoutCardDesignsInput;
}

export interface CardDesignWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  slug?: string ;
  slug_not?: string ;
  slug_in?: string[] ;
  slug_not_in?: string[] ;
  slug_lt?: string ;
  slug_lte?: string ;
  slug_gt?: string ;
  slug_gte?: string ;
  slug_contains?: string ;
  slug_not_contains?: string ;
  slug_starts_with?: string ;
  slug_not_starts_with?: string ;
  slug_ends_with?: string ;
  slug_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  memberships_every?: MembershipLevelWhereInput ;
  memberships_some?: MembershipLevelWhereInput ;
  memberships_none?: MembershipLevelWhereInput ;
  AND?: CardDesignWhereInput[] ;
  OR?: CardDesignWhereInput[] ;
  NOT?: CardDesignWhereInput[] ;
}

export interface CardDesignWhereUniqueInput {
  id?: string ;
}

export interface CardDetailsInput {
  cardType?: string ;
  cardPaymentEntryMode?: string ;
  tsi?: string ;
  tvr?: string ;
  aid?: string ;
  maskedPan?: string ;
}

export interface CategoryCreateManyWithoutCompanyInput {
  create?: CategoryCreateWithoutCompanyInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
}

export interface CategoryCreateManyWithoutCourseTypeInput {
  create?: CategoryCreateWithoutCourseTypeInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
}

export interface CategoryCreateManyWithoutExpressPagesInput {
  create?: CategoryCreateWithoutExpressPagesInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
}

export interface CategoryCreateManyWithoutImageInput {
  create?: CategoryCreateWithoutImageInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
}

export interface CategoryCreateManyWithoutItemsInput {
  create?: CategoryCreateWithoutItemsInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
}

export interface CategoryCreateManyWithoutOffersInput {
  create?: CategoryCreateWithoutOffersInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
}

export interface CategoryCreateManyWithoutStationsInput {
  create?: CategoryCreateWithoutStationsInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
}

export interface CategoryCreateOneWithoutDescriptionLangInput {
  create?: CategoryCreateWithoutDescriptionLangInput ;
  connect?: CategoryWhereUniqueInput ;
}

export interface CategoryCreateOneWithoutEntriesInput {
  create?: CategoryCreateWithoutEntriesInput ;
  connect?: CategoryWhereUniqueInput ;
}

export interface CategoryCreateOneWithoutItemGroupsInput {
  create?: CategoryCreateWithoutItemGroupsInput ;
  connect?: CategoryWhereUniqueInput ;
}

export interface CategoryCreateOneWithoutNameLangInput {
  create?: CategoryCreateWithoutNameLangInput ;
  connect?: CategoryWhereUniqueInput ;
}

export interface CategoryCreateWithoutCompanyInput {
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutCourseTypeInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutDescriptionLangInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutEntriesInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutExpressPagesInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutImageInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutItemGroupsInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutItemsInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutNameLangInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutOffersInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutStationsInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreatetagsInput {
  set?: string[] ;
}

export interface CategoryWhereInput {
  company?: CompanyWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  description?: string ;
  description_not?: string ;
  description_in?: string[] ;
  description_not_in?: string[] ;
  description_lt?: string ;
  description_lte?: string ;
  description_gt?: string ;
  description_gte?: string ;
  description_contains?: string ;
  description_not_contains?: string ;
  description_starts_with?: string ;
  description_not_starts_with?: string ;
  description_ends_with?: string ;
  description_not_ends_with?: string ;
  descriptionLang?: TranslatedStringWhereInput ;
  entries_every?: MenuEntryWhereInput ;
  entries_some?: MenuEntryWhereInput ;
  entries_none?: MenuEntryWhereInput ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  image?: ImageWhereInput ;
  img?: string ;
  img_not?: string ;
  img_in?: string[] ;
  img_not_in?: string[] ;
  img_lt?: string ;
  img_lte?: string ;
  img_gt?: string ;
  img_gte?: string ;
  img_contains?: string ;
  img_not_contains?: string ;
  img_starts_with?: string ;
  img_not_starts_with?: string ;
  img_ends_with?: string ;
  img_not_ends_with?: string ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  color?: string ;
  color_not?: string ;
  color_in?: string[] ;
  color_not_in?: string[] ;
  color_lt?: string ;
  color_lte?: string ;
  color_gt?: string ;
  color_gte?: string ;
  color_contains?: string ;
  color_not_contains?: string ;
  color_starts_with?: string ;
  color_not_starts_with?: string ;
  color_ends_with?: string ;
  color_not_ends_with?: string ;
  nameLang?: TranslatedStringWhereInput ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  itemGroups_every?: ItemGroupWhereInput ;
  itemGroups_some?: ItemGroupWhereInput ;
  itemGroups_none?: ItemGroupWhereInput ;
  stations_every?: StationWhereInput ;
  stations_some?: StationWhereInput ;
  stations_none?: StationWhereInput ;
  expressPages_every?: ExpressPageWhereInput ;
  expressPages_some?: ExpressPageWhereInput ;
  expressPages_none?: ExpressPageWhereInput ;
  parentId?: string ;
  parentId_not?: string ;
  parentId_in?: string[] ;
  parentId_not_in?: string[] ;
  parentId_lt?: string ;
  parentId_lte?: string ;
  parentId_gt?: string ;
  parentId_gte?: string ;
  parentId_contains?: string ;
  parentId_not_contains?: string ;
  parentId_starts_with?: string ;
  parentId_not_starts_with?: string ;
  parentId_ends_with?: string ;
  parentId_not_ends_with?: string ;
  offers_every?: OfferWhereInput ;
  offers_some?: OfferWhereInput ;
  offers_none?: OfferWhereInput ;
  vatRate?: number ;
  vatRate_not?: number ;
  vatRate_in?: number[] ;
  vatRate_not_in?: number[] ;
  vatRate_lt?: number ;
  vatRate_lte?: number ;
  vatRate_gt?: number ;
  vatRate_gte?: number ;
  courseType?: CourseTypeWhereInput ;
  hideInCustomerOrderingFlows?: boolean ;
  hideInCustomerOrderingFlows_not?: boolean ;
  AND?: CategoryWhereInput[] ;
  OR?: CategoryWhereInput[] ;
  NOT?: CategoryWhereInput[] ;
}

export interface CategoryWhereUniqueInput {
  id?: string ;
}

export interface CompanyCreateManyWithoutReferralOfferInput {
  create?: CompanyCreateWithoutReferralOfferInput[] ;
  connect?: CompanyWhereUniqueInput[] ;
}

export interface CompanyCreateManyWithoutReferrerOfferInput {
  create?: CompanyCreateWithoutReferrerOfferInput[] ;
  connect?: CompanyWhereUniqueInput[] ;
}

export interface CompanyCreateOneWithoutAccessLevelsInput {
  create?: CompanyCreateWithoutAccessLevelsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutCardDesignsInput {
  create?: CompanyCreateWithoutCardDesignsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutCategoriesInput {
  create?: CompanyCreateWithoutCategoriesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutContentInput {
  create?: CompanyCreateWithoutContentInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutCourseTypesInput {
  create?: CompanyCreateWithoutCourseTypesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutDeliveryRatesInput {
  create?: CompanyCreateWithoutDeliveryRatesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutDiscountsInput {
  create?: CompanyCreateWithoutDiscountsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutExpensesInput {
  create?: CompanyCreateWithoutExpensesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutExpressPagesInput {
  create?: CompanyCreateWithoutExpressPagesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutFeedInput {
  create?: CompanyCreateWithoutFeedInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutFloorPlansInput {
  create?: CompanyCreateWithoutFloorPlansInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutImagesInput {
  create?: CompanyCreateWithoutImagesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutInvoiceTargetsInput {
  create?: CompanyCreateWithoutInvoiceTargetsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutItemSizesInput {
  create?: CompanyCreateWithoutItemSizesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutItemsInput {
  create?: CompanyCreateWithoutItemsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutLayoutsInput {
  create?: CompanyCreateWithoutLayoutsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutMembershipTradeinsInput {
  create?: CompanyCreateWithoutMembershipTradeinsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutMembershipsInput {
  create?: CompanyCreateWithoutMembershipsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutMenusInput {
  create?: CompanyCreateWithoutMenusInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutOfferYieldEventsInput {
  create?: CompanyCreateWithoutOfferYieldEventsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutOffersInput {
  create?: CompanyCreateWithoutOffersInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutPagesInput {
  create?: CompanyCreateWithoutPagesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutPaymentMethodsInput {
  create?: CompanyCreateWithoutPaymentMethodsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutPosCategoriesInput {
  create?: CompanyCreateWithoutPosCategoriesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutPosDevicesInput {
  create?: CompanyCreateWithoutPosDevicesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutPredefinedMessagesInput {
  create?: CompanyCreateWithoutPredefinedMessagesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutPromocodesInput {
  create?: CompanyCreateWithoutPromocodesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutReceiptTemplateInput {
  create?: CompanyCreateWithoutReceiptTemplateInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutReferralBodyInput {
  create?: CompanyCreateWithoutReferralBodyInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutReferralShareMessageInput {
  create?: CompanyCreateWithoutReferralShareMessageInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutReferralTitleInput {
  create?: CompanyCreateWithoutReferralTitleInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutSegmentsInput {
  create?: CompanyCreateWithoutSegmentsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutSocialMediaFeedInput {
  create?: CompanyCreateWithoutSocialMediaFeedInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutStaffsInput {
  create?: CompanyCreateWithoutStaffsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutStampCardsInput {
  create?: CompanyCreateWithoutStampCardsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutStationsInput {
  create?: CompanyCreateWithoutStationsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutUpsellsInput {
  create?: CompanyCreateWithoutUpsellsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutUsersInput {
  create?: CompanyCreateWithoutUsersInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutVariationGroupsInput {
  create?: CompanyCreateWithoutVariationGroupsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutVariationsInput {
  create?: CompanyCreateWithoutVariationsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutVenuesInput {
  create?: CompanyCreateWithoutVenuesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutZonesInput {
  create?: CompanyCreateWithoutZonesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateWithoutAccessLevelsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutCardDesignsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutCategoriesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutContentInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutCourseTypesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutDeliveryRatesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutDiscountsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutExpensesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutExpressPagesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutFeedInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutFloorPlansInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutImagesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutInvoiceTargetsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutItemSizesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutItemsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutLayoutsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutMembershipTradeinsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutMembershipsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutMenusInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutOfferYieldEventsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutOffersInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutPagesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutPaymentMethodsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutPosCategoriesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutPosDevicesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutPredefinedMessagesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutPromocodesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutReceiptTemplateInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutReferralBodyInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutReferralOfferInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutReferralShareMessageInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutReferralTitleInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutReferrerOfferInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutSegmentsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutSocialMediaFeedInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutStaffsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutStampCardsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutStationsInput {
  id?: string ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutUpsellsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutUsersInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutVariationGroupsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutVariationsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutVenuesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutZonesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreatecurrenciesInput {
  set?: CURRENCY[] ;
}

export interface CompanyCreatelanguagesInput {
  set?: string[] ;
}

export interface CompanyCreateloginMethodsInput {
  set?: LOGIN_METHOD[] ;
}

export interface CompanyCreatevisibleVMCategoriesInput {
  set?: string[] ;
}

export interface CompanyWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  stations_every?: StationWhereInput ;
  stations_some?: StationWhereInput ;
  stations_none?: StationWhereInput ;
  categories_every?: CategoryWhereInput ;
  categories_some?: CategoryWhereInput ;
  categories_none?: CategoryWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  metadata?: AppMetadataWhereInput ;
  discounts_every?: DiscountWhereInput ;
  discounts_some?: DiscountWhereInput ;
  discounts_none?: DiscountWhereInput ;
  memberships_every?: MembershipLevelWhereInput ;
  memberships_some?: MembershipLevelWhereInput ;
  memberships_none?: MembershipLevelWhereInput ;
  useUntranslatedFields?: boolean ;
  useUntranslatedFields_not?: boolean ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  itemSizes_every?: ItemSizeWhereInput ;
  itemSizes_some?: ItemSizeWhereInput ;
  itemSizes_none?: ItemSizeWhereInput ;
  defaultCurrency?: CURRENCY ;
  defaultCurrency_not?: CURRENCY ;
  defaultCurrency_in?: CURRENCY[] ;
  defaultCurrency_not_in?: CURRENCY[] ;
  defaultLanguage?: string ;
  defaultLanguage_not?: string ;
  defaultLanguage_in?: string[] ;
  defaultLanguage_not_in?: string[] ;
  defaultLanguage_lt?: string ;
  defaultLanguage_lte?: string ;
  defaultLanguage_gt?: string ;
  defaultLanguage_gte?: string ;
  defaultLanguage_contains?: string ;
  defaultLanguage_not_contains?: string ;
  defaultLanguage_starts_with?: string ;
  defaultLanguage_not_starts_with?: string ;
  defaultLanguage_ends_with?: string ;
  defaultLanguage_not_ends_with?: string ;
  defaultCountryCode?: string ;
  defaultCountryCode_not?: string ;
  defaultCountryCode_in?: string[] ;
  defaultCountryCode_not_in?: string[] ;
  defaultCountryCode_lt?: string ;
  defaultCountryCode_lte?: string ;
  defaultCountryCode_gt?: string ;
  defaultCountryCode_gte?: string ;
  defaultCountryCode_contains?: string ;
  defaultCountryCode_not_contains?: string ;
  defaultCountryCode_starts_with?: string ;
  defaultCountryCode_not_starts_with?: string ;
  defaultCountryCode_ends_with?: string ;
  defaultCountryCode_not_ends_with?: string ;
  menus_every?: MenuWhereInput ;
  menus_some?: MenuWhereInput ;
  menus_none?: MenuWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  manualEndOfDay?: boolean ;
  manualEndOfDay_not?: boolean ;
  paymentMethods_every?: PaymentMethodWhereInput ;
  paymentMethods_some?: PaymentMethodWhereInput ;
  paymentMethods_none?: PaymentMethodWhereInput ;
  disableStackedDiscounts?: boolean ;
  disableStackedDiscounts_not?: boolean ;
  createdByCustomer?: boolean ;
  createdByCustomer_not?: boolean ;
  cardDesigns_every?: CardDesignWhereInput ;
  cardDesigns_some?: CardDesignWhereInput ;
  cardDesigns_none?: CardDesignWhereInput ;
  promocodes_every?: PromoCodeWhereInput ;
  promocodes_some?: PromoCodeWhereInput ;
  promocodes_none?: PromoCodeWhereInput ;
  deliveryRates_every?: DeliveryRateWhereInput ;
  deliveryRates_some?: DeliveryRateWhereInput ;
  deliveryRates_none?: DeliveryRateWhereInput ;
  offerYieldEvents_every?: OfferYieldEventWhereInput ;
  offerYieldEvents_some?: OfferYieldEventWhereInput ;
  offerYieldEvents_none?: OfferYieldEventWhereInput ;
  referralsEnabled?: boolean ;
  referralsEnabled_not?: boolean ;
  referralShareMessage?: TranslatedStringWhereInput ;
  referralOffer?: OfferWhereInput ;
  referrerOffer?: OfferWhereInput ;
  referralTitle?: TranslatedStringWhereInput ;
  referralBody?: TranslatedStringWhereInput ;
  hasCashback?: boolean ;
  hasCashback_not?: boolean ;
  active?: boolean ;
  active_not?: boolean ;
  images_every?: ImageWhereInput ;
  images_some?: ImageWhereInput ;
  images_none?: ImageWhereInput ;
  posDevices_every?: POSDeviceWhereInput ;
  posDevices_some?: POSDeviceWhereInput ;
  posDevices_none?: POSDeviceWhereInput ;
  supportEmail?: string ;
  supportEmail_not?: string ;
  supportEmail_in?: string[] ;
  supportEmail_not_in?: string[] ;
  supportEmail_lt?: string ;
  supportEmail_lte?: string ;
  supportEmail_gt?: string ;
  supportEmail_gte?: string ;
  supportEmail_contains?: string ;
  supportEmail_not_contains?: string ;
  supportEmail_starts_with?: string ;
  supportEmail_not_starts_with?: string ;
  supportEmail_ends_with?: string ;
  supportEmail_not_ends_with?: string ;
  requiresEmail?: string ;
  requiresEmail_not?: string ;
  requiresEmail_in?: string[] ;
  requiresEmail_not_in?: string[] ;
  requiresEmail_lt?: string ;
  requiresEmail_lte?: string ;
  requiresEmail_gt?: string ;
  requiresEmail_gte?: string ;
  requiresEmail_contains?: string ;
  requiresEmail_not_contains?: string ;
  requiresEmail_starts_with?: string ;
  requiresEmail_not_starts_with?: string ;
  requiresEmail_ends_with?: string ;
  requiresEmail_not_ends_with?: string ;
  feed_every?: SocialMediaFeedWhereInput ;
  feed_some?: SocialMediaFeedWhereInput ;
  feed_none?: SocialMediaFeedWhereInput ;
  socialMediaFeed_every?: SocialMediaFeedWhereInput ;
  socialMediaFeed_some?: SocialMediaFeedWhereInput ;
  socialMediaFeed_none?: SocialMediaFeedWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  variations_every?: VariationWhereInput ;
  variations_some?: VariationWhereInput ;
  variations_none?: VariationWhereInput ;
  variationGroups_every?: VariationGroupWhereInput ;
  variationGroups_some?: VariationGroupWhereInput ;
  variationGroups_none?: VariationGroupWhereInput ;
  venues_every?: VenueWhereInput ;
  venues_some?: VenueWhereInput ;
  venues_none?: VenueWhereInput ;
  offers_every?: OfferWhereInput ;
  offers_some?: OfferWhereInput ;
  offers_none?: OfferWhereInput ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  stampCards_every?: StampCardWhereInput ;
  stampCards_some?: StampCardWhereInput ;
  stampCards_none?: StampCardWhereInput ;
  legacySegmentation?: boolean ;
  legacySegmentation_not?: boolean ;
  segments_every?: UserSegmentWhereInput ;
  segments_some?: UserSegmentWhereInput ;
  segments_none?: UserSegmentWhereInput ;
  code?: string ;
  code_not?: string ;
  code_in?: string[] ;
  code_not_in?: string[] ;
  code_lt?: string ;
  code_lte?: string ;
  code_gt?: string ;
  code_gte?: string ;
  code_contains?: string ;
  code_not_contains?: string ;
  code_starts_with?: string ;
  code_not_starts_with?: string ;
  code_ends_with?: string ;
  code_not_ends_with?: string ;
  content_every?: ContentWhereInput ;
  content_some?: ContentWhereInput ;
  content_none?: ContentWhereInput ;
  hasMembershipCards?: boolean ;
  hasMembershipCards_not?: boolean ;
  membershipPointsPercentage?: number ;
  membershipPointsPercentage_not?: number ;
  membershipPointsPercentage_in?: number[] ;
  membershipPointsPercentage_not_in?: number[] ;
  membershipPointsPercentage_lt?: number ;
  membershipPointsPercentage_lte?: number ;
  membershipPointsPercentage_gt?: number ;
  membershipPointsPercentage_gte?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodType_not?: MEMBERSHIP_PERIOD ;
  evaluationPeriodType_in?: MEMBERSHIP_PERIOD[] ;
  evaluationPeriodType_not_in?: MEMBERSHIP_PERIOD[] ;
  evaluationPeriodValue?: number ;
  evaluationPeriodValue_not?: number ;
  evaluationPeriodValue_in?: number[] ;
  evaluationPeriodValue_not_in?: number[] ;
  evaluationPeriodValue_lt?: number ;
  evaluationPeriodValue_lte?: number ;
  evaluationPeriodValue_gt?: number ;
  evaluationPeriodValue_gte?: number ;
  evaluationEndMonth?: number ;
  evaluationEndMonth_not?: number ;
  evaluationEndMonth_in?: number[] ;
  evaluationEndMonth_not_in?: number[] ;
  evaluationEndMonth_lt?: number ;
  evaluationEndMonth_lte?: number ;
  evaluationEndMonth_gt?: number ;
  evaluationEndMonth_gte?: number ;
  integrations_every?: IntegrationWhereInput ;
  integrations_some?: IntegrationWhereInput ;
  integrations_none?: IntegrationWhereInput ;
  terminals_every?: PosTerminalWhereInput ;
  terminals_some?: PosTerminalWhereInput ;
  terminals_none?: PosTerminalWhereInput ;
  membershipTradeins_every?: MembershipTradeinWhereInput ;
  membershipTradeins_some?: MembershipTradeinWhereInput ;
  membershipTradeins_none?: MembershipTradeinWhereInput ;
  hasPOS?: boolean ;
  hasPOS_not?: boolean ;
  hasPoints?: boolean ;
  hasPoints_not?: boolean ;
  hasTables?: boolean ;
  hasTables_not?: boolean ;
  hasAppOrders?: boolean ;
  hasAppOrders_not?: boolean ;
  hasKDS?: boolean ;
  hasKDS_not?: boolean ;
  hasCDS?: boolean ;
  hasCDS_not?: boolean ;
  hasExpress?: boolean ;
  hasExpress_not?: boolean ;
  hasInventory?: boolean ;
  hasInventory_not?: boolean ;
  brandPrimaryColor?: string ;
  brandPrimaryColor_not?: string ;
  brandPrimaryColor_in?: string[] ;
  brandPrimaryColor_not_in?: string[] ;
  brandPrimaryColor_lt?: string ;
  brandPrimaryColor_lte?: string ;
  brandPrimaryColor_gt?: string ;
  brandPrimaryColor_gte?: string ;
  brandPrimaryColor_contains?: string ;
  brandPrimaryColor_not_contains?: string ;
  brandPrimaryColor_starts_with?: string ;
  brandPrimaryColor_not_starts_with?: string ;
  brandPrimaryColor_ends_with?: string ;
  brandPrimaryColor_not_ends_with?: string ;
  brandSecondaryColor?: string ;
  brandSecondaryColor_not?: string ;
  brandSecondaryColor_in?: string[] ;
  brandSecondaryColor_not_in?: string[] ;
  brandSecondaryColor_lt?: string ;
  brandSecondaryColor_lte?: string ;
  brandSecondaryColor_gt?: string ;
  brandSecondaryColor_gte?: string ;
  brandSecondaryColor_contains?: string ;
  brandSecondaryColor_not_contains?: string ;
  brandSecondaryColor_starts_with?: string ;
  brandSecondaryColor_not_starts_with?: string ;
  brandSecondaryColor_ends_with?: string ;
  brandSecondaryColor_not_ends_with?: string ;
  extended?: boolean ;
  extended_not?: boolean ;
  serviceFee?: number ;
  serviceFee_not?: number ;
  serviceFee_in?: number[] ;
  serviceFee_not_in?: number[] ;
  serviceFee_lt?: number ;
  serviceFee_lte?: number ;
  serviceFee_gt?: number ;
  serviceFee_gte?: number ;
  timezone?: string ;
  timezone_not?: string ;
  timezone_in?: string[] ;
  timezone_not_in?: string[] ;
  timezone_lt?: string ;
  timezone_lte?: string ;
  timezone_gt?: string ;
  timezone_gte?: string ;
  timezone_contains?: string ;
  timezone_not_contains?: string ;
  timezone_starts_with?: string ;
  timezone_not_starts_with?: string ;
  timezone_ends_with?: string ;
  timezone_not_ends_with?: string ;
  invoiceTargets_every?: InvoiceTargetWhereInput ;
  invoiceTargets_some?: InvoiceTargetWhereInput ;
  invoiceTargets_none?: InvoiceTargetWhereInput ;
  layouts_every?: LayoutWhereInput ;
  layouts_some?: LayoutWhereInput ;
  layouts_none?: LayoutWhereInput ;
  pages_every?: PageWhereInput ;
  pages_some?: PageWhereInput ;
  pages_none?: PageWhereInput ;
  posCategories_every?: PosCategoryWhereInput ;
  posCategories_some?: PosCategoryWhereInput ;
  posCategories_none?: PosCategoryWhereInput ;
  receiptTemplate_every?: ReceiptTemplateWhereInput ;
  receiptTemplate_some?: ReceiptTemplateWhereInput ;
  receiptTemplate_none?: ReceiptTemplateWhereInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  defaultOrderStatus_not?: ORDER_STATUS ;
  defaultOrderStatus_in?: ORDER_STATUS[] ;
  defaultOrderStatus_not_in?: ORDER_STATUS[] ;
  accessLevels_every?: AccessLevelWhereInput ;
  accessLevels_some?: AccessLevelWhereInput ;
  accessLevels_none?: AccessLevelWhereInput ;
  staffs_every?: StaffWhereInput ;
  staffs_some?: StaffWhereInput ;
  staffs_none?: StaffWhereInput ;
  upsells_every?: UpsellWhereInput ;
  upsells_some?: UpsellWhereInput ;
  upsells_none?: UpsellWhereInput ;
  expressPages_every?: ExpressPageWhereInput ;
  expressPages_some?: ExpressPageWhereInput ;
  expressPages_none?: ExpressPageWhereInput ;
  zones_every?: ZoneWhereInput ;
  zones_some?: ZoneWhereInput ;
  zones_none?: ZoneWhereInput ;
  courseTypes_every?: CourseTypeWhereInput ;
  courseTypes_some?: CourseTypeWhereInput ;
  courseTypes_none?: CourseTypeWhereInput ;
  floorPlans_every?: FloorPlanWhereInput ;
  floorPlans_some?: FloorPlanWhereInput ;
  floorPlans_none?: FloorPlanWhereInput ;
  predefinedMessages_every?: PredefinedMessageWhereInput ;
  predefinedMessages_some?: PredefinedMessageWhereInput ;
  predefinedMessages_none?: PredefinedMessageWhereInput ;
  expenses_every?: ExpenseWhereInput ;
  expenses_some?: ExpenseWhereInput ;
  expenses_none?: ExpenseWhereInput ;
  usesAFP?: boolean ;
  usesAFP_not?: boolean ;
  AND?: CompanyWhereInput[] ;
  OR?: CompanyWhereInput[] ;
  NOT?: CompanyWhereInput[] ;
}

export interface CompanyWhereUniqueInput {
  id?: string ;
}

export interface ContentCreateManyWithoutCompanyInput {
  create?: ContentCreateWithoutCompanyInput[] ;
  connect?: ContentWhereUniqueInput[] ;
}

export interface ContentCreateManyWithoutImageInput {
  create?: ContentCreateWithoutImageInput[] ;
  connect?: ContentWhereUniqueInput[] ;
}

export interface ContentCreateManyWithoutSegmentsInput {
  create?: ContentCreateWithoutSegmentsInput[] ;
  connect?: ContentWhereUniqueInput[] ;
}

export interface ContentCreateOneWithoutSubTitleInput {
  create?: ContentCreateWithoutSubTitleInput ;
  connect?: ContentWhereUniqueInput ;
}

export interface ContentCreateOneWithoutTextInput {
  create?: ContentCreateWithoutTextInput ;
  connect?: ContentWhereUniqueInput ;
}

export interface ContentCreateOneWithoutTitleInput {
  create?: ContentCreateWithoutTitleInput ;
  connect?: ContentWhereUniqueInput ;
}

export interface ContentCreateWithoutCompanyInput {
  id?: string ;
  slug: string;
  image?: ImageCreateOneWithoutContentInput ;
  title?: TranslatedStringCreateOneWithoutContentTitleInput ;
  subTitle?: TranslatedStringCreateOneWithoutContentSubTitleInput ;
  text?: TranslatedStringCreateOneWithoutContentTextInput ;
  segments?: UserSegmentCreateManyWithoutContentsInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentCreatetypeInput ;
}

export interface ContentCreateWithoutImageInput {
  id?: string ;
  slug: string;
  company?: CompanyCreateOneWithoutContentInput ;
  title?: TranslatedStringCreateOneWithoutContentTitleInput ;
  subTitle?: TranslatedStringCreateOneWithoutContentSubTitleInput ;
  text?: TranslatedStringCreateOneWithoutContentTextInput ;
  segments?: UserSegmentCreateManyWithoutContentsInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentCreatetypeInput ;
}

export interface ContentCreateWithoutSegmentsInput {
  id?: string ;
  slug: string;
  company?: CompanyCreateOneWithoutContentInput ;
  image?: ImageCreateOneWithoutContentInput ;
  title?: TranslatedStringCreateOneWithoutContentTitleInput ;
  subTitle?: TranslatedStringCreateOneWithoutContentSubTitleInput ;
  text?: TranslatedStringCreateOneWithoutContentTextInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentCreatetypeInput ;
}

export interface ContentCreateWithoutSubTitleInput {
  id?: string ;
  slug: string;
  company?: CompanyCreateOneWithoutContentInput ;
  image?: ImageCreateOneWithoutContentInput ;
  title?: TranslatedStringCreateOneWithoutContentTitleInput ;
  text?: TranslatedStringCreateOneWithoutContentTextInput ;
  segments?: UserSegmentCreateManyWithoutContentsInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentCreatetypeInput ;
}

export interface ContentCreateWithoutTextInput {
  id?: string ;
  slug: string;
  company?: CompanyCreateOneWithoutContentInput ;
  image?: ImageCreateOneWithoutContentInput ;
  title?: TranslatedStringCreateOneWithoutContentTitleInput ;
  subTitle?: TranslatedStringCreateOneWithoutContentSubTitleInput ;
  segments?: UserSegmentCreateManyWithoutContentsInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentCreatetypeInput ;
}

export interface ContentCreateWithoutTitleInput {
  id?: string ;
  slug: string;
  company?: CompanyCreateOneWithoutContentInput ;
  image?: ImageCreateOneWithoutContentInput ;
  subTitle?: TranslatedStringCreateOneWithoutContentSubTitleInput ;
  text?: TranslatedStringCreateOneWithoutContentTextInput ;
  segments?: UserSegmentCreateManyWithoutContentsInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentCreatetypeInput ;
}

export interface ContentCreatetypeInput {
  set?: CONTENT_TYPE[] ;
}

export interface ContentWhereInput {
  types?: string[] ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  slug?: string ;
  slug_not?: string ;
  slug_in?: string[] ;
  slug_not_in?: string[] ;
  slug_lt?: string ;
  slug_lte?: string ;
  slug_gt?: string ;
  slug_gte?: string ;
  slug_contains?: string ;
  slug_not_contains?: string ;
  slug_starts_with?: string ;
  slug_not_starts_with?: string ;
  slug_ends_with?: string ;
  slug_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  image?: ImageWhereInput ;
  title?: TranslatedStringWhereInput ;
  subTitle?: TranslatedStringWhereInput ;
  text?: TranslatedStringWhereInput ;
  segments_every?: UserSegmentWhereInput ;
  segments_some?: UserSegmentWhereInput ;
  segments_none?: UserSegmentWhereInput ;
  showFrom?: any ;
  showFrom_not?: any ;
  showFrom_in?: any[] ;
  showFrom_not_in?: any[] ;
  showFrom_lt?: any ;
  showFrom_lte?: any ;
  showFrom_gt?: any ;
  showFrom_gte?: any ;
  showUntil?: any ;
  showUntil_not?: any ;
  showUntil_in?: any[] ;
  showUntil_not_in?: any[] ;
  showUntil_lt?: any ;
  showUntil_lte?: any ;
  showUntil_gt?: any ;
  showUntil_gte?: any ;
  status?: CONTENT_STATUS ;
  status_not?: CONTENT_STATUS ;
  status_in?: CONTENT_STATUS[] ;
  status_not_in?: CONTENT_STATUS[] ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: ContentWhereInput[] ;
  OR?: ContentWhereInput[] ;
  NOT?: ContentWhereInput[] ;
}

export interface ContentWhereUniqueInput {
  id?: string ;
}

export interface CourseTypeCreateManyWithoutCompanyInput {
  create?: CourseTypeCreateWithoutCompanyInput[] ;
  connect?: CourseTypeWhereUniqueInput[] ;
}

export interface CourseTypeCreateOneWithoutCategoriesInput {
  create?: CourseTypeCreateWithoutCategoriesInput ;
  connect?: CourseTypeWhereUniqueInput ;
}

export interface CourseTypeCreateOneWithoutItemsInput {
  create?: CourseTypeCreateWithoutItemsInput ;
  connect?: CourseTypeWhereUniqueInput ;
}

export interface CourseTypeCreateWithoutCategoriesInput {
  id?: string ;
  company: CompanyCreateOneWithoutCourseTypesInput;
  items?: ItemCreateManyWithoutCourseTypeInput ;
  deleted?: boolean ;
  name?: string ;
  color: string;
  label: string;
  order?: number ;
}

export interface CourseTypeCreateWithoutCompanyInput {
  id?: string ;
  items?: ItemCreateManyWithoutCourseTypeInput ;
  categories?: CategoryCreateManyWithoutCourseTypeInput ;
  deleted?: boolean ;
  name?: string ;
  color: string;
  label: string;
  order?: number ;
}

export interface CourseTypeCreateWithoutItemsInput {
  id?: string ;
  company: CompanyCreateOneWithoutCourseTypesInput;
  categories?: CategoryCreateManyWithoutCourseTypeInput ;
  deleted?: boolean ;
  name?: string ;
  color: string;
  label: string;
  order?: number ;
}

export interface CourseTypeWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  company?: CompanyWhereInput ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  categories_every?: CategoryWhereInput ;
  categories_some?: CategoryWhereInput ;
  categories_none?: CategoryWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  color?: string ;
  color_not?: string ;
  color_in?: string[] ;
  color_not_in?: string[] ;
  color_lt?: string ;
  color_lte?: string ;
  color_gt?: string ;
  color_gte?: string ;
  color_contains?: string ;
  color_not_contains?: string ;
  color_starts_with?: string ;
  color_not_starts_with?: string ;
  color_ends_with?: string ;
  color_not_ends_with?: string ;
  label?: string ;
  label_not?: string ;
  label_in?: string[] ;
  label_not_in?: string[] ;
  label_lt?: string ;
  label_lte?: string ;
  label_gt?: string ;
  label_gte?: string ;
  label_contains?: string ;
  label_not_contains?: string ;
  label_starts_with?: string ;
  label_not_starts_with?: string ;
  label_ends_with?: string ;
  label_not_ends_with?: string ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  AND?: CourseTypeWhereInput[] ;
  OR?: CourseTypeWhereInput[] ;
  NOT?: CourseTypeWhereInput[] ;
}

export interface CourseTypeWhereUniqueInput {
  id?: string ;
}

export interface CreateAdyenPaymentLinkInput {
  venueId: string;
  companyId: string;
  amount: number;
  currency?: string ;
  countryCode?: string ;
  shopperLocale?: string ;
  description?: string ;
  expiresInMinutes?: number ;
  allowedPaymentMethods?: string[] ;
  lineItems: AdyenPaymentLinkLineItemInput[];
}

export interface CreateBookingInput {
  venueId: string;
  date: string;
  startTime: string;
  partySize: number;
  guestName: string;
  guestPhone?: string ;
  guestEmail?: string ;
  comment?: string ;
  idempotencyKey?: string ;
  source?: BookingSource ;
  language?: BookingLanguage ;
  tableIds?: string[] ;
}

export interface CreateDeviceInput {
  name: string;
  venueId: string;
  companyId?: string ;
}

export interface CreateSettingsBlueprintInput {
  name: string;
  storage: any;
  companyId?: string ;
  code?: string ;
}

export interface CreditBankCreateOneWithoutCreditsTransactionsInput {
  create?: CreditBankCreateWithoutCreditsTransactionsInput ;
  connect?: CreditBankWhereUniqueInput ;
}

export interface CreditBankCreateOneWithoutUserInput {
  create?: CreditBankCreateWithoutUserInput ;
  connect?: CreditBankWhereUniqueInput ;
}

export interface CreditBankCreateWithoutCreditsTransactionsInput {
  amount: number;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  history?: CreditBankCreatehistoryInput ;
  id?: string ;
  user: UserCreateOneWithoutCreditBankInput;
}

export interface CreditBankCreateWithoutUserInput {
  amount: number;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  history?: CreditBankCreatehistoryInput ;
  id?: string ;
  creditsTransactions?: CreditsTransactionCreateManyWithoutCreditBankInput ;
}

export interface CreditBankCreatehistoryInput {
  set?: any[] ;
}

export interface CreditBankWhereInput {
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  balanceSnapshot?: number ;
  balanceSnapshot_not?: number ;
  balanceSnapshot_in?: number[] ;
  balanceSnapshot_not_in?: number[] ;
  balanceSnapshot_lt?: number ;
  balanceSnapshot_lte?: number ;
  balanceSnapshot_gt?: number ;
  balanceSnapshot_gte?: number ;
  snapshotTime?: any ;
  snapshotTime_not?: any ;
  snapshotTime_in?: any[] ;
  snapshotTime_not_in?: any[] ;
  snapshotTime_lt?: any ;
  snapshotTime_lte?: any ;
  snapshotTime_gt?: any ;
  snapshotTime_gte?: any ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  user?: UserWhereInput ;
  creditsTransactions_every?: CreditsTransactionWhereInput ;
  creditsTransactions_some?: CreditsTransactionWhereInput ;
  creditsTransactions_none?: CreditsTransactionWhereInput ;
  AND?: CreditBankWhereInput[] ;
  OR?: CreditBankWhereInput[] ;
  NOT?: CreditBankWhereInput[] ;
}

export interface CreditBankWhereUniqueInput {
  id?: string ;
}

export interface CreditCardCreateManyWithoutUserInput {
  create?: CreditCardCreateWithoutUserInput[] ;
  connect?: CreditCardWhereUniqueInput[] ;
}

export interface CreditCardCreateWithoutUserInput {
  id?: string ;
  provider: string;
  digits: string;
  token: string;
  usesNewPaymentApi?: boolean ;
}

export interface CreditCardWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  provider?: string ;
  provider_not?: string ;
  provider_in?: string[] ;
  provider_not_in?: string[] ;
  provider_lt?: string ;
  provider_lte?: string ;
  provider_gt?: string ;
  provider_gte?: string ;
  provider_contains?: string ;
  provider_not_contains?: string ;
  provider_starts_with?: string ;
  provider_not_starts_with?: string ;
  provider_ends_with?: string ;
  provider_not_ends_with?: string ;
  digits?: string ;
  digits_not?: string ;
  digits_in?: string[] ;
  digits_not_in?: string[] ;
  digits_lt?: string ;
  digits_lte?: string ;
  digits_gt?: string ;
  digits_gte?: string ;
  digits_contains?: string ;
  digits_not_contains?: string ;
  digits_starts_with?: string ;
  digits_not_starts_with?: string ;
  digits_ends_with?: string ;
  digits_not_ends_with?: string ;
  token?: string ;
  token_not?: string ;
  token_in?: string[] ;
  token_not_in?: string[] ;
  token_lt?: string ;
  token_lte?: string ;
  token_gt?: string ;
  token_gte?: string ;
  token_contains?: string ;
  token_not_contains?: string ;
  token_starts_with?: string ;
  token_not_starts_with?: string ;
  token_ends_with?: string ;
  token_not_ends_with?: string ;
  user?: UserWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  usesNewPaymentApi?: boolean ;
  usesNewPaymentApi_not?: boolean ;
  AND?: CreditCardWhereInput[] ;
  OR?: CreditCardWhereInput[] ;
  NOT?: CreditCardWhereInput[] ;
}

export interface CreditCardWhereUniqueInput {
  id?: string ;
}

export interface CreditsTransactionCreateManyWithoutCreditBankInput {
  create?: CreditsTransactionCreateWithoutCreditBankInput[] ;
  connect?: CreditsTransactionWhereUniqueInput[] ;
}

export interface CreditsTransactionCreateManyWithoutPaymentInput {
  create?: CreditsTransactionCreateWithoutPaymentInput[] ;
  connect?: CreditsTransactionWhereUniqueInput[] ;
}

export interface CreditsTransactionCreateWithoutCreditBankInput {
  id?: string ;
  amount: number;
  payment?: PaymentCreateOneWithoutCreditsTransactionsInput ;
  source: SOURCE_TYPE;
}

export interface CreditsTransactionCreateWithoutPaymentInput {
  id?: string ;
  amount: number;
  creditBank?: CreditBankCreateOneWithoutCreditsTransactionsInput ;
  source: SOURCE_TYPE;
}

export interface CreditsTransactionWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  creditBank?: CreditBankWhereInput ;
  payment?: PaymentWhereInput ;
  source?: SOURCE_TYPE ;
  source_not?: SOURCE_TYPE ;
  source_in?: SOURCE_TYPE[] ;
  source_not_in?: SOURCE_TYPE[] ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: CreditsTransactionWhereInput[] ;
  OR?: CreditsTransactionWhereInput[] ;
  NOT?: CreditsTransactionWhereInput[] ;
}

export interface CreditsTransactionWhereUniqueInput {
  id?: string ;
}

export interface CryptoPaymentInput {
  amount: number;
  reference: string;
  currency: string;
  callbackUrl: string;
}

export interface DeliveryRateCreateManyWithoutCompanyInput {
  create?: DeliveryRateCreateWithoutCompanyInput[] ;
  connect?: DeliveryRateWhereUniqueInput[] ;
}

export interface DeliveryRateCreateManyWithoutFeeInput {
  create?: DeliveryRateCreateWithoutFeeInput[] ;
  connect?: DeliveryRateWhereUniqueInput[] ;
}

export interface DeliveryRateCreateManyWithoutMenuInput {
  create?: DeliveryRateCreateWithoutMenuInput[] ;
  connect?: DeliveryRateWhereUniqueInput[] ;
}

export interface DeliveryRateCreateManyWithoutVenuesInput {
  create?: DeliveryRateCreateWithoutVenuesInput[] ;
  connect?: DeliveryRateWhereUniqueInput[] ;
}

export interface DeliveryRateCreateOneWithoutMessageInput {
  create?: DeliveryRateCreateWithoutMessageInput ;
  connect?: DeliveryRateWhereUniqueInput ;
}

export interface DeliveryRateCreateOneWithoutNameInput {
  create?: DeliveryRateCreateWithoutNameInput ;
  connect?: DeliveryRateWhereUniqueInput ;
}

export interface DeliveryRateCreateWithoutCompanyInput {
  id?: string ;
  name?: TranslatedStringCreateOneWithoutDeliveryRateNameInput ;
  message?: TranslatedStringCreateOneWithoutDeliveryRateMessageInput ;
  zip?: number ;
  polygon?: any ;
  fee: FeeCreateOneWithoutDeliveryRatesInput;
  venues?: VenueCreateManyWithoutDeliveryRatesInput ;
  menu?: MenuCreateOneWithoutDeliveryRateInput ;
}

export interface DeliveryRateCreateWithoutFeeInput {
  id?: string ;
  name?: TranslatedStringCreateOneWithoutDeliveryRateNameInput ;
  message?: TranslatedStringCreateOneWithoutDeliveryRateMessageInput ;
  zip?: number ;
  polygon?: any ;
  venues?: VenueCreateManyWithoutDeliveryRatesInput ;
  company?: CompanyCreateOneWithoutDeliveryRatesInput ;
  menu?: MenuCreateOneWithoutDeliveryRateInput ;
}

export interface DeliveryRateCreateWithoutMenuInput {
  id?: string ;
  name?: TranslatedStringCreateOneWithoutDeliveryRateNameInput ;
  message?: TranslatedStringCreateOneWithoutDeliveryRateMessageInput ;
  zip?: number ;
  polygon?: any ;
  fee: FeeCreateOneWithoutDeliveryRatesInput;
  venues?: VenueCreateManyWithoutDeliveryRatesInput ;
  company?: CompanyCreateOneWithoutDeliveryRatesInput ;
}

export interface DeliveryRateCreateWithoutMessageInput {
  id?: string ;
  name?: TranslatedStringCreateOneWithoutDeliveryRateNameInput ;
  zip?: number ;
  polygon?: any ;
  fee: FeeCreateOneWithoutDeliveryRatesInput;
  venues?: VenueCreateManyWithoutDeliveryRatesInput ;
  company?: CompanyCreateOneWithoutDeliveryRatesInput ;
  menu?: MenuCreateOneWithoutDeliveryRateInput ;
}

export interface DeliveryRateCreateWithoutNameInput {
  id?: string ;
  message?: TranslatedStringCreateOneWithoutDeliveryRateMessageInput ;
  zip?: number ;
  polygon?: any ;
  fee: FeeCreateOneWithoutDeliveryRatesInput;
  venues?: VenueCreateManyWithoutDeliveryRatesInput ;
  company?: CompanyCreateOneWithoutDeliveryRatesInput ;
  menu?: MenuCreateOneWithoutDeliveryRateInput ;
}

export interface DeliveryRateCreateWithoutVenuesInput {
  id?: string ;
  name?: TranslatedStringCreateOneWithoutDeliveryRateNameInput ;
  message?: TranslatedStringCreateOneWithoutDeliveryRateMessageInput ;
  zip?: number ;
  polygon?: any ;
  fee: FeeCreateOneWithoutDeliveryRatesInput;
  company?: CompanyCreateOneWithoutDeliveryRatesInput ;
  menu?: MenuCreateOneWithoutDeliveryRateInput ;
}

export interface DeliveryRateWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  name?: TranslatedStringWhereInput ;
  message?: TranslatedStringWhereInput ;
  zip?: number ;
  zip_not?: number ;
  zip_in?: number[] ;
  zip_not_in?: number[] ;
  zip_lt?: number ;
  zip_lte?: number ;
  zip_gt?: number ;
  zip_gte?: number ;
  fee?: FeeWhereInput ;
  venues_every?: VenueWhereInput ;
  venues_some?: VenueWhereInput ;
  venues_none?: VenueWhereInput ;
  company?: CompanyWhereInput ;
  menu?: MenuWhereInput ;
  AND?: DeliveryRateWhereInput[] ;
  OR?: DeliveryRateWhereInput[] ;
  NOT?: DeliveryRateWhereInput[] ;
}

export interface DeliveryRateWhereUniqueInput {
  id?: string ;
}

export interface DeviceCreateManyWithoutUserInput {
  create?: DeviceCreateWithoutUserInput[] ;
  connect?: DeviceWhereUniqueInput[] ;
}

export interface DeviceCreateWithoutUserInput {
  id?: string ;
  operatingSystem: DEVICE_OS;
  notificationsDisabled?: boolean ;
  topic?: string ;
  token: string;
  useNewSenderID?: boolean ;
}

export interface DeviceWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  user?: UserWhereInput ;
  operatingSystem?: DEVICE_OS ;
  operatingSystem_not?: DEVICE_OS ;
  operatingSystem_in?: DEVICE_OS[] ;
  operatingSystem_not_in?: DEVICE_OS[] ;
  notificationsDisabled?: boolean ;
  notificationsDisabled_not?: boolean ;
  topic?: string ;
  topic_not?: string ;
  topic_in?: string[] ;
  topic_not_in?: string[] ;
  topic_lt?: string ;
  topic_lte?: string ;
  topic_gt?: string ;
  topic_gte?: string ;
  topic_contains?: string ;
  topic_not_contains?: string ;
  topic_starts_with?: string ;
  topic_not_starts_with?: string ;
  topic_ends_with?: string ;
  topic_not_ends_with?: string ;
  token?: string ;
  token_not?: string ;
  token_in?: string[] ;
  token_not_in?: string[] ;
  token_lt?: string ;
  token_lte?: string ;
  token_gt?: string ;
  token_gte?: string ;
  token_contains?: string ;
  token_not_contains?: string ;
  token_starts_with?: string ;
  token_not_starts_with?: string ;
  token_ends_with?: string ;
  token_not_ends_with?: string ;
  useNewSenderID?: boolean ;
  useNewSenderID_not?: boolean ;
  AND?: DeviceWhereInput[] ;
  OR?: DeviceWhereInput[] ;
  NOT?: DeviceWhereInput[] ;
}

export interface DeviceWhereUniqueInput {
  id?: string ;
}

export interface DiscountCreateManyWithoutCompanyInput {
  create?: DiscountCreateWithoutCompanyInput[] ;
  connect?: DiscountWhereUniqueInput[] ;
}

export interface DiscountCreateManyWithoutItemsInput {
  create?: DiscountCreateWithoutItemsInput[] ;
  connect?: DiscountWhereUniqueInput[] ;
}

export interface DiscountCreateWithoutCompanyInput {
  campaigns?: CampaignCreateManyWithoutDiscountsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutDiscountsInput ;
  type: DISCOUNT_TYPE;
}

export interface DiscountCreateWithoutItemsInput {
  campaigns?: CampaignCreateManyWithoutDiscountsInput ;
  company?: CompanyCreateOneWithoutDiscountsInput ;
  id?: string ;
  type: DISCOUNT_TYPE;
}

export interface DiscountWhereInput {
  campaigns_every?: CampaignWhereInput ;
  campaigns_some?: CampaignWhereInput ;
  campaigns_none?: CampaignWhereInput ;
  company?: CompanyWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  type?: DISCOUNT_TYPE ;
  type_not?: DISCOUNT_TYPE ;
  type_in?: DISCOUNT_TYPE[] ;
  type_not_in?: DISCOUNT_TYPE[] ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: DiscountWhereInput[] ;
  OR?: DiscountWhereInput[] ;
  NOT?: DiscountWhereInput[] ;
}

export interface DiscountWhereUniqueInput {
  id?: string ;
}

export interface EmailDetails {
  companyName: string;
  formattedAmount: string;
}

export interface EventCreateManyWithoutUserInput {
  create?: EventCreateWithoutUserInput[] ;
  connect?: EventWhereUniqueInput[] ;
}

export interface EventCreateWithoutUserInput {
  id?: string ;
  category: string;
  action: string;
  label?: string ;
  value?: number ;
}

export interface EventWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  category?: string ;
  category_not?: string ;
  category_in?: string[] ;
  category_not_in?: string[] ;
  category_lt?: string ;
  category_lte?: string ;
  category_gt?: string ;
  category_gte?: string ;
  category_contains?: string ;
  category_not_contains?: string ;
  category_starts_with?: string ;
  category_not_starts_with?: string ;
  category_ends_with?: string ;
  category_not_ends_with?: string ;
  action?: string ;
  action_not?: string ;
  action_in?: string[] ;
  action_not_in?: string[] ;
  action_lt?: string ;
  action_lte?: string ;
  action_gt?: string ;
  action_gte?: string ;
  action_contains?: string ;
  action_not_contains?: string ;
  action_starts_with?: string ;
  action_not_starts_with?: string ;
  action_ends_with?: string ;
  action_not_ends_with?: string ;
  label?: string ;
  label_not?: string ;
  label_in?: string[] ;
  label_not_in?: string[] ;
  label_lt?: string ;
  label_lte?: string ;
  label_gt?: string ;
  label_gte?: string ;
  label_contains?: string ;
  label_not_contains?: string ;
  label_starts_with?: string ;
  label_not_starts_with?: string ;
  label_ends_with?: string ;
  label_not_ends_with?: string ;
  value?: number ;
  value_not?: number ;
  value_in?: number[] ;
  value_not_in?: number[] ;
  value_lt?: number ;
  value_lte?: number ;
  value_gt?: number ;
  value_gte?: number ;
  user?: UserWhereInput ;
  AND?: EventWhereInput[] ;
  OR?: EventWhereInput[] ;
  NOT?: EventWhereInput[] ;
}

export interface EventWhereUniqueInput {
  id?: string ;
}

export interface ExpenseCreateManyWithoutCompanyInput {
  create?: ExpenseCreateWithoutCompanyInput[] ;
  connect?: ExpenseWhereUniqueInput[] ;
}

export interface ExpenseCreateManyWithoutStaffInput {
  create?: ExpenseCreateWithoutStaffInput[] ;
  connect?: ExpenseWhereUniqueInput[] ;
}

export interface ExpenseCreateManyWithoutVenueInput {
  create?: ExpenseCreateWithoutVenueInput[] ;
  connect?: ExpenseWhereUniqueInput[] ;
}

export interface ExpenseCreateWithoutCompanyInput {
  id?: string ;
  amount: number;
  paymentType: string;
  venue: VenueCreateOneWithoutExpensesInput;
  staff: StaffCreateOneWithoutExpensesInput;
}

export interface ExpenseCreateWithoutStaffInput {
  id?: string ;
  amount: number;
  paymentType: string;
  venue: VenueCreateOneWithoutExpensesInput;
  company: CompanyCreateOneWithoutExpensesInput;
}

export interface ExpenseCreateWithoutVenueInput {
  id?: string ;
  amount: number;
  paymentType: string;
  company: CompanyCreateOneWithoutExpensesInput;
  staff: StaffCreateOneWithoutExpensesInput;
}

export interface ExpenseWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  paymentType?: string ;
  paymentType_not?: string ;
  paymentType_in?: string[] ;
  paymentType_not_in?: string[] ;
  paymentType_lt?: string ;
  paymentType_lte?: string ;
  paymentType_gt?: string ;
  paymentType_gte?: string ;
  paymentType_contains?: string ;
  paymentType_not_contains?: string ;
  paymentType_starts_with?: string ;
  paymentType_not_starts_with?: string ;
  paymentType_ends_with?: string ;
  paymentType_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  venue?: VenueWhereInput ;
  company?: CompanyWhereInput ;
  staff?: StaffWhereInput ;
  AND?: ExpenseWhereInput[] ;
  OR?: ExpenseWhereInput[] ;
  NOT?: ExpenseWhereInput[] ;
}

export interface ExpenseWhereUniqueInput {
  id?: string ;
}

export interface ExpressPageCreateManyWithoutCategoriesInput {
  create?: ExpressPageCreateWithoutCategoriesInput[] ;
  connect?: ExpressPageWhereUniqueInput[] ;
}

export interface ExpressPageCreateManyWithoutCompanyInput {
  create?: ExpressPageCreateWithoutCompanyInput[] ;
  connect?: ExpressPageWhereUniqueInput[] ;
}

export interface ExpressPageCreateManyWithoutIconInput {
  create?: ExpressPageCreateWithoutIconInput[] ;
  connect?: ExpressPageWhereUniqueInput[] ;
}

export interface ExpressPageCreateManyWithoutImageInput {
  create?: ExpressPageCreateWithoutImageInput[] ;
  connect?: ExpressPageWhereUniqueInput[] ;
}

export interface ExpressPageCreateOneWithoutDescriptionInput {
  create?: ExpressPageCreateWithoutDescriptionInput ;
  connect?: ExpressPageWhereUniqueInput ;
}

export interface ExpressPageCreateOneWithoutTitleInput {
  create?: ExpressPageCreateWithoutTitleInput ;
  connect?: ExpressPageWhereUniqueInput ;
}

export interface ExpressPageCreateWithoutCategoriesInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutExpressPageTitleInput;
  description?: TranslatedStringCreateOneWithoutExpressPageDescriptionInput ;
  company: CompanyCreateOneWithoutExpressPagesInput;
  icon: ImageCreateOneWithoutExpressPageIconsInput;
  image?: ImageCreateOneWithoutExpressPageImagesInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageCreateWithoutCompanyInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutExpressPageTitleInput;
  description?: TranslatedStringCreateOneWithoutExpressPageDescriptionInput ;
  categories?: CategoryCreateManyWithoutExpressPagesInput ;
  icon: ImageCreateOneWithoutExpressPageIconsInput;
  image?: ImageCreateOneWithoutExpressPageImagesInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageCreateWithoutDescriptionInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutExpressPageTitleInput;
  company: CompanyCreateOneWithoutExpressPagesInput;
  categories?: CategoryCreateManyWithoutExpressPagesInput ;
  icon: ImageCreateOneWithoutExpressPageIconsInput;
  image?: ImageCreateOneWithoutExpressPageImagesInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageCreateWithoutIconInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutExpressPageTitleInput;
  description?: TranslatedStringCreateOneWithoutExpressPageDescriptionInput ;
  company: CompanyCreateOneWithoutExpressPagesInput;
  categories?: CategoryCreateManyWithoutExpressPagesInput ;
  image?: ImageCreateOneWithoutExpressPageImagesInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageCreateWithoutImageInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutExpressPageTitleInput;
  description?: TranslatedStringCreateOneWithoutExpressPageDescriptionInput ;
  company: CompanyCreateOneWithoutExpressPagesInput;
  categories?: CategoryCreateManyWithoutExpressPagesInput ;
  icon: ImageCreateOneWithoutExpressPageIconsInput;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageCreateWithoutTitleInput {
  id?: string ;
  description?: TranslatedStringCreateOneWithoutExpressPageDescriptionInput ;
  company: CompanyCreateOneWithoutExpressPagesInput;
  categories?: CategoryCreateManyWithoutExpressPagesInput ;
  icon: ImageCreateOneWithoutExpressPageIconsInput;
  image?: ImageCreateOneWithoutExpressPageImagesInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  title?: TranslatedStringWhereInput ;
  description?: TranslatedStringWhereInput ;
  company?: CompanyWhereInput ;
  categories_every?: CategoryWhereInput ;
  categories_some?: CategoryWhereInput ;
  categories_none?: CategoryWhereInput ;
  icon?: ImageWhereInput ;
  image?: ImageWhereInput ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: ExpressPageWhereInput[] ;
  OR?: ExpressPageWhereInput[] ;
  NOT?: ExpressPageWhereInput[] ;
}

export interface ExpressPageWhereUniqueInput {
  id?: string ;
}

export interface FeeCreateManyWithoutOrdersInput {
  create?: FeeCreateWithoutOrdersInput[] ;
  connect?: FeeWhereUniqueInput[] ;
}

export interface FeeCreateOneWithoutDeliveryRatesInput {
  create?: FeeCreateWithoutDeliveryRatesInput ;
  connect?: FeeWhereUniqueInput ;
}

export interface FeeCreateOneWithoutLocalDeliveryRatesInput {
  create?: FeeCreateWithoutLocalDeliveryRatesInput ;
  connect?: FeeWhereUniqueInput ;
}

export interface FeeCreateOneWithoutPriceInput {
  create?: FeeCreateWithoutPriceInput ;
  connect?: FeeWhereUniqueInput ;
}

export interface FeeCreateWithoutDeliveryRatesInput {
  id?: string ;
  name: string;
  orders?: OrderCreateManyWithoutFeesInput ;
  price: PriceCreateOneWithoutFeeInput;
  localDeliveryRates?: LocalDeliveryOptionsCreateManyWithoutFeeInput ;
}

export interface FeeCreateWithoutLocalDeliveryRatesInput {
  id?: string ;
  name: string;
  orders?: OrderCreateManyWithoutFeesInput ;
  price: PriceCreateOneWithoutFeeInput;
  deliveryRates?: DeliveryRateCreateManyWithoutFeeInput ;
}

export interface FeeCreateWithoutOrdersInput {
  id?: string ;
  name: string;
  price: PriceCreateOneWithoutFeeInput;
  deliveryRates?: DeliveryRateCreateManyWithoutFeeInput ;
  localDeliveryRates?: LocalDeliveryOptionsCreateManyWithoutFeeInput ;
}

export interface FeeCreateWithoutPriceInput {
  id?: string ;
  name: string;
  orders?: OrderCreateManyWithoutFeesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutFeeInput ;
  localDeliveryRates?: LocalDeliveryOptionsCreateManyWithoutFeeInput ;
}

export interface FeeWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  orders_every?: OrderWhereInput ;
  orders_some?: OrderWhereInput ;
  orders_none?: OrderWhereInput ;
  price?: PriceWhereInput ;
  deliveryRates_every?: DeliveryRateWhereInput ;
  deliveryRates_some?: DeliveryRateWhereInput ;
  deliveryRates_none?: DeliveryRateWhereInput ;
  localDeliveryRates_every?: LocalDeliveryOptionsWhereInput ;
  localDeliveryRates_some?: LocalDeliveryOptionsWhereInput ;
  localDeliveryRates_none?: LocalDeliveryOptionsWhereInput ;
  AND?: FeeWhereInput[] ;
  OR?: FeeWhereInput[] ;
  NOT?: FeeWhereInput[] ;
}

export interface FeeWhereUniqueInput {
  id?: string ;
}

export interface FileCreateOneWithoutImagesInput {
  create?: FileCreateWithoutImagesInput ;
  connect?: FileWhereUniqueInput ;
}

export interface FileCreateWithoutImagesInput {
  contentType: string;
  id?: string ;
  name: string;
  secret: string;
  size: number;
  url: string;
}

export interface FileWhereInput {
  contentType?: string ;
  contentType_not?: string ;
  contentType_in?: string[] ;
  contentType_not_in?: string[] ;
  contentType_lt?: string ;
  contentType_lte?: string ;
  contentType_gt?: string ;
  contentType_gte?: string ;
  contentType_contains?: string ;
  contentType_not_contains?: string ;
  contentType_starts_with?: string ;
  contentType_not_starts_with?: string ;
  contentType_ends_with?: string ;
  contentType_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  images_every?: ImageWhereInput ;
  images_some?: ImageWhereInput ;
  images_none?: ImageWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  secret?: string ;
  secret_not?: string ;
  secret_in?: string[] ;
  secret_not_in?: string[] ;
  secret_lt?: string ;
  secret_lte?: string ;
  secret_gt?: string ;
  secret_gte?: string ;
  secret_contains?: string ;
  secret_not_contains?: string ;
  secret_starts_with?: string ;
  secret_not_starts_with?: string ;
  secret_ends_with?: string ;
  secret_not_ends_with?: string ;
  size?: number ;
  size_not?: number ;
  size_in?: number[] ;
  size_not_in?: number[] ;
  size_lt?: number ;
  size_lte?: number ;
  size_gt?: number ;
  size_gte?: number ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  url?: string ;
  url_not?: string ;
  url_in?: string[] ;
  url_not_in?: string[] ;
  url_lt?: string ;
  url_lte?: string ;
  url_gt?: string ;
  url_gte?: string ;
  url_contains?: string ;
  url_not_contains?: string ;
  url_starts_with?: string ;
  url_not_starts_with?: string ;
  url_ends_with?: string ;
  url_not_ends_with?: string ;
  AND?: FileWhereInput[] ;
  OR?: FileWhereInput[] ;
  NOT?: FileWhereInput[] ;
}

export interface FileWhereUniqueInput {
  id?: string ;
  secret?: string ;
  url?: string ;
}

export interface FloorPlanCreateManyWithoutCompanyInput {
  create?: FloorPlanCreateWithoutCompanyInput[] ;
  connect?: FloorPlanWhereUniqueInput[] ;
}

export interface FloorPlanCreateManyWithoutVenueInput {
  create?: FloorPlanCreateWithoutVenueInput[] ;
  connect?: FloorPlanWhereUniqueInput[] ;
}

export interface FloorPlanCreateOneWithoutTablesInput {
  create?: FloorPlanCreateWithoutTablesInput ;
  connect?: FloorPlanWhereUniqueInput ;
}

export interface FloorPlanCreateWithoutCompanyInput {
  id?: string ;
  name: string;
  deleted?: boolean ;
  tables?: TableCreateManyWithoutFloorPlanInput ;
  venue: VenueCreateOneWithoutFloorPlansInput;
}

export interface FloorPlanCreateWithoutTablesInput {
  id?: string ;
  name: string;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutFloorPlansInput;
  venue: VenueCreateOneWithoutFloorPlansInput;
}

export interface FloorPlanCreateWithoutVenueInput {
  id?: string ;
  name: string;
  deleted?: boolean ;
  tables?: TableCreateManyWithoutFloorPlanInput ;
  company: CompanyCreateOneWithoutFloorPlansInput;
}

export interface FloorPlanWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  tables_every?: TableWhereInput ;
  tables_some?: TableWhereInput ;
  tables_none?: TableWhereInput ;
  company?: CompanyWhereInput ;
  venue?: VenueWhereInput ;
  AND?: FloorPlanWhereInput[] ;
  OR?: FloorPlanWhereInput[] ;
  NOT?: FloorPlanWhereInput[] ;
}

export interface FloorPlanWhereUniqueInput {
  id?: string ;
}

export interface GiftcardSearchFilter {
  shortcode?: string ;
  status?: GIFTCARD_STATUS ;
}

export interface HotelChargeChequeToRoomInput {
  chargeId: string;
  cheque: HotelChequeInput;
  target: HotelChargeTargetInput;
  tip?: number ;
  reopenedFrom?: string ;
  staffId?: string ;
  deviceId?: string ;
}

export interface HotelChargeTargetInput {
  kind: HotelChargeTargetKind;
  reservationId?: string ;
  guestId?: string ;
  accountId?: string ;
  roomNumber?: string ;
}

export interface HotelChequeInput {
  chequeId: string;
  venueId: string;
  items: HotelSaleItemInput[];
  tableId?: string ;
  orderNumber?: string ;
}

export interface HotelCorrectRoomChargeInput {
  correctionId: string;
  chargeId: string;
  itemIds?: string[] ;
  lines?: HotelCorrectionLineInput[] ;
  tip?: number ;
  reopen?: boolean ;
  staffId?: string ;
  deviceId?: string ;
}

/**
 * A refunded line: corrects one open item with the same category, VAT and
 * amount (the line total after discount, as charged).
 */
export interface HotelCorrectionLineInput {
  categoryId: string;
  vatRate: number;
  amount: number;
}

export interface HotelResolveRoomChargeInput {
  chargeId: string;
  outcome: HotelRoomChargeOutcome;
  staffId?: string ;
  deviceId?: string ;
}

export interface HotelSaleItemInput {
  itemId: string;
  name: string;
  categoryId: string;
  vatRate: number;
  quantity: number;
  amount: number;
}

export interface ImageCreateManyWithoutCompanyInput {
  create?: ImageCreateWithoutCompanyInput[] ;
  connect?: ImageWhereUniqueInput[] ;
}

export interface ImageCreateOneWithoutContentInput {
  create?: ImageCreateWithoutContentInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutDEPRECATEDvenuesInput {
  create?: ImageCreateWithoutDEPRECATEDvenuesInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutExpressPageIconsInput {
  create?: ImageCreateWithoutExpressPageIconsInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutExpressPageImagesInput {
  create?: ImageCreateWithoutExpressPageImagesInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutItemsInput {
  create?: ImageCreateWithoutItemsInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutMembershipLevelImagesInput {
  create?: ImageCreateWithoutMembershipLevelImagesInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutOffersInput {
  create?: ImageCreateWithoutOffersInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutParentsInput {
  create?: ImageCreateWithoutParentsInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutReceiptTemplateInput {
  create?: ImageCreateWithoutReceiptTemplateInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutVariationsInput {
  create?: ImageCreateWithoutVariationsInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateWithoutCompanyInput {
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutContentInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutDEPRECATEDvenuesInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutExpressPageIconsInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutExpressPageImagesInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutItemsInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutMembershipLevelImagesInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  title: string;
}

export interface ImageCreateWithoutOffersInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutParentsInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutReceiptTemplateInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutVariationsInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  company?: CompanyWhereInput ;
  dEPRECATEDvenues_every?: VenueWhereInput ;
  dEPRECATEDvenues_some?: VenueWhereInput ;
  dEPRECATEDvenues_none?: VenueWhereInput ;
  file?: FileWhereInput ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  offers_every?: OfferWhereInput ;
  offers_some?: OfferWhereInput ;
  offers_none?: OfferWhereInput ;
  content_every?: ContentWhereInput ;
  content_some?: ContentWhereInput ;
  content_none?: ContentWhereInput ;
  parents_every?: CategoryWhereInput ;
  parents_some?: CategoryWhereInput ;
  parents_none?: CategoryWhereInput ;
  variations_every?: VariationWhereInput ;
  variations_some?: VariationWhereInput ;
  variations_none?: VariationWhereInput ;
  receiptTemplate?: ReceiptTemplateWhereInput ;
  expressPageImages_every?: ExpressPageWhereInput ;
  expressPageImages_some?: ExpressPageWhereInput ;
  expressPageImages_none?: ExpressPageWhereInput ;
  expressPageIcons_every?: ExpressPageWhereInput ;
  expressPageIcons_some?: ExpressPageWhereInput ;
  expressPageIcons_none?: ExpressPageWhereInput ;
  membershipLevelImages_every?: MembershipLevelWhereInput ;
  membershipLevelImages_some?: MembershipLevelWhereInput ;
  membershipLevelImages_none?: MembershipLevelWhereInput ;
  title?: string ;
  title_not?: string ;
  title_in?: string[] ;
  title_not_in?: string[] ;
  title_lt?: string ;
  title_lte?: string ;
  title_gt?: string ;
  title_gte?: string ;
  title_contains?: string ;
  title_not_contains?: string ;
  title_starts_with?: string ;
  title_not_starts_with?: string ;
  title_ends_with?: string ;
  title_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: ImageWhereInput[] ;
  OR?: ImageWhereInput[] ;
  NOT?: ImageWhereInput[] ;
}

export interface ImageWhereUniqueInput {
  id?: string ;
}

export interface IntRangeInput {
  min?: number ;
  max?: number ;
}

export interface IntegrationCreateManyWithoutCompanyInput {
  create?: IntegrationCreateWithoutCompanyInput[] ;
  connect?: IntegrationWhereUniqueInput[] ;
}

export interface IntegrationCreateWithoutCompanyInput {
  id?: string ;
  type: string;
  provider: string;
  isActive: boolean;
  activatedFeatures?: IntegrationCreateactivatedFeaturesInput ;
  keyStore?: KeyValueCreateManyWithoutIntegrationInput ;
  internalKeyStore?: InternalKeyValueCreateManyWithoutIntegrationInput ;
}

export interface IntegrationCreateactivatedFeaturesInput {
  set?: string[] ;
}

export interface IntegrationWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  company?: CompanyWhereInput ;
  type?: string ;
  type_not?: string ;
  type_in?: string[] ;
  type_not_in?: string[] ;
  type_lt?: string ;
  type_lte?: string ;
  type_gt?: string ;
  type_gte?: string ;
  type_contains?: string ;
  type_not_contains?: string ;
  type_starts_with?: string ;
  type_not_starts_with?: string ;
  type_ends_with?: string ;
  type_not_ends_with?: string ;
  provider?: string ;
  provider_not?: string ;
  provider_in?: string[] ;
  provider_not_in?: string[] ;
  provider_lt?: string ;
  provider_lte?: string ;
  provider_gt?: string ;
  provider_gte?: string ;
  provider_contains?: string ;
  provider_not_contains?: string ;
  provider_starts_with?: string ;
  provider_not_starts_with?: string ;
  provider_ends_with?: string ;
  provider_not_ends_with?: string ;
  isActive?: boolean ;
  isActive_not?: boolean ;
  keyStore_every?: KeyValueWhereInput ;
  keyStore_some?: KeyValueWhereInput ;
  keyStore_none?: KeyValueWhereInput ;
  internalKeyStore_every?: InternalKeyValueWhereInput ;
  internalKeyStore_some?: InternalKeyValueWhereInput ;
  internalKeyStore_none?: InternalKeyValueWhereInput ;
  AND?: IntegrationWhereInput[] ;
  OR?: IntegrationWhereInput[] ;
  NOT?: IntegrationWhereInput[] ;
}

export interface IntegrationWhereUniqueInput {
  id?: string ;
}

export interface InternalKeyValueCreateManyWithoutIntegrationInput {
  create?: InternalKeyValueCreateWithoutIntegrationInput[] ;
  connect?: InternalKeyValueWhereUniqueInput[] ;
}

export interface InternalKeyValueCreateWithoutIntegrationInput {
  id?: string ;
  key: string;
  value: string;
}

export interface InternalKeyValueWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  integration?: IntegrationWhereInput ;
  key?: string ;
  key_not?: string ;
  key_in?: string[] ;
  key_not_in?: string[] ;
  key_lt?: string ;
  key_lte?: string ;
  key_gt?: string ;
  key_gte?: string ;
  key_contains?: string ;
  key_not_contains?: string ;
  key_starts_with?: string ;
  key_not_starts_with?: string ;
  key_ends_with?: string ;
  key_not_ends_with?: string ;
  value?: string ;
  value_not?: string ;
  value_in?: string[] ;
  value_not_in?: string[] ;
  value_lt?: string ;
  value_lte?: string ;
  value_gt?: string ;
  value_gte?: string ;
  value_contains?: string ;
  value_not_contains?: string ;
  value_starts_with?: string ;
  value_not_starts_with?: string ;
  value_ends_with?: string ;
  value_not_ends_with?: string ;
  AND?: InternalKeyValueWhereInput[] ;
  OR?: InternalKeyValueWhereInput[] ;
  NOT?: InternalKeyValueWhereInput[] ;
}

export interface InternalKeyValueWhereUniqueInput {
  id?: string ;
}

export interface InvoiceTargetCreateManyWithoutCompanyInput {
  create?: InvoiceTargetCreateWithoutCompanyInput[] ;
  connect?: InvoiceTargetWhereUniqueInput[] ;
}

export interface InvoiceTargetCreateManyWithoutVenueInput {
  create?: InvoiceTargetCreateWithoutVenueInput[] ;
  connect?: InvoiceTargetWhereUniqueInput[] ;
}

export interface InvoiceTargetCreateOneWithoutOrdersInput {
  create?: InvoiceTargetCreateWithoutOrdersInput ;
  connect?: InvoiceTargetWhereUniqueInput ;
}

export interface InvoiceTargetCreateWithoutCompanyInput {
  id?: string ;
  lastSeenActive?: any ;
  name: string;
  type: InvoiceTargetType;
  companyName?: string ;
  orgNumber?: string ;
  email?: string ;
  phone?: string ;
  address1?: string ;
  address2?: string ;
  city?: string ;
  zip?: string ;
  country?: string ;
  venue?: VenueCreateOneWithoutInvoiceTargetsInput ;
  orders?: OrderCreateManyWithoutInvoiceTargetInput ;
}

export interface InvoiceTargetCreateWithoutOrdersInput {
  id?: string ;
  lastSeenActive?: any ;
  name: string;
  type: InvoiceTargetType;
  companyName?: string ;
  orgNumber?: string ;
  email?: string ;
  phone?: string ;
  address1?: string ;
  address2?: string ;
  city?: string ;
  zip?: string ;
  country?: string ;
  company: CompanyCreateOneWithoutInvoiceTargetsInput;
  venue?: VenueCreateOneWithoutInvoiceTargetsInput ;
}

export interface InvoiceTargetCreateWithoutVenueInput {
  id?: string ;
  lastSeenActive?: any ;
  name: string;
  type: InvoiceTargetType;
  companyName?: string ;
  orgNumber?: string ;
  email?: string ;
  phone?: string ;
  address1?: string ;
  address2?: string ;
  city?: string ;
  zip?: string ;
  country?: string ;
  company: CompanyCreateOneWithoutInvoiceTargetsInput;
  orders?: OrderCreateManyWithoutInvoiceTargetInput ;
}

export interface InvoiceTargetWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  lastSeenActive?: any ;
  lastSeenActive_not?: any ;
  lastSeenActive_in?: any[] ;
  lastSeenActive_not_in?: any[] ;
  lastSeenActive_lt?: any ;
  lastSeenActive_lte?: any ;
  lastSeenActive_gt?: any ;
  lastSeenActive_gte?: any ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  type?: InvoiceTargetType ;
  type_not?: InvoiceTargetType ;
  type_in?: InvoiceTargetType[] ;
  type_not_in?: InvoiceTargetType[] ;
  companyName?: string ;
  companyName_not?: string ;
  companyName_in?: string[] ;
  companyName_not_in?: string[] ;
  companyName_lt?: string ;
  companyName_lte?: string ;
  companyName_gt?: string ;
  companyName_gte?: string ;
  companyName_contains?: string ;
  companyName_not_contains?: string ;
  companyName_starts_with?: string ;
  companyName_not_starts_with?: string ;
  companyName_ends_with?: string ;
  companyName_not_ends_with?: string ;
  orgNumber?: string ;
  orgNumber_not?: string ;
  orgNumber_in?: string[] ;
  orgNumber_not_in?: string[] ;
  orgNumber_lt?: string ;
  orgNumber_lte?: string ;
  orgNumber_gt?: string ;
  orgNumber_gte?: string ;
  orgNumber_contains?: string ;
  orgNumber_not_contains?: string ;
  orgNumber_starts_with?: string ;
  orgNumber_not_starts_with?: string ;
  orgNumber_ends_with?: string ;
  orgNumber_not_ends_with?: string ;
  email?: string ;
  email_not?: string ;
  email_in?: string[] ;
  email_not_in?: string[] ;
  email_lt?: string ;
  email_lte?: string ;
  email_gt?: string ;
  email_gte?: string ;
  email_contains?: string ;
  email_not_contains?: string ;
  email_starts_with?: string ;
  email_not_starts_with?: string ;
  email_ends_with?: string ;
  email_not_ends_with?: string ;
  phone?: string ;
  phone_not?: string ;
  phone_in?: string[] ;
  phone_not_in?: string[] ;
  phone_lt?: string ;
  phone_lte?: string ;
  phone_gt?: string ;
  phone_gte?: string ;
  phone_contains?: string ;
  phone_not_contains?: string ;
  phone_starts_with?: string ;
  phone_not_starts_with?: string ;
  phone_ends_with?: string ;
  phone_not_ends_with?: string ;
  address1?: string ;
  address1_not?: string ;
  address1_in?: string[] ;
  address1_not_in?: string[] ;
  address1_lt?: string ;
  address1_lte?: string ;
  address1_gt?: string ;
  address1_gte?: string ;
  address1_contains?: string ;
  address1_not_contains?: string ;
  address1_starts_with?: string ;
  address1_not_starts_with?: string ;
  address1_ends_with?: string ;
  address1_not_ends_with?: string ;
  address2?: string ;
  address2_not?: string ;
  address2_in?: string[] ;
  address2_not_in?: string[] ;
  address2_lt?: string ;
  address2_lte?: string ;
  address2_gt?: string ;
  address2_gte?: string ;
  address2_contains?: string ;
  address2_not_contains?: string ;
  address2_starts_with?: string ;
  address2_not_starts_with?: string ;
  address2_ends_with?: string ;
  address2_not_ends_with?: string ;
  city?: string ;
  city_not?: string ;
  city_in?: string[] ;
  city_not_in?: string[] ;
  city_lt?: string ;
  city_lte?: string ;
  city_gt?: string ;
  city_gte?: string ;
  city_contains?: string ;
  city_not_contains?: string ;
  city_starts_with?: string ;
  city_not_starts_with?: string ;
  city_ends_with?: string ;
  city_not_ends_with?: string ;
  zip?: string ;
  zip_not?: string ;
  zip_in?: string[] ;
  zip_not_in?: string[] ;
  zip_lt?: string ;
  zip_lte?: string ;
  zip_gt?: string ;
  zip_gte?: string ;
  zip_contains?: string ;
  zip_not_contains?: string ;
  zip_starts_with?: string ;
  zip_not_starts_with?: string ;
  zip_ends_with?: string ;
  zip_not_ends_with?: string ;
  country?: string ;
  country_not?: string ;
  country_in?: string[] ;
  country_not_in?: string[] ;
  country_lt?: string ;
  country_lte?: string ;
  country_gt?: string ;
  country_gte?: string ;
  country_contains?: string ;
  country_not_contains?: string ;
  country_starts_with?: string ;
  country_not_starts_with?: string ;
  country_ends_with?: string ;
  country_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  venue?: VenueWhereInput ;
  orders_every?: OrderWhereInput ;
  orders_some?: OrderWhereInput ;
  orders_none?: OrderWhereInput ;
  AND?: InvoiceTargetWhereInput[] ;
  OR?: InvoiceTargetWhereInput[] ;
  NOT?: InvoiceTargetWhereInput[] ;
}

export interface InvoiceTargetWhereUniqueInput {
  id?: string ;
}

export interface ItemCreateInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateManyWithoutCategoriesInput {
  create?: ItemCreateWithoutCategoriesInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutCompanyInput {
  create?: ItemCreateWithoutCompanyInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutCourseTypeInput {
  create?: ItemCreateWithoutCourseTypeInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutDefaultVariationsInput {
  create?: ItemCreateWithoutDefaultVariationsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutDiscountsInput {
  create?: ItemCreateWithoutDiscountsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutGroupsInput {
  create?: ItemCreateWithoutGroupsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutImageInput {
  create?: ItemCreateWithoutImageInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutOfferStagesInput {
  create?: ItemCreateWithoutOfferStagesInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutOffersInput {
  create?: ItemCreateWithoutOffersInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutSizesInput {
  create?: ItemCreateWithoutSizesInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutStampCardsInput {
  create?: ItemCreateWithoutStampCardsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutStationsInput {
  create?: ItemCreateWithoutStationsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutUpsalesInput {
  create?: ItemCreateWithoutUpsalesInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutUpsellInput {
  create?: ItemCreateWithoutUpsellInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutUsedAsUpsellOnInput {
  create?: ItemCreateWithoutUsedAsUpsellOnInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutVariationsInput {
  create?: ItemCreateWithoutVariationsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateOneInput {
  create?: ItemCreateInput ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemCreateOneWithoutAllergiesInput {
  create?: ItemCreateWithoutAllergiesInput ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemCreateOneWithoutAppliedVariationsInput {
  create?: ItemCreateWithoutAppliedVariationsInput ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemCreateOneWithoutArticleMapsInput {
  create?: ItemCreateWithoutArticleMapsInput ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemCreateOneWithoutDescriptionLangInput {
  create?: ItemCreateWithoutDescriptionLangInput ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemCreateOneWithoutMenuEntriesInput {
  create?: ItemCreateWithoutMenuEntriesInput ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemCreateOneWithoutRecommendationsInput {
  create?: ItemCreateWithoutRecommendationsInput ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemCreateOneWithoutTitleLangInput {
  create?: ItemCreateWithoutTitleLangInput ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemCreateWithoutAllergiesInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutAppliedVariationsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutArticleMapsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutCategoriesInput {
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutCompanyInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutCourseTypeInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutDefaultVariationsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutDescriptionLangInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutDiscountsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutGroupsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutImageInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutMenuEntriesInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutOfferStagesInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutOffersInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutRecommendationsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutSizesInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutStampCardsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutStationsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutTitleLangInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutUpsalesInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutUpsellInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutUsedAsUpsellOnInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutVariationsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateallergensInput {
  set?: ALLERGEN[] ;
}

export interface ItemCreatetagsInput {
  set?: string[] ;
}

export interface ItemGroupCreateManyWithoutCategoryInput {
  create?: ItemGroupCreateWithoutCategoryInput[] ;
  connect?: ItemGroupWhereUniqueInput[] ;
}

export interface ItemGroupCreateManyWithoutItemsInput {
  create?: ItemGroupCreateWithoutItemsInput[] ;
  connect?: ItemGroupWhereUniqueInput[] ;
}

export interface ItemGroupCreateWithoutCategoryInput {
  id?: string ;
  items?: ItemCreateManyWithoutGroupsInput ;
  name: string;
}

export interface ItemGroupCreateWithoutItemsInput {
  id?: string ;
  category?: CategoryCreateOneWithoutItemGroupsInput ;
  name: string;
}

export interface ItemGroupWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  category?: CategoryWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: ItemGroupWhereInput[] ;
  OR?: ItemGroupWhereInput[] ;
  NOT?: ItemGroupWhereInput[] ;
}

export interface ItemGroupWhereUniqueInput {
  id?: string ;
}

export interface ItemSizeCreateManyWithoutCompanyInput {
  create?: ItemSizeCreateWithoutCompanyInput[] ;
  connect?: ItemSizeWhereUniqueInput[] ;
}

export interface ItemSizeCreateManyWithoutVariationsInput {
  create?: ItemSizeCreateWithoutVariationsInput[] ;
  connect?: ItemSizeWhereUniqueInput[] ;
}

export interface ItemSizeCreateOneWithoutArticleMapInput {
  create?: ItemSizeCreateWithoutArticleMapInput ;
  connect?: ItemSizeWhereUniqueInput ;
}

export interface ItemSizeCreateOneWithoutItemsInput {
  create?: ItemSizeCreateWithoutItemsInput ;
  connect?: ItemSizeWhereUniqueInput ;
}

export interface ItemSizeCreateOneWithoutNameLangInput {
  create?: ItemSizeCreateWithoutNameLangInput ;
  connect?: ItemSizeWhereUniqueInput ;
}

export interface ItemSizeCreateWithoutArticleMapInput {
  id?: string ;
  company?: CompanyCreateOneWithoutItemSizesInput ;
  items?: ItemCreateManyWithoutSizesInput ;
  variations?: VariationCreateManyWithoutSizeUsesInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutItemSizeNameInput ;
  type: ITEM_SIZE_TYPE;
}

export interface ItemSizeCreateWithoutCompanyInput {
  id?: string ;
  items?: ItemCreateManyWithoutSizesInput ;
  variations?: VariationCreateManyWithoutSizeUsesInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutItemSizeNameInput ;
  type: ITEM_SIZE_TYPE;
  articleMap?: ArticleMapCreateOneWithoutSizeInput ;
}

export interface ItemSizeCreateWithoutItemsInput {
  id?: string ;
  company?: CompanyCreateOneWithoutItemSizesInput ;
  variations?: VariationCreateManyWithoutSizeUsesInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutItemSizeNameInput ;
  type: ITEM_SIZE_TYPE;
  articleMap?: ArticleMapCreateOneWithoutSizeInput ;
}

export interface ItemSizeCreateWithoutNameLangInput {
  id?: string ;
  company?: CompanyCreateOneWithoutItemSizesInput ;
  items?: ItemCreateManyWithoutSizesInput ;
  variations?: VariationCreateManyWithoutSizeUsesInput ;
  name: string;
  type: ITEM_SIZE_TYPE;
  articleMap?: ArticleMapCreateOneWithoutSizeInput ;
}

export interface ItemSizeCreateWithoutVariationsInput {
  id?: string ;
  company?: CompanyCreateOneWithoutItemSizesInput ;
  items?: ItemCreateManyWithoutSizesInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutItemSizeNameInput ;
  type: ITEM_SIZE_TYPE;
  articleMap?: ArticleMapCreateOneWithoutSizeInput ;
}

export interface ItemSizeWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  variations_every?: VariationWhereInput ;
  variations_some?: VariationWhereInput ;
  variations_none?: VariationWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  nameLang?: TranslatedStringWhereInput ;
  type?: ITEM_SIZE_TYPE ;
  type_not?: ITEM_SIZE_TYPE ;
  type_in?: ITEM_SIZE_TYPE[] ;
  type_not_in?: ITEM_SIZE_TYPE[] ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  articleMap?: ArticleMapWhereInput ;
  AND?: ItemSizeWhereInput[] ;
  OR?: ItemSizeWhereInput[] ;
  NOT?: ItemSizeWhereInput[] ;
}

export interface ItemSizeWhereUniqueInput {
  id?: string ;
}

export interface ItemWhereInput {
  categories_every?: CategoryWhereInput ;
  categories_some?: CategoryWhereInput ;
  categories_none?: CategoryWhereInput ;
  ageRestricted?: boolean ;
  ageRestricted_not?: boolean ;
  vatRate?: number ;
  vatRate_not?: number ;
  vatRate_in?: number[] ;
  vatRate_not_in?: number[] ;
  vatRate_lt?: number ;
  vatRate_lte?: number ;
  vatRate_gt?: number ;
  vatRate_gte?: number ;
  allergies?: TranslatedStringWhereInput ;
  company?: CompanyWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  defaultPrice?: number ;
  defaultPrice_not?: number ;
  defaultPrice_in?: number[] ;
  defaultPrice_not_in?: number[] ;
  defaultPrice_lt?: number ;
  defaultPrice_lte?: number ;
  defaultPrice_gt?: number ;
  defaultPrice_gte?: number ;
  description?: string ;
  description_not?: string ;
  description_in?: string[] ;
  description_not_in?: string[] ;
  description_lt?: string ;
  description_lte?: string ;
  description_gt?: string ;
  description_gte?: string ;
  description_contains?: string ;
  description_not_contains?: string ;
  description_starts_with?: string ;
  description_not_starts_with?: string ;
  description_ends_with?: string ;
  description_not_ends_with?: string ;
  descriptionLang?: TranslatedStringWhereInput ;
  discounts_every?: DiscountWhereInput ;
  discounts_some?: DiscountWhereInput ;
  discounts_none?: DiscountWhereInput ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  image?: ImageWhereInput ;
  menuEntries_every?: MenuEntryWhereInput ;
  menuEntries_some?: MenuEntryWhereInput ;
  menuEntries_none?: MenuEntryWhereInput ;
  offers_every?: OfferWhereInput ;
  offers_some?: OfferWhereInput ;
  offers_none?: OfferWhereInput ;
  offerStages_every?: OfferStageWhereInput ;
  offerStages_some?: OfferStageWhereInput ;
  offerStages_none?: OfferStageWhereInput ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  title?: string ;
  title_not?: string ;
  title_in?: string[] ;
  title_not_in?: string[] ;
  title_lt?: string ;
  title_lte?: string ;
  title_gt?: string ;
  title_gte?: string ;
  title_contains?: string ;
  title_not_contains?: string ;
  title_starts_with?: string ;
  title_not_starts_with?: string ;
  title_ends_with?: string ;
  title_not_ends_with?: string ;
  titleLang?: TranslatedStringWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  variations_every?: VariationWhereInput ;
  variations_some?: VariationWhereInput ;
  variations_none?: VariationWhereInput ;
  stampCards_every?: StampCardWhereInput ;
  stampCards_some?: StampCardWhereInput ;
  stampCards_none?: StampCardWhereInput ;
  defaultVariations_every?: VariationWhereInput ;
  defaultVariations_some?: VariationWhereInput ;
  defaultVariations_none?: VariationWhereInput ;
  appliedVariations_every?: AppliedVariationWhereInput ;
  appliedVariations_some?: AppliedVariationWhereInput ;
  appliedVariations_none?: AppliedVariationWhereInput ;
  groups_every?: ItemGroupWhereInput ;
  groups_some?: ItemGroupWhereInput ;
  groups_none?: ItemGroupWhereInput ;
  sizes?: ItemSizeWhereInput ;
  recommendations_every?: RecommendationWhereInput ;
  recommendations_some?: RecommendationWhereInput ;
  recommendations_none?: RecommendationWhereInput ;
  articleMaps_every?: ArticleMapWhereInput ;
  articleMaps_some?: ArticleMapWhereInput ;
  articleMaps_none?: ArticleMapWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  disableMembershipDiscount?: boolean ;
  disableMembershipDiscount_not?: boolean ;
  stations_every?: StationWhereInput ;
  stations_some?: StationWhereInput ;
  stations_none?: StationWhereInput ;
  upsell?: UpsellWhereInput ;
  usedAsUpsellOn_every?: UpsellWhereInput ;
  usedAsUpsellOn_some?: UpsellWhereInput ;
  usedAsUpsellOn_none?: UpsellWhereInput ;
  upsales_every?: UpsellWhereInput ;
  upsales_some?: UpsellWhereInput ;
  upsales_none?: UpsellWhereInput ;
  courseType?: CourseTypeWhereInput ;
  manualPrice?: boolean ;
  manualPrice_not?: boolean ;
  inventoryEOD?: boolean ;
  inventoryEOD_not?: boolean ;
  volumeSuffix?: string ;
  volumeSuffix_not?: string ;
  volumeSuffix_in?: string[] ;
  volumeSuffix_not_in?: string[] ;
  volumeSuffix_lt?: string ;
  volumeSuffix_lte?: string ;
  volumeSuffix_gt?: string ;
  volumeSuffix_gte?: string ;
  volumeSuffix_contains?: string ;
  volumeSuffix_not_contains?: string ;
  volumeSuffix_starts_with?: string ;
  volumeSuffix_not_starts_with?: string ;
  volumeSuffix_ends_with?: string ;
  volumeSuffix_not_ends_with?: string ;
  costBasis?: number ;
  costBasis_not?: number ;
  costBasis_in?: number[] ;
  costBasis_not_in?: number[] ;
  costBasis_lt?: number ;
  costBasis_lte?: number ;
  costBasis_gt?: number ;
  costBasis_gte?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
  defaultOrderStatus_not?: ORDER_STATUS ;
  defaultOrderStatus_in?: ORDER_STATUS[] ;
  defaultOrderStatus_not_in?: ORDER_STATUS[] ;
  AND?: ItemWhereInput[] ;
  OR?: ItemWhereInput[] ;
  NOT?: ItemWhereInput[] ;
}

export interface ItemWhereUniqueInput {
  id?: string ;
}

export interface KeyValueCreateManyWithoutIntegrationInput {
  create?: KeyValueCreateWithoutIntegrationInput[] ;
  connect?: KeyValueWhereUniqueInput[] ;
}

export interface KeyValueCreateWithoutIntegrationInput {
  id?: string ;
  key: string;
  value: string;
}

export interface KeyValueWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  integration?: IntegrationWhereInput ;
  key?: string ;
  key_not?: string ;
  key_in?: string[] ;
  key_not_in?: string[] ;
  key_lt?: string ;
  key_lte?: string ;
  key_gt?: string ;
  key_gte?: string ;
  key_contains?: string ;
  key_not_contains?: string ;
  key_starts_with?: string ;
  key_not_starts_with?: string ;
  key_ends_with?: string ;
  key_not_ends_with?: string ;
  value?: string ;
  value_not?: string ;
  value_in?: string[] ;
  value_not_in?: string[] ;
  value_lt?: string ;
  value_lte?: string ;
  value_gt?: string ;
  value_gte?: string ;
  value_contains?: string ;
  value_not_contains?: string ;
  value_starts_with?: string ;
  value_not_starts_with?: string ;
  value_ends_with?: string ;
  value_not_ends_with?: string ;
  AND?: KeyValueWhereInput[] ;
  OR?: KeyValueWhereInput[] ;
  NOT?: KeyValueWhereInput[] ;
}

export interface KeyValueWhereUniqueInput {
  id?: string ;
}

export interface KivraAddressInput {
  streetAddress?: string ;
  locality?: string ;
  postalCode?: string ;
}

export interface KivraItemInput {
  id: string;
  name: string;
  fraction: number;
  amount: number;
  discount: number;
  vatRate: number;
}

export interface KivraPaymentInput {
  amount: number;
  type: string;
  cardToken?: string ;
  refund?: boolean ;
  acquiringInstitutionIdCode?: string ;
  cardAcceptorName?: string ;
  cardAcceptorId?: string ;
  cardAcceptorTerminalId?: string ;
  approvalCode?: string ;
  bankIdentificationNumber?: string ;
}

export interface KivraSendReceiptInput {
  venueId: string;
  venueName: string;
  companyName?: string ;
  orderId: string;
  createdAt: string;
  organizationNumber: string;
  address?: KivraAddressInput ;
  phone?: string ;
  items: KivraItemInput[];
  payments: KivraPaymentInput[];
  amount: number;
  discount: number;
  amountAfterDiscounts: number;
}

export interface LayoutCreateManyWithoutCompanyInput {
  create?: LayoutCreateWithoutCompanyInput[] ;
  connect?: LayoutWhereUniqueInput[] ;
}

export interface LayoutCreateOneWithoutCategoriesInput {
  create?: LayoutCreateWithoutCategoriesInput ;
  connect?: LayoutWhereUniqueInput ;
}

export interface LayoutCreateOneWithoutNameInput {
  create?: LayoutCreateWithoutNameInput ;
  connect?: LayoutWhereUniqueInput ;
}

export interface LayoutCreateWithoutCategoriesInput {
  id?: string ;
  deleted?: boolean ;
  name: TranslatedStringCreateOneWithoutLayoutInput;
  company: CompanyCreateOneWithoutLayoutsInput;
}

export interface LayoutCreateWithoutCompanyInput {
  id?: string ;
  deleted?: boolean ;
  name: TranslatedStringCreateOneWithoutLayoutInput;
  categories?: PosCategoryCreateManyWithoutLayoutInput ;
}

export interface LayoutCreateWithoutNameInput {
  id?: string ;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutLayoutsInput;
  categories?: PosCategoryCreateManyWithoutLayoutInput ;
}

export interface LayoutWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  name?: TranslatedStringWhereInput ;
  company?: CompanyWhereInput ;
  categories_every?: PosCategoryWhereInput ;
  categories_some?: PosCategoryWhereInput ;
  categories_none?: PosCategoryWhereInput ;
  AND?: LayoutWhereInput[] ;
  OR?: LayoutWhereInput[] ;
  NOT?: LayoutWhereInput[] ;
}

export interface LayoutWhereUniqueInput {
  id?: string ;
}

export interface LocalDeliveryOptionsCreateManyWithoutFeeInput {
  create?: LocalDeliveryOptionsCreateWithoutFeeInput[] ;
  connect?: LocalDeliveryOptionsWhereUniqueInput[] ;
}

export interface LocalDeliveryOptionsCreateOneWithoutVenuesInput {
  create?: LocalDeliveryOptionsCreateWithoutVenuesInput ;
  connect?: LocalDeliveryOptionsWhereUniqueInput ;
}

export interface LocalDeliveryOptionsCreateWithoutFeeInput {
  id?: string ;
  options?: LocalDeliveryOptionsCreateoptionsInput ;
  venues?: VenueCreateManyWithoutLocalDeliveriesInput ;
}

export interface LocalDeliveryOptionsCreateWithoutVenuesInput {
  id?: string ;
  options?: LocalDeliveryOptionsCreateoptionsInput ;
  fee: FeeCreateOneWithoutLocalDeliveryRatesInput;
}

export interface LocalDeliveryOptionsCreateoptionsInput {
  set?: string[] ;
}

export interface LocalDeliveryOptionsWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  fee?: FeeWhereInput ;
  venues_every?: VenueWhereInput ;
  venues_some?: VenueWhereInput ;
  venues_none?: VenueWhereInput ;
  AND?: LocalDeliveryOptionsWhereInput[] ;
  OR?: LocalDeliveryOptionsWhereInput[] ;
  NOT?: LocalDeliveryOptionsWhereInput[] ;
}

export interface LocalDeliveryOptionsWhereUniqueInput {
  id?: string ;
}

export interface LocationCreateManyWithoutUserInput {
  create?: LocationCreateWithoutUserInput[] ;
  connect?: LocationWhereUniqueInput[] ;
}

export interface LocationCreateOneWithoutOrdersInput {
  create?: LocationCreateWithoutOrdersInput ;
  connect?: LocationWhereUniqueInput ;
}

export interface LocationCreateOneWithoutVenueInput {
  create?: LocationCreateWithoutVenueInput ;
  connect?: LocationWhereUniqueInput ;
}

export interface LocationCreateWithoutOrdersInput {
  id?: string ;
  lat: string;
  long: string;
  name: string;
  venue?: VenueCreateOneWithoutLocationInput ;
  city?: string ;
  street?: string ;
  user?: UserCreateOneWithoutLocationsInput ;
  zip?: number ;
}

export interface LocationCreateWithoutUserInput {
  id?: string ;
  lat: string;
  long: string;
  name: string;
  venue?: VenueCreateOneWithoutLocationInput ;
  city?: string ;
  orders?: OrderCreateManyWithoutDeliveryLocationInput ;
  street?: string ;
  zip?: number ;
}

export interface LocationCreateWithoutVenueInput {
  id?: string ;
  lat: string;
  long: string;
  name: string;
  city?: string ;
  orders?: OrderCreateManyWithoutDeliveryLocationInput ;
  street?: string ;
  user?: UserCreateOneWithoutLocationsInput ;
  zip?: number ;
}

export interface LocationWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  lat?: string ;
  lat_not?: string ;
  lat_in?: string[] ;
  lat_not_in?: string[] ;
  lat_lt?: string ;
  lat_lte?: string ;
  lat_gt?: string ;
  lat_gte?: string ;
  lat_contains?: string ;
  lat_not_contains?: string ;
  lat_starts_with?: string ;
  lat_not_starts_with?: string ;
  lat_ends_with?: string ;
  lat_not_ends_with?: string ;
  long?: string ;
  long_not?: string ;
  long_in?: string[] ;
  long_not_in?: string[] ;
  long_lt?: string ;
  long_lte?: string ;
  long_gt?: string ;
  long_gte?: string ;
  long_contains?: string ;
  long_not_contains?: string ;
  long_starts_with?: string ;
  long_not_starts_with?: string ;
  long_ends_with?: string ;
  long_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  venue?: VenueWhereInput ;
  city?: string ;
  city_not?: string ;
  city_in?: string[] ;
  city_not_in?: string[] ;
  city_lt?: string ;
  city_lte?: string ;
  city_gt?: string ;
  city_gte?: string ;
  city_contains?: string ;
  city_not_contains?: string ;
  city_starts_with?: string ;
  city_not_starts_with?: string ;
  city_ends_with?: string ;
  city_not_ends_with?: string ;
  orders_every?: OrderWhereInput ;
  orders_some?: OrderWhereInput ;
  orders_none?: OrderWhereInput ;
  street?: string ;
  street_not?: string ;
  street_in?: string[] ;
  street_not_in?: string[] ;
  street_lt?: string ;
  street_lte?: string ;
  street_gt?: string ;
  street_gte?: string ;
  street_contains?: string ;
  street_not_contains?: string ;
  street_starts_with?: string ;
  street_not_starts_with?: string ;
  street_ends_with?: string ;
  street_not_ends_with?: string ;
  user?: UserWhereInput ;
  zip?: number ;
  zip_not?: number ;
  zip_in?: number[] ;
  zip_not_in?: number[] ;
  zip_lt?: number ;
  zip_lte?: number ;
  zip_gt?: number ;
  zip_gte?: number ;
  AND?: LocationWhereInput[] ;
  OR?: LocationWhereInput[] ;
  NOT?: LocationWhereInput[] ;
}

export interface LocationWhereUniqueInput {
  id?: string ;
}

export interface LogCreateManyWithoutUserInput {
  create?: LogCreateWithoutUserInput[] ;
  connect?: LogWhereUniqueInput[] ;
}

export interface LogCreateWithoutUserInput {
  id?: string ;
  content?: any ;
  message?: string ;
  logLevel?: LOG_LEVEL ;
  context?: string ;
  actionLog?: ActionLogCreateOneWithoutLogInput ;
  requestId?: string ;
  stack?: string ;
  index?: number ;
}

export interface LogWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  message?: string ;
  message_not?: string ;
  message_in?: string[] ;
  message_not_in?: string[] ;
  message_lt?: string ;
  message_lte?: string ;
  message_gt?: string ;
  message_gte?: string ;
  message_contains?: string ;
  message_not_contains?: string ;
  message_starts_with?: string ;
  message_not_starts_with?: string ;
  message_ends_with?: string ;
  message_not_ends_with?: string ;
  logLevel?: LOG_LEVEL ;
  logLevel_not?: LOG_LEVEL ;
  logLevel_in?: LOG_LEVEL[] ;
  logLevel_not_in?: LOG_LEVEL[] ;
  context?: string ;
  context_not?: string ;
  context_in?: string[] ;
  context_not_in?: string[] ;
  context_lt?: string ;
  context_lte?: string ;
  context_gt?: string ;
  context_gte?: string ;
  context_contains?: string ;
  context_not_contains?: string ;
  context_starts_with?: string ;
  context_not_starts_with?: string ;
  context_ends_with?: string ;
  context_not_ends_with?: string ;
  user?: UserWhereInput ;
  actionLog?: ActionLogWhereInput ;
  requestId?: string ;
  requestId_not?: string ;
  requestId_in?: string[] ;
  requestId_not_in?: string[] ;
  requestId_lt?: string ;
  requestId_lte?: string ;
  requestId_gt?: string ;
  requestId_gte?: string ;
  requestId_contains?: string ;
  requestId_not_contains?: string ;
  requestId_starts_with?: string ;
  requestId_not_starts_with?: string ;
  requestId_ends_with?: string ;
  requestId_not_ends_with?: string ;
  stack?: string ;
  stack_not?: string ;
  stack_in?: string[] ;
  stack_not_in?: string[] ;
  stack_lt?: string ;
  stack_lte?: string ;
  stack_gt?: string ;
  stack_gte?: string ;
  stack_contains?: string ;
  stack_not_contains?: string ;
  stack_starts_with?: string ;
  stack_not_starts_with?: string ;
  stack_ends_with?: string ;
  stack_not_ends_with?: string ;
  index?: number ;
  index_not?: number ;
  index_in?: number[] ;
  index_not_in?: number[] ;
  index_lt?: number ;
  index_lte?: number ;
  index_gt?: number ;
  index_gte?: number ;
  AND?: LogWhereInput[] ;
  OR?: LogWhereInput[] ;
  NOT?: LogWhereInput[] ;
}

export interface LogWhereUniqueInput {
  id?: string ;
}

export interface MembershipAssignmentCreateManyWithoutMembershipLevelInput {
  create?: MembershipAssignmentCreateWithoutMembershipLevelInput[] ;
  connect?: MembershipAssignmentWhereUniqueInput[] ;
}

export interface MembershipAssignmentCreateManyWithoutUserInput {
  create?: MembershipAssignmentCreateWithoutUserInput[] ;
  connect?: MembershipAssignmentWhereUniqueInput[] ;
}

export interface MembershipAssignmentCreateWithoutMembershipLevelInput {
  id?: string ;
  source: MEMBERSHIP_SOURCE_TYPE;
  user: UserCreateOneWithoutMembershipAssignmentsInput;
}

export interface MembershipAssignmentCreateWithoutUserInput {
  id?: string ;
  membershipLevel: MembershipLevelCreateOneWithoutMembershipAssignmentsInput;
  source: MEMBERSHIP_SOURCE_TYPE;
}

export interface MembershipAssignmentWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  membershipLevel?: MembershipLevelWhereInput ;
  source?: MEMBERSHIP_SOURCE_TYPE ;
  source_not?: MEMBERSHIP_SOURCE_TYPE ;
  source_in?: MEMBERSHIP_SOURCE_TYPE[] ;
  source_not_in?: MEMBERSHIP_SOURCE_TYPE[] ;
  user?: UserWhereInput ;
  AND?: MembershipAssignmentWhereInput[] ;
  OR?: MembershipAssignmentWhereInput[] ;
  NOT?: MembershipAssignmentWhereInput[] ;
}

export interface MembershipAssignmentWhereUniqueInput {
  id?: string ;
}

export interface MembershipCardCreateManyWithoutLowestMembershipLevelInput {
  create?: MembershipCardCreateWithoutLowestMembershipLevelInput[] ;
  connect?: MembershipCardWhereUniqueInput[] ;
}

export interface MembershipCardCreateManyWithoutMembershipLevelInput {
  create?: MembershipCardCreateWithoutMembershipLevelInput[] ;
  connect?: MembershipCardWhereUniqueInput[] ;
}

export interface MembershipCardCreateOneWithoutPointsTransactionsInput {
  create?: MembershipCardCreateWithoutPointsTransactionsInput ;
  connect?: MembershipCardWhereUniqueInput ;
}

export interface MembershipCardCreateOneWithoutUserInput {
  create?: MembershipCardCreateWithoutUserInput ;
  connect?: MembershipCardWhereUniqueInput ;
}

export interface MembershipCardCreateWithoutLowestMembershipLevelInput {
  id?: string ;
  membershipLevel: MembershipLevelCreateOneWithoutMembershipCardsInput;
  user: UserCreateOneWithoutMembershipCardInput;
  points?: number ;
  pointsTransactions?: PointsTransactionCreateManyWithoutMembershipCardInput ;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  source: MEMBERSHIP_SOURCE_TYPE;
}

export interface MembershipCardCreateWithoutMembershipLevelInput {
  id?: string ;
  lowestMembershipLevel?: MembershipLevelCreateOneWithoutAsLowestInInput ;
  user: UserCreateOneWithoutMembershipCardInput;
  points?: number ;
  pointsTransactions?: PointsTransactionCreateManyWithoutMembershipCardInput ;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  source: MEMBERSHIP_SOURCE_TYPE;
}

export interface MembershipCardCreateWithoutPointsTransactionsInput {
  id?: string ;
  membershipLevel: MembershipLevelCreateOneWithoutMembershipCardsInput;
  lowestMembershipLevel?: MembershipLevelCreateOneWithoutAsLowestInInput ;
  user: UserCreateOneWithoutMembershipCardInput;
  points?: number ;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  source: MEMBERSHIP_SOURCE_TYPE;
}

export interface MembershipCardCreateWithoutUserInput {
  id?: string ;
  membershipLevel: MembershipLevelCreateOneWithoutMembershipCardsInput;
  lowestMembershipLevel?: MembershipLevelCreateOneWithoutAsLowestInInput ;
  points?: number ;
  pointsTransactions?: PointsTransactionCreateManyWithoutMembershipCardInput ;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  source: MEMBERSHIP_SOURCE_TYPE;
}

export interface MembershipCardWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  membershipLevel?: MembershipLevelWhereInput ;
  lowestMembershipLevel?: MembershipLevelWhereInput ;
  user?: UserWhereInput ;
  points?: number ;
  points_not?: number ;
  points_in?: number[] ;
  points_not_in?: number[] ;
  points_lt?: number ;
  points_lte?: number ;
  points_gt?: number ;
  points_gte?: number ;
  pointsTransactions_every?: PointsTransactionWhereInput ;
  pointsTransactions_some?: PointsTransactionWhereInput ;
  pointsTransactions_none?: PointsTransactionWhereInput ;
  balanceSnapshot?: number ;
  balanceSnapshot_not?: number ;
  balanceSnapshot_in?: number[] ;
  balanceSnapshot_not_in?: number[] ;
  balanceSnapshot_lt?: number ;
  balanceSnapshot_lte?: number ;
  balanceSnapshot_gt?: number ;
  balanceSnapshot_gte?: number ;
  snapshotTime?: any ;
  snapshotTime_not?: any ;
  snapshotTime_in?: any[] ;
  snapshotTime_not_in?: any[] ;
  snapshotTime_lt?: any ;
  snapshotTime_lte?: any ;
  snapshotTime_gt?: any ;
  snapshotTime_gte?: any ;
  source?: MEMBERSHIP_SOURCE_TYPE ;
  source_not?: MEMBERSHIP_SOURCE_TYPE ;
  source_in?: MEMBERSHIP_SOURCE_TYPE[] ;
  source_not_in?: MEMBERSHIP_SOURCE_TYPE[] ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: MembershipCardWhereInput[] ;
  OR?: MembershipCardWhereInput[] ;
  NOT?: MembershipCardWhereInput[] ;
}

export interface MembershipCardWhereUniqueInput {
  id?: string ;
}

export interface MembershipLevelCreateManyWithoutCompanyInput {
  create?: MembershipLevelCreateWithoutCompanyInput[] ;
  connect?: MembershipLevelWhereUniqueInput[] ;
}

export interface MembershipLevelCreateManyWithoutDesignInput {
  create?: MembershipLevelCreateWithoutDesignInput[] ;
  connect?: MembershipLevelWhereUniqueInput[] ;
}

export interface MembershipLevelCreateManyWithoutImageInput {
  create?: MembershipLevelCreateWithoutImageInput[] ;
  connect?: MembershipLevelWhereUniqueInput[] ;
}

export interface MembershipLevelCreateManyWithoutMenusInput {
  create?: MembershipLevelCreateWithoutMenusInput[] ;
  connect?: MembershipLevelWhereUniqueInput[] ;
}

export interface MembershipLevelCreateOneWithoutAsLowestInInput {
  create?: MembershipLevelCreateWithoutAsLowestInInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelCreateOneWithoutDescriptionInput {
  create?: MembershipLevelCreateWithoutDescriptionInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelCreateOneWithoutMembershipAssignmentsInput {
  create?: MembershipLevelCreateWithoutMembershipAssignmentsInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelCreateOneWithoutMembershipCardsInput {
  create?: MembershipLevelCreateWithoutMembershipCardsInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelCreateOneWithoutMembershipTradeinsInput {
  create?: MembershipLevelCreateWithoutMembershipTradeinsInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelCreateOneWithoutPromoCodesInput {
  create?: MembershipLevelCreateWithoutPromoCodesInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelCreateOneWithoutTitleInput {
  create?: MembershipLevelCreateWithoutTitleInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelCreateOneWithoutUsersInput {
  create?: MembershipLevelCreateWithoutUsersInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelCreateWithoutAsLowestInInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutCompanyInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutDescriptionInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutDesignInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutImageInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
}

export interface MembershipLevelCreateWithoutMembershipAssignmentsInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutMembershipCardsInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutMembershipTradeinsInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutMenusInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutPromoCodesInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutTitleInput {
  id?: string ;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutUsersInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  title?: TranslatedStringWhereInput ;
  description?: TranslatedStringWhereInput ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  company?: CompanyWhereInput ;
  default?: boolean ;
  default_not?: boolean ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  primaryColor?: string ;
  primaryColor_not?: string ;
  primaryColor_in?: string[] ;
  primaryColor_not_in?: string[] ;
  primaryColor_lt?: string ;
  primaryColor_lte?: string ;
  primaryColor_gt?: string ;
  primaryColor_gte?: string ;
  primaryColor_contains?: string ;
  primaryColor_not_contains?: string ;
  primaryColor_starts_with?: string ;
  primaryColor_not_starts_with?: string ;
  primaryColor_ends_with?: string ;
  primaryColor_not_ends_with?: string ;
  secondaryColor?: string ;
  secondaryColor_not?: string ;
  secondaryColor_in?: string[] ;
  secondaryColor_not_in?: string[] ;
  secondaryColor_lt?: string ;
  secondaryColor_lte?: string ;
  secondaryColor_gt?: string ;
  secondaryColor_gte?: string ;
  secondaryColor_contains?: string ;
  secondaryColor_not_contains?: string ;
  secondaryColor_starts_with?: string ;
  secondaryColor_not_starts_with?: string ;
  secondaryColor_ends_with?: string ;
  secondaryColor_not_ends_with?: string ;
  discountPercentage?: number ;
  discountPercentage_not?: number ;
  discountPercentage_in?: number[] ;
  discountPercentage_not_in?: number[] ;
  discountPercentage_lt?: number ;
  discountPercentage_lte?: number ;
  discountPercentage_gt?: number ;
  discountPercentage_gte?: number ;
  creditsYieldPercentage?: number ;
  creditsYieldPercentage_not?: number ;
  creditsYieldPercentage_in?: number[] ;
  creditsYieldPercentage_not_in?: number[] ;
  creditsYieldPercentage_lt?: number ;
  creditsYieldPercentage_lte?: number ;
  creditsYieldPercentage_gt?: number ;
  creditsYieldPercentage_gte?: number ;
  pointsRequired?: number ;
  pointsRequired_not?: number ;
  pointsRequired_in?: number[] ;
  pointsRequired_not_in?: number[] ;
  pointsRequired_lt?: number ;
  pointsRequired_lte?: number ;
  pointsRequired_gt?: number ;
  pointsRequired_gte?: number ;
  membershipCards_every?: MembershipCardWhereInput ;
  membershipCards_some?: MembershipCardWhereInput ;
  membershipCards_none?: MembershipCardWhereInput ;
  asLowestIn_every?: MembershipCardWhereInput ;
  asLowestIn_some?: MembershipCardWhereInput ;
  asLowestIn_none?: MembershipCardWhereInput ;
  promoCodes_every?: PromoCodeWhereInput ;
  promoCodes_some?: PromoCodeWhereInput ;
  promoCodes_none?: PromoCodeWhereInput ;
  menus_every?: AppliedMenuWhereInput ;
  menus_some?: AppliedMenuWhereInput ;
  menus_none?: AppliedMenuWhereInput ;
  design?: CardDesignWhereInput ;
  membershipAssignments_every?: MembershipAssignmentWhereInput ;
  membershipAssignments_some?: MembershipAssignmentWhereInput ;
  membershipAssignments_none?: MembershipAssignmentWhereInput ;
  membershipTradeins_every?: MembershipTradeinWhereInput ;
  membershipTradeins_some?: MembershipTradeinWhereInput ;
  membershipTradeins_none?: MembershipTradeinWhereInput ;
  image?: ImageWhereInput ;
  AND?: MembershipLevelWhereInput[] ;
  OR?: MembershipLevelWhereInput[] ;
  NOT?: MembershipLevelWhereInput[] ;
}

export interface MembershipLevelWhereUniqueInput {
  id?: string ;
}

export interface MembershipTradeinCreateManyWithoutCompanyInput {
  create?: MembershipTradeinCreateWithoutCompanyInput[] ;
  connect?: MembershipTradeinWhereUniqueInput[] ;
}

export interface MembershipTradeinCreateManyWithoutMembershipLevelInput {
  create?: MembershipTradeinCreateWithoutMembershipLevelInput[] ;
  connect?: MembershipTradeinWhereUniqueInput[] ;
}

export interface MembershipTradeinCreateManyWithoutUserInput {
  create?: MembershipTradeinCreateWithoutUserInput[] ;
  connect?: MembershipTradeinWhereUniqueInput[] ;
}

export interface MembershipTradeinCreateWithoutCompanyInput {
  id?: string ;
  membershipLevel: MembershipLevelCreateOneWithoutMembershipTradeinsInput;
  traded?: boolean ;
  code: string;
  user?: UserCreateOneWithoutMembershipTradeinsInput ;
}

export interface MembershipTradeinCreateWithoutMembershipLevelInput {
  id?: string ;
  traded?: boolean ;
  code: string;
  user?: UserCreateOneWithoutMembershipTradeinsInput ;
  company: CompanyCreateOneWithoutMembershipTradeinsInput;
}

export interface MembershipTradeinCreateWithoutUserInput {
  id?: string ;
  membershipLevel: MembershipLevelCreateOneWithoutMembershipTradeinsInput;
  traded?: boolean ;
  code: string;
  company: CompanyCreateOneWithoutMembershipTradeinsInput;
}

export interface MembershipTradeinWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  membershipLevel?: MembershipLevelWhereInput ;
  traded?: boolean ;
  traded_not?: boolean ;
  code?: string ;
  code_not?: string ;
  code_in?: string[] ;
  code_not_in?: string[] ;
  code_lt?: string ;
  code_lte?: string ;
  code_gt?: string ;
  code_gte?: string ;
  code_contains?: string ;
  code_not_contains?: string ;
  code_starts_with?: string ;
  code_not_starts_with?: string ;
  code_ends_with?: string ;
  code_not_ends_with?: string ;
  user?: UserWhereInput ;
  company?: CompanyWhereInput ;
  AND?: MembershipTradeinWhereInput[] ;
  OR?: MembershipTradeinWhereInput[] ;
  NOT?: MembershipTradeinWhereInput[] ;
}

export interface MembershipTradeinWhereUniqueInput {
  id?: string ;
}

export interface MenuCreateManyWithoutCompanyInput {
  create?: MenuCreateWithoutCompanyInput[] ;
  connect?: MenuWhereUniqueInput[] ;
}

export interface MenuCreateOneWithoutApplicationsInput {
  create?: MenuCreateWithoutApplicationsInput ;
  connect?: MenuWhereUniqueInput ;
}

export interface MenuCreateOneWithoutDeliveryRateInput {
  create?: MenuCreateWithoutDeliveryRateInput ;
  connect?: MenuWhereUniqueInput ;
}

export interface MenuCreateOneWithoutMenuEntriesInput {
  create?: MenuCreateWithoutMenuEntriesInput ;
  connect?: MenuWhereUniqueInput ;
}

export interface MenuCreateOneWithoutNameLangInput {
  create?: MenuCreateWithoutNameLangInput ;
  connect?: MenuWhereUniqueInput ;
}

export interface MenuCreateWithoutApplicationsInput {
  company?: CompanyCreateOneWithoutMenusInput ;
  id?: string ;
  menuEntries?: MenuEntryCreateManyWithoutMenuInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutMenuNameInput ;
  deleted?: boolean ;
  currency?: CURRENCY ;
  deliveryRate?: DeliveryRateCreateManyWithoutMenuInput ;
}

export interface MenuCreateWithoutCompanyInput {
  id?: string ;
  menuEntries?: MenuEntryCreateManyWithoutMenuInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutMenuNameInput ;
  applications?: AppliedMenuCreateManyWithoutMenuInput ;
  deleted?: boolean ;
  currency?: CURRENCY ;
  deliveryRate?: DeliveryRateCreateManyWithoutMenuInput ;
}

export interface MenuCreateWithoutDeliveryRateInput {
  company?: CompanyCreateOneWithoutMenusInput ;
  id?: string ;
  menuEntries?: MenuEntryCreateManyWithoutMenuInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutMenuNameInput ;
  applications?: AppliedMenuCreateManyWithoutMenuInput ;
  deleted?: boolean ;
  currency?: CURRENCY ;
}

export interface MenuCreateWithoutMenuEntriesInput {
  company?: CompanyCreateOneWithoutMenusInput ;
  id?: string ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutMenuNameInput ;
  applications?: AppliedMenuCreateManyWithoutMenuInput ;
  deleted?: boolean ;
  currency?: CURRENCY ;
  deliveryRate?: DeliveryRateCreateManyWithoutMenuInput ;
}

export interface MenuCreateWithoutNameLangInput {
  company?: CompanyCreateOneWithoutMenusInput ;
  id?: string ;
  menuEntries?: MenuEntryCreateManyWithoutMenuInput ;
  name: string;
  applications?: AppliedMenuCreateManyWithoutMenuInput ;
  deleted?: boolean ;
  currency?: CURRENCY ;
  deliveryRate?: DeliveryRateCreateManyWithoutMenuInput ;
}

export interface MenuEntryCreateManyWithoutCategoryInput {
  create?: MenuEntryCreateWithoutCategoryInput[] ;
  connect?: MenuEntryWhereUniqueInput[] ;
}

export interface MenuEntryCreateManyWithoutItemInput {
  create?: MenuEntryCreateWithoutItemInput[] ;
  connect?: MenuEntryWhereUniqueInput[] ;
}

export interface MenuEntryCreateManyWithoutMenuInput {
  create?: MenuEntryCreateWithoutMenuInput[] ;
  connect?: MenuEntryWhereUniqueInput[] ;
}

export interface MenuEntryCreateOneWithoutOrderItemsInput {
  create?: MenuEntryCreateWithoutOrderItemsInput ;
  connect?: MenuEntryWhereUniqueInput ;
}

export interface MenuEntryCreateOneWithoutSelectedVariationsInput {
  create?: MenuEntryCreateWithoutSelectedVariationsInput ;
  connect?: MenuEntryWhereUniqueInput ;
}

export interface MenuEntryCreateWithoutCategoryInput {
  endTime?: any ;
  id?: string ;
  item?: ItemCreateOneWithoutMenuEntriesInput ;
  menu?: MenuCreateOneWithoutMenuEntriesInput ;
  orderItems?: OrderItemCreateManyWithoutEntryInput ;
  price?: number ;
  selectedVariations?: VariationCreateManyWithoutMenuEntryInput ;
  startTime?: any ;
  instant?: boolean ;
  selfService?: boolean ;
}

export interface MenuEntryCreateWithoutItemInput {
  category?: CategoryCreateOneWithoutEntriesInput ;
  endTime?: any ;
  id?: string ;
  menu?: MenuCreateOneWithoutMenuEntriesInput ;
  orderItems?: OrderItemCreateManyWithoutEntryInput ;
  price?: number ;
  selectedVariations?: VariationCreateManyWithoutMenuEntryInput ;
  startTime?: any ;
  instant?: boolean ;
  selfService?: boolean ;
}

export interface MenuEntryCreateWithoutMenuInput {
  category?: CategoryCreateOneWithoutEntriesInput ;
  endTime?: any ;
  id?: string ;
  item?: ItemCreateOneWithoutMenuEntriesInput ;
  orderItems?: OrderItemCreateManyWithoutEntryInput ;
  price?: number ;
  selectedVariations?: VariationCreateManyWithoutMenuEntryInput ;
  startTime?: any ;
  instant?: boolean ;
  selfService?: boolean ;
}

export interface MenuEntryCreateWithoutOrderItemsInput {
  category?: CategoryCreateOneWithoutEntriesInput ;
  endTime?: any ;
  id?: string ;
  item?: ItemCreateOneWithoutMenuEntriesInput ;
  menu?: MenuCreateOneWithoutMenuEntriesInput ;
  price?: number ;
  selectedVariations?: VariationCreateManyWithoutMenuEntryInput ;
  startTime?: any ;
  instant?: boolean ;
  selfService?: boolean ;
}

export interface MenuEntryCreateWithoutSelectedVariationsInput {
  category?: CategoryCreateOneWithoutEntriesInput ;
  endTime?: any ;
  id?: string ;
  item?: ItemCreateOneWithoutMenuEntriesInput ;
  menu?: MenuCreateOneWithoutMenuEntriesInput ;
  orderItems?: OrderItemCreateManyWithoutEntryInput ;
  price?: number ;
  startTime?: any ;
  instant?: boolean ;
  selfService?: boolean ;
}

export interface MenuEntryWhereInput {
  category?: CategoryWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  endTime?: any ;
  endTime_not?: any ;
  endTime_in?: any[] ;
  endTime_not_in?: any[] ;
  endTime_lt?: any ;
  endTime_lte?: any ;
  endTime_gt?: any ;
  endTime_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  item?: ItemWhereInput ;
  menu?: MenuWhereInput ;
  orderItems_every?: OrderItemWhereInput ;
  orderItems_some?: OrderItemWhereInput ;
  orderItems_none?: OrderItemWhereInput ;
  price?: number ;
  price_not?: number ;
  price_in?: number[] ;
  price_not_in?: number[] ;
  price_lt?: number ;
  price_lte?: number ;
  price_gt?: number ;
  price_gte?: number ;
  selectedVariations_every?: VariationWhereInput ;
  selectedVariations_some?: VariationWhereInput ;
  selectedVariations_none?: VariationWhereInput ;
  startTime?: any ;
  startTime_not?: any ;
  startTime_in?: any[] ;
  startTime_not_in?: any[] ;
  startTime_lt?: any ;
  startTime_lte?: any ;
  startTime_gt?: any ;
  startTime_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  instant?: boolean ;
  instant_not?: boolean ;
  selfService?: boolean ;
  selfService_not?: boolean ;
  AND?: MenuEntryWhereInput[] ;
  OR?: MenuEntryWhereInput[] ;
  NOT?: MenuEntryWhereInput[] ;
}

export interface MenuEntryWhereUniqueInput {
  id?: string ;
}

export interface MenuWhereInput {
  company?: CompanyWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  menuEntries_every?: MenuEntryWhereInput ;
  menuEntries_some?: MenuEntryWhereInput ;
  menuEntries_none?: MenuEntryWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  nameLang?: TranslatedStringWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  applications_every?: AppliedMenuWhereInput ;
  applications_some?: AppliedMenuWhereInput ;
  applications_none?: AppliedMenuWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  currency?: CURRENCY ;
  currency_not?: CURRENCY ;
  currency_in?: CURRENCY[] ;
  currency_not_in?: CURRENCY[] ;
  deliveryRate_every?: DeliveryRateWhereInput ;
  deliveryRate_some?: DeliveryRateWhereInput ;
  deliveryRate_none?: DeliveryRateWhereInput ;
  AND?: MenuWhereInput[] ;
  OR?: MenuWhereInput[] ;
  NOT?: MenuWhereInput[] ;
}

export interface MenuWhereUniqueInput {
  id?: string ;
}

export interface NotificationCreateManyWithoutUsersInput {
  create?: NotificationCreateWithoutUsersInput[] ;
  connect?: NotificationWhereUniqueInput[] ;
}

export interface NotificationCreateOneWithoutBodyInput {
  create?: NotificationCreateWithoutBodyInput ;
  connect?: NotificationWhereUniqueInput ;
}

export interface NotificationCreateOneWithoutSentNotificationsInput {
  create?: NotificationCreateWithoutSentNotificationsInput ;
  connect?: NotificationWhereUniqueInput ;
}

export interface NotificationCreateOneWithoutTitleInput {
  create?: NotificationCreateWithoutTitleInput ;
  connect?: NotificationWhereUniqueInput ;
}

export interface NotificationCreateWithoutBodyInput {
  id?: string ;
  users?: UserCreateManyWithoutNotificationsInput ;
  sentNotifications?: SentNotificationCreateManyWithoutNotificationInput ;
  ticker: string;
  bigText: string;
  message: string;
  sent?: NotificationCreatesentInput ;
  failed?: NotificationCreatefailedInput ;
  target?: NOTIFICATION_TARGET ;
  title?: TranslatedStringCreateOneWithoutNotifTitleInput ;
  payload?: any ;
}

export interface NotificationCreateWithoutSentNotificationsInput {
  id?: string ;
  users?: UserCreateManyWithoutNotificationsInput ;
  ticker: string;
  bigText: string;
  message: string;
  sent?: NotificationCreatesentInput ;
  failed?: NotificationCreatefailedInput ;
  target?: NOTIFICATION_TARGET ;
  title?: TranslatedStringCreateOneWithoutNotifTitleInput ;
  body?: TranslatedStringCreateOneWithoutNotifBodyInput ;
  payload?: any ;
}

export interface NotificationCreateWithoutTitleInput {
  id?: string ;
  users?: UserCreateManyWithoutNotificationsInput ;
  sentNotifications?: SentNotificationCreateManyWithoutNotificationInput ;
  ticker: string;
  bigText: string;
  message: string;
  sent?: NotificationCreatesentInput ;
  failed?: NotificationCreatefailedInput ;
  target?: NOTIFICATION_TARGET ;
  body?: TranslatedStringCreateOneWithoutNotifBodyInput ;
  payload?: any ;
}

export interface NotificationCreateWithoutUsersInput {
  id?: string ;
  sentNotifications?: SentNotificationCreateManyWithoutNotificationInput ;
  ticker: string;
  bigText: string;
  message: string;
  sent?: NotificationCreatesentInput ;
  failed?: NotificationCreatefailedInput ;
  target?: NOTIFICATION_TARGET ;
  title?: TranslatedStringCreateOneWithoutNotifTitleInput ;
  body?: TranslatedStringCreateOneWithoutNotifBodyInput ;
  payload?: any ;
}

export interface NotificationCreatefailedInput {
  set?: string[] ;
}

export interface NotificationCreatesentInput {
  set?: string[] ;
}

export interface NotificationWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  sentNotifications_every?: SentNotificationWhereInput ;
  sentNotifications_some?: SentNotificationWhereInput ;
  sentNotifications_none?: SentNotificationWhereInput ;
  ticker?: string ;
  ticker_not?: string ;
  ticker_in?: string[] ;
  ticker_not_in?: string[] ;
  ticker_lt?: string ;
  ticker_lte?: string ;
  ticker_gt?: string ;
  ticker_gte?: string ;
  ticker_contains?: string ;
  ticker_not_contains?: string ;
  ticker_starts_with?: string ;
  ticker_not_starts_with?: string ;
  ticker_ends_with?: string ;
  ticker_not_ends_with?: string ;
  bigText?: string ;
  bigText_not?: string ;
  bigText_in?: string[] ;
  bigText_not_in?: string[] ;
  bigText_lt?: string ;
  bigText_lte?: string ;
  bigText_gt?: string ;
  bigText_gte?: string ;
  bigText_contains?: string ;
  bigText_not_contains?: string ;
  bigText_starts_with?: string ;
  bigText_not_starts_with?: string ;
  bigText_ends_with?: string ;
  bigText_not_ends_with?: string ;
  message?: string ;
  message_not?: string ;
  message_in?: string[] ;
  message_not_in?: string[] ;
  message_lt?: string ;
  message_lte?: string ;
  message_gt?: string ;
  message_gte?: string ;
  message_contains?: string ;
  message_not_contains?: string ;
  message_starts_with?: string ;
  message_not_starts_with?: string ;
  message_ends_with?: string ;
  message_not_ends_with?: string ;
  target?: NOTIFICATION_TARGET ;
  target_not?: NOTIFICATION_TARGET ;
  target_in?: NOTIFICATION_TARGET[] ;
  target_not_in?: NOTIFICATION_TARGET[] ;
  title?: TranslatedStringWhereInput ;
  body?: TranslatedStringWhereInput ;
  AND?: NotificationWhereInput[] ;
  OR?: NotificationWhereInput[] ;
  NOT?: NotificationWhereInput[] ;
}

export interface NotificationWhereUniqueInput {
  id?: string ;
}

export interface OfferCreateManyWithoutCategoriesInput {
  create?: OfferCreateWithoutCategoriesInput[] ;
  connect?: OfferWhereUniqueInput[] ;
}

export interface OfferCreateManyWithoutCompanyInput {
  create?: OfferCreateWithoutCompanyInput[] ;
  connect?: OfferWhereUniqueInput[] ;
}

export interface OfferCreateManyWithoutImageInput {
  create?: OfferCreateWithoutImageInput[] ;
  connect?: OfferWhereUniqueInput[] ;
}

export interface OfferCreateManyWithoutItemsInput {
  create?: OfferCreateWithoutItemsInput[] ;
  connect?: OfferWhereUniqueInput[] ;
}

export interface OfferCreateManyWithoutOrdersInput {
  create?: OfferCreateWithoutOrdersInput[] ;
  connect?: OfferWhereUniqueInput[] ;
}

export interface OfferCreateManyWithoutUsersInput {
  create?: OfferCreateWithoutUsersInput[] ;
  connect?: OfferWhereUniqueInput[] ;
}

export interface OfferCreateManyWithoutVenuesInput {
  create?: OfferCreateWithoutVenuesInput[] ;
  connect?: OfferWhereUniqueInput[] ;
}

export interface OfferCreateOneWithoutDescriptionLangInput {
  create?: OfferCreateWithoutDescriptionLangInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutNameLangInput {
  create?: OfferCreateWithoutNameLangInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutOrdersSinglesInput {
  create?: OfferCreateWithoutOrdersSinglesInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutPromoCodesInput {
  create?: OfferCreateWithoutPromoCodesInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutReferralOfferForCompanyInput {
  create?: OfferCreateWithoutReferralOfferForCompanyInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutReferrerOfferForCompanyInput {
  create?: OfferCreateWithoutReferrerOfferForCompanyInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutStagesInput {
  create?: OfferCreateWithoutStagesInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutStampCardsInput {
  create?: OfferCreateWithoutStampCardsInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutTokensInput {
  create?: OfferCreateWithoutTokensInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutUsesInput {
  create?: OfferCreateWithoutUsesInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutYieldEventsInput {
  create?: OfferCreateWithoutYieldEventsInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateWithoutCategoriesInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
}

export interface OfferCreateWithoutCompanyInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutDescriptionLangInput {
  id?: string ;
  description?: string ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutImageInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutItemsInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutNameLangInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutOrdersInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutOrdersSinglesInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutPromoCodesInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutReferralOfferForCompanyInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutReferrerOfferForCompanyInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutStagesInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutStampCardsInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutTokensInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutUsersInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutUsesInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutVenuesInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutYieldEventsInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferStageCreateManyWithoutItemsInput {
  create?: OfferStageCreateWithoutItemsInput[] ;
  connect?: OfferStageWhereUniqueInput[] ;
}

export interface OfferStageCreateManyWithoutOfferInput {
  create?: OfferStageCreateWithoutOfferInput[] ;
  connect?: OfferStageWhereUniqueInput[] ;
}

export interface OfferStageCreateOneWithoutDescriptionInput {
  create?: OfferStageCreateWithoutDescriptionInput ;
  connect?: OfferStageWhereUniqueInput ;
}

export interface OfferStageCreateOneWithoutTitleInput {
  create?: OfferStageCreateWithoutTitleInput ;
  connect?: OfferStageWhereUniqueInput ;
}

export interface OfferStageCreateWithoutDescriptionInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutOfferStageTitleInput;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
  items?: ItemCreateManyWithoutOfferStagesInput ;
  offer?: OfferCreateOneWithoutStagesInput ;
}

export interface OfferStageCreateWithoutItemsInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutOfferStageTitleInput;
  description: TranslatedStringCreateOneWithoutOfferStageDescriptionInput;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
  offer?: OfferCreateOneWithoutStagesInput ;
}

export interface OfferStageCreateWithoutOfferInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutOfferStageTitleInput;
  description: TranslatedStringCreateOneWithoutOfferStageDescriptionInput;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
  items?: ItemCreateManyWithoutOfferStagesInput ;
}

export interface OfferStageCreateWithoutTitleInput {
  id?: string ;
  description: TranslatedStringCreateOneWithoutOfferStageDescriptionInput;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
  items?: ItemCreateManyWithoutOfferStagesInput ;
  offer?: OfferCreateOneWithoutStagesInput ;
}

export interface OfferStageWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  title?: TranslatedStringWhereInput ;
  description?: TranslatedStringWhereInput ;
  discountRate?: number ;
  discountRate_not?: number ;
  discountRate_in?: number[] ;
  discountRate_not_in?: number[] ;
  discountRate_lt?: number ;
  discountRate_lte?: number ;
  discountRate_gt?: number ;
  discountRate_gte?: number ;
  discountType?: DISCOUNT_TYPE ;
  discountType_not?: DISCOUNT_TYPE ;
  discountType_in?: DISCOUNT_TYPE[] ;
  discountType_not_in?: DISCOUNT_TYPE[] ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  offer?: OfferWhereInput ;
  AND?: OfferStageWhereInput[] ;
  OR?: OfferStageWhereInput[] ;
  NOT?: OfferStageWhereInput[] ;
}

export interface OfferStageWhereUniqueInput {
  id?: string ;
}

export interface OfferTokenCreateManyWithoutOfferInput {
  create?: OfferTokenCreateWithoutOfferInput[] ;
  connect?: OfferTokenWhereUniqueInput[] ;
}

export interface OfferTokenCreateManyWithoutUserInput {
  create?: OfferTokenCreateWithoutUserInput[] ;
  connect?: OfferTokenWhereUniqueInput[] ;
}

export interface OfferTokenCreateOneWithoutAvailabilitiesInput {
  create?: OfferTokenCreateWithoutAvailabilitiesInput ;
  connect?: OfferTokenWhereUniqueInput ;
}

export interface OfferTokenCreateWithoutAvailabilitiesInput {
  id?: string ;
  offer?: OfferCreateOneWithoutTokensInput ;
  used?: boolean ;
  user?: UserCreateOneWithoutTokensInput ;
  expiresAt?: any ;
  singleUse?: boolean ;
  expired?: boolean ;
  activated?: boolean ;
  lifetime?: number ;
  deleteAt?: any ;
  deleted?: boolean ;
}

export interface OfferTokenCreateWithoutOfferInput {
  id?: string ;
  used?: boolean ;
  user?: UserCreateOneWithoutTokensInput ;
  expiresAt?: any ;
  singleUse?: boolean ;
  availabilities?: AvailabilityCreateManyWithoutOfferTokenInput ;
  expired?: boolean ;
  activated?: boolean ;
  lifetime?: number ;
  deleteAt?: any ;
  deleted?: boolean ;
}

export interface OfferTokenCreateWithoutUserInput {
  id?: string ;
  offer?: OfferCreateOneWithoutTokensInput ;
  used?: boolean ;
  expiresAt?: any ;
  singleUse?: boolean ;
  availabilities?: AvailabilityCreateManyWithoutOfferTokenInput ;
  expired?: boolean ;
  activated?: boolean ;
  lifetime?: number ;
  deleteAt?: any ;
  deleted?: boolean ;
}

export interface OfferTokenWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  offer?: OfferWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  used?: boolean ;
  used_not?: boolean ;
  user?: UserWhereInput ;
  expiresAt?: any ;
  expiresAt_not?: any ;
  expiresAt_in?: any[] ;
  expiresAt_not_in?: any[] ;
  expiresAt_lt?: any ;
  expiresAt_lte?: any ;
  expiresAt_gt?: any ;
  expiresAt_gte?: any ;
  singleUse?: boolean ;
  singleUse_not?: boolean ;
  availabilities_every?: AvailabilityWhereInput ;
  availabilities_some?: AvailabilityWhereInput ;
  availabilities_none?: AvailabilityWhereInput ;
  expired?: boolean ;
  expired_not?: boolean ;
  activated?: boolean ;
  activated_not?: boolean ;
  lifetime?: number ;
  lifetime_not?: number ;
  lifetime_in?: number[] ;
  lifetime_not_in?: number[] ;
  lifetime_lt?: number ;
  lifetime_lte?: number ;
  lifetime_gt?: number ;
  lifetime_gte?: number ;
  deleteAt?: any ;
  deleteAt_not?: any ;
  deleteAt_in?: any[] ;
  deleteAt_not_in?: any[] ;
  deleteAt_lt?: any ;
  deleteAt_lte?: any ;
  deleteAt_gt?: any ;
  deleteAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: OfferTokenWhereInput[] ;
  OR?: OfferTokenWhereInput[] ;
  NOT?: OfferTokenWhereInput[] ;
}

export interface OfferTokenWhereUniqueInput {
  id?: string ;
}

export interface OfferWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  description?: string ;
  description_not?: string ;
  description_in?: string[] ;
  description_not_in?: string[] ;
  description_lt?: string ;
  description_lte?: string ;
  description_gt?: string ;
  description_gte?: string ;
  description_contains?: string ;
  description_not_contains?: string ;
  description_starts_with?: string ;
  description_not_starts_with?: string ;
  description_ends_with?: string ;
  description_not_ends_with?: string ;
  descriptionLang?: TranslatedStringWhereInput ;
  orders_every?: OrderWhereInput ;
  orders_some?: OrderWhereInput ;
  orders_none?: OrderWhereInput ;
  ordersSingles_every?: OrderWhereInput ;
  ordersSingles_some?: OrderWhereInput ;
  ordersSingles_none?: OrderWhereInput ;
  image?: ImageWhereInput ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  uses_every?: OrderItemWhereInput ;
  uses_some?: OrderItemWhereInput ;
  uses_none?: OrderItemWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  nameLang?: TranslatedStringWhereInput ;
  price?: number ;
  price_not?: number ;
  price_in?: number[] ;
  price_not_in?: number[] ;
  price_lt?: number ;
  price_lte?: number ;
  price_gt?: number ;
  price_gte?: number ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  company?: CompanyWhereInput ;
  referralOfferForCompany_every?: CompanyWhereInput ;
  referralOfferForCompany_some?: CompanyWhereInput ;
  referralOfferForCompany_none?: CompanyWhereInput ;
  referrerOfferForCompany_every?: CompanyWhereInput ;
  referrerOfferForCompany_some?: CompanyWhereInput ;
  referrerOfferForCompany_none?: CompanyWhereInput ;
  default?: boolean ;
  default_not?: boolean ;
  stampCards_every?: StampCardWhereInput ;
  stampCards_some?: StampCardWhereInput ;
  stampCards_none?: StampCardWhereInput ;
  tokens_every?: OfferTokenWhereInput ;
  tokens_some?: OfferTokenWhereInput ;
  tokens_none?: OfferTokenWhereInput ;
  discountRate?: number ;
  discountRate_not?: number ;
  discountRate_in?: number[] ;
  discountRate_not_in?: number[] ;
  discountRate_lt?: number ;
  discountRate_lte?: number ;
  discountRate_gt?: number ;
  discountRate_gte?: number ;
  promoCodes_every?: PromoCodeWhereInput ;
  promoCodes_some?: PromoCodeWhereInput ;
  promoCodes_none?: PromoCodeWhereInput ;
  discountType?: DISCOUNT_TYPE ;
  discountType_not?: DISCOUNT_TYPE ;
  discountType_in?: DISCOUNT_TYPE[] ;
  discountType_not_in?: DISCOUNT_TYPE[] ;
  type?: OFFER_TYPE ;
  type_not?: OFFER_TYPE ;
  type_in?: OFFER_TYPE[] ;
  type_not_in?: OFFER_TYPE[] ;
  enabled?: boolean ;
  enabled_not?: boolean ;
  context?: OFFER_CONTEXT ;
  context_not?: OFFER_CONTEXT ;
  context_in?: OFFER_CONTEXT[] ;
  context_not_in?: OFFER_CONTEXT[] ;
  quality?: number ;
  quality_not?: number ;
  quality_in?: number[] ;
  quality_not_in?: number[] ;
  quality_lt?: number ;
  quality_lte?: number ;
  quality_gt?: number ;
  quality_gte?: number ;
  yieldEvents_every?: OfferYieldEventWhereInput ;
  yieldEvents_some?: OfferYieldEventWhereInput ;
  yieldEvents_none?: OfferYieldEventWhereInput ;
  singleUseDefault?: boolean ;
  singleUseDefault_not?: boolean ;
  stages_every?: OfferStageWhereInput ;
  stages_some?: OfferStageWhereInput ;
  stages_none?: OfferStageWhereInput ;
  venues_every?: VenueWhereInput ;
  venues_some?: VenueWhereInput ;
  venues_none?: VenueWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  categories_every?: CategoryWhereInput ;
  categories_some?: CategoryWhereInput ;
  categories_none?: CategoryWhereInput ;
  AND?: OfferWhereInput[] ;
  OR?: OfferWhereInput[] ;
  NOT?: OfferWhereInput[] ;
}

export interface OfferWhereUniqueInput {
  id?: string ;
}

export interface OfferYieldEventCreateManyWithoutCompanyInput {
  create?: OfferYieldEventCreateWithoutCompanyInput[] ;
  connect?: OfferYieldEventWhereUniqueInput[] ;
}

export interface OfferYieldEventCreateManyWithoutOfferInput {
  create?: OfferYieldEventCreateWithoutOfferInput[] ;
  connect?: OfferYieldEventWhereUniqueInput[] ;
}

export interface OfferYieldEventCreateManyWithoutSegmentsInput {
  create?: OfferYieldEventCreateWithoutSegmentsInput[] ;
  connect?: OfferYieldEventWhereUniqueInput[] ;
}

export interface OfferYieldEventCreateManyWithoutUsersInput {
  create?: OfferYieldEventCreateWithoutUsersInput[] ;
  connect?: OfferYieldEventWhereUniqueInput[] ;
}

export interface OfferYieldEventCreateOneWithoutNameInput {
  create?: OfferYieldEventCreateWithoutNameInput ;
  connect?: OfferYieldEventWhereUniqueInput ;
}

export interface OfferYieldEventCreateWithoutCompanyInput {
  id?: string ;
  deleted?: boolean ;
  name?: TranslatedStringCreateOneWithoutOfferYieldNameInput ;
  cron?: string ;
  yieldAt: any;
  shouldExpireAfter?: number ;
  hasYielded?: boolean ;
  yieldIfDuplicate?: boolean ;
  isRepeatable?: boolean ;
  notificationTitle?: string ;
  notificationBody?: string ;
  users?: UserCreateManyWithoutOfferYieldEventsInput ;
  segments?: UserSegmentCreateManyWithoutYieldEventsInput ;
  offer: OfferCreateOneWithoutYieldEventsInput;
}

export interface OfferYieldEventCreateWithoutNameInput {
  id?: string ;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutOfferYieldEventsInput;
  cron?: string ;
  yieldAt: any;
  shouldExpireAfter?: number ;
  hasYielded?: boolean ;
  yieldIfDuplicate?: boolean ;
  isRepeatable?: boolean ;
  notificationTitle?: string ;
  notificationBody?: string ;
  users?: UserCreateManyWithoutOfferYieldEventsInput ;
  segments?: UserSegmentCreateManyWithoutYieldEventsInput ;
  offer: OfferCreateOneWithoutYieldEventsInput;
}

export interface OfferYieldEventCreateWithoutOfferInput {
  id?: string ;
  deleted?: boolean ;
  name?: TranslatedStringCreateOneWithoutOfferYieldNameInput ;
  company: CompanyCreateOneWithoutOfferYieldEventsInput;
  cron?: string ;
  yieldAt: any;
  shouldExpireAfter?: number ;
  hasYielded?: boolean ;
  yieldIfDuplicate?: boolean ;
  isRepeatable?: boolean ;
  notificationTitle?: string ;
  notificationBody?: string ;
  users?: UserCreateManyWithoutOfferYieldEventsInput ;
  segments?: UserSegmentCreateManyWithoutYieldEventsInput ;
}

export interface OfferYieldEventCreateWithoutSegmentsInput {
  id?: string ;
  deleted?: boolean ;
  name?: TranslatedStringCreateOneWithoutOfferYieldNameInput ;
  company: CompanyCreateOneWithoutOfferYieldEventsInput;
  cron?: string ;
  yieldAt: any;
  shouldExpireAfter?: number ;
  hasYielded?: boolean ;
  yieldIfDuplicate?: boolean ;
  isRepeatable?: boolean ;
  notificationTitle?: string ;
  notificationBody?: string ;
  users?: UserCreateManyWithoutOfferYieldEventsInput ;
  offer: OfferCreateOneWithoutYieldEventsInput;
}

export interface OfferYieldEventCreateWithoutUsersInput {
  id?: string ;
  deleted?: boolean ;
  name?: TranslatedStringCreateOneWithoutOfferYieldNameInput ;
  company: CompanyCreateOneWithoutOfferYieldEventsInput;
  cron?: string ;
  yieldAt: any;
  shouldExpireAfter?: number ;
  hasYielded?: boolean ;
  yieldIfDuplicate?: boolean ;
  isRepeatable?: boolean ;
  notificationTitle?: string ;
  notificationBody?: string ;
  segments?: UserSegmentCreateManyWithoutYieldEventsInput ;
  offer: OfferCreateOneWithoutYieldEventsInput;
}

export interface OfferYieldEventWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  name?: TranslatedStringWhereInput ;
  company?: CompanyWhereInput ;
  cron?: string ;
  cron_not?: string ;
  cron_in?: string[] ;
  cron_not_in?: string[] ;
  cron_lt?: string ;
  cron_lte?: string ;
  cron_gt?: string ;
  cron_gte?: string ;
  cron_contains?: string ;
  cron_not_contains?: string ;
  cron_starts_with?: string ;
  cron_not_starts_with?: string ;
  cron_ends_with?: string ;
  cron_not_ends_with?: string ;
  yieldAt?: any ;
  yieldAt_not?: any ;
  yieldAt_in?: any[] ;
  yieldAt_not_in?: any[] ;
  yieldAt_lt?: any ;
  yieldAt_lte?: any ;
  yieldAt_gt?: any ;
  yieldAt_gte?: any ;
  shouldExpireAfter?: number ;
  shouldExpireAfter_not?: number ;
  shouldExpireAfter_in?: number[] ;
  shouldExpireAfter_not_in?: number[] ;
  shouldExpireAfter_lt?: number ;
  shouldExpireAfter_lte?: number ;
  shouldExpireAfter_gt?: number ;
  shouldExpireAfter_gte?: number ;
  hasYielded?: boolean ;
  hasYielded_not?: boolean ;
  yieldIfDuplicate?: boolean ;
  yieldIfDuplicate_not?: boolean ;
  isRepeatable?: boolean ;
  isRepeatable_not?: boolean ;
  notificationTitle?: string ;
  notificationTitle_not?: string ;
  notificationTitle_in?: string[] ;
  notificationTitle_not_in?: string[] ;
  notificationTitle_lt?: string ;
  notificationTitle_lte?: string ;
  notificationTitle_gt?: string ;
  notificationTitle_gte?: string ;
  notificationTitle_contains?: string ;
  notificationTitle_not_contains?: string ;
  notificationTitle_starts_with?: string ;
  notificationTitle_not_starts_with?: string ;
  notificationTitle_ends_with?: string ;
  notificationTitle_not_ends_with?: string ;
  notificationBody?: string ;
  notificationBody_not?: string ;
  notificationBody_in?: string[] ;
  notificationBody_not_in?: string[] ;
  notificationBody_lt?: string ;
  notificationBody_lte?: string ;
  notificationBody_gt?: string ;
  notificationBody_gte?: string ;
  notificationBody_contains?: string ;
  notificationBody_not_contains?: string ;
  notificationBody_starts_with?: string ;
  notificationBody_not_starts_with?: string ;
  notificationBody_ends_with?: string ;
  notificationBody_not_ends_with?: string ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  segments_every?: UserSegmentWhereInput ;
  segments_some?: UserSegmentWhereInput ;
  segments_none?: UserSegmentWhereInput ;
  offer?: OfferWhereInput ;
  AND?: OfferYieldEventWhereInput[] ;
  OR?: OfferYieldEventWhereInput[] ;
  NOT?: OfferYieldEventWhereInput[] ;
}

export interface OfferYieldEventWhereUniqueInput {
  id?: string ;
}

export interface OnboardingEventInput {
  companyId: string;
  name: ONBOARDING_EVENT_STEP;
}

export interface OrderCreateInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateManyWithoutDeliveryLocationInput {
  create?: OrderCreateWithoutDeliveryLocationInput[] ;
  connect?: OrderWhereUniqueInput[] ;
}

export interface OrderCreateManyWithoutFeesInput {
  create?: OrderCreateWithoutFeesInput[] ;
  connect?: OrderWhereUniqueInput[] ;
}

export interface OrderCreateManyWithoutInvoiceTargetInput {
  create?: OrderCreateWithoutInvoiceTargetInput[] ;
  connect?: OrderWhereUniqueInput[] ;
}

export interface OrderCreateManyWithoutOfferInput {
  create?: OrderCreateWithoutOfferInput[] ;
  connect?: OrderWhereUniqueInput[] ;
}

export interface OrderCreateManyWithoutOffersInput {
  create?: OrderCreateWithoutOffersInput[] ;
  connect?: OrderWhereUniqueInput[] ;
}

export interface OrderCreateManyWithoutTableInput {
  create?: OrderCreateWithoutTableInput[] ;
  connect?: OrderWhereUniqueInput[] ;
}

export interface OrderCreateManyWithoutUserInput {
  create?: OrderCreateWithoutUserInput[] ;
  connect?: OrderWhereUniqueInput[] ;
}

export interface OrderCreateManyWithoutVenueInput {
  create?: OrderCreateWithoutVenueInput[] ;
  connect?: OrderWhereUniqueInput[] ;
}

export interface OrderCreateOneInput {
  create?: OrderCreateInput ;
  connect?: OrderWhereUniqueInput ;
}

export interface OrderCreateOneWithoutItemsInput {
  create?: OrderCreateWithoutItemsInput ;
  connect?: OrderWhereUniqueInput ;
}

export interface OrderCreateOneWithoutPaymentInput {
  create?: OrderCreateWithoutPaymentInput ;
  connect?: OrderWhereUniqueInput ;
}

export interface OrderCreateWithoutDeliveryLocationInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutFeesInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutInvoiceTargetInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutItemsInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutOfferInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutOffersInput {
  claimed?: boolean ;
  creationDate?: any ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutPaymentInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutTableInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutUserInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutVenueInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderItemCreateInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemCreateManyWithoutEntryInput {
  create?: OrderItemCreateWithoutEntryInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
}

export interface OrderItemCreateManyWithoutOfferInput {
  create?: OrderItemCreateWithoutOfferInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
}

export interface OrderItemCreateManyWithoutOrderInput {
  create?: OrderItemCreateWithoutOrderInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
}

export interface OrderItemCreateManyWithoutRemovedVariationsInput {
  create?: OrderItemCreateWithoutRemovedVariationsInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
}

export interface OrderItemCreateManyWithoutSelectedForPaymentByUserInput {
  create?: OrderItemCreateWithoutSelectedForPaymentByUserInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
}

export interface OrderItemCreateManyWithoutSizeInput {
  create?: OrderItemCreateWithoutSizeInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
}

export interface OrderItemCreateManyWithoutTableSessionInput {
  create?: OrderItemCreateWithoutTableSessionInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
}

export interface OrderItemCreateManyWithoutVariationsInput {
  create?: OrderItemCreateWithoutVariationsInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
}

export interface OrderItemCreateOneInput {
  create?: OrderItemCreateInput ;
  connect?: OrderItemWhereUniqueInput ;
}

export interface OrderItemCreateOneWithoutPriceInput {
  create?: OrderItemCreateWithoutPriceInput ;
  connect?: OrderItemWhereUniqueInput ;
}

export interface OrderItemCreateWithoutEntryInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemCreateWithoutOfferInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemCreateWithoutOrderInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemCreateWithoutPriceInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemCreateWithoutRemovedVariationsInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemCreateWithoutSelectedForPaymentByUserInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
}

export interface OrderItemCreateWithoutSizeInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemCreateWithoutTableSessionInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemCreateWithoutVariationsInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  fraction?: number ;
  fraction_not?: number ;
  fraction_in?: number[] ;
  fraction_not_in?: number[] ;
  fraction_lt?: number ;
  fraction_lte?: number ;
  fraction_gt?: number ;
  fraction_gte?: number ;
  isRefunded?: boolean ;
  isRefunded_not?: boolean ;
  bundleId?: string ;
  bundleId_not?: string ;
  bundleId_in?: string[] ;
  bundleId_not_in?: string[] ;
  bundleId_lt?: string ;
  bundleId_lte?: string ;
  bundleId_gt?: string ;
  bundleId_gte?: string ;
  bundleId_contains?: string ;
  bundleId_not_contains?: string ;
  bundleId_starts_with?: string ;
  bundleId_not_starts_with?: string ;
  bundleId_ends_with?: string ;
  bundleId_not_ends_with?: string ;
  message?: string ;
  message_not?: string ;
  message_in?: string[] ;
  message_not_in?: string[] ;
  message_lt?: string ;
  message_lte?: string ;
  message_gt?: string ;
  message_gte?: string ;
  message_contains?: string ;
  message_not_contains?: string ;
  message_starts_with?: string ;
  message_not_starts_with?: string ;
  message_ends_with?: string ;
  message_not_ends_with?: string ;
  offer?: OfferWhereInput ;
  entry?: MenuEntryWhereInput ;
  size?: VariationWhereInput ;
  order?: OrderWhereInput ;
  variations_every?: VariationWhereInput ;
  variations_some?: VariationWhereInput ;
  variations_none?: VariationWhereInput ;
  removedVariations_every?: VariationWhereInput ;
  removedVariations_some?: VariationWhereInput ;
  removedVariations_none?: VariationWhereInput ;
  price?: PriceWhereInput ;
  tableSession?: TableSessionWhereInput ;
  selectedForPaymentByUser?: TablePaymentSettingWhereInput ;
  AND?: OrderItemWhereInput[] ;
  OR?: OrderItemWhereInput[] ;
  NOT?: OrderItemWhereInput[] ;
}

export interface OrderItemWhereUniqueInput {
  id?: string ;
}

export interface OrderWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  claimed?: boolean ;
  claimed_not?: boolean ;
  creationDate?: any ;
  creationDate_not?: any ;
  creationDate_in?: any[] ;
  creationDate_not_in?: any[] ;
  creationDate_lt?: any ;
  creationDate_lte?: any ;
  creationDate_gt?: any ;
  creationDate_gte?: any ;
  offers_every?: OfferWhereInput ;
  offers_some?: OfferWhereInput ;
  offers_none?: OfferWhereInput ;
  offer?: OfferWhereInput ;
  estimatedFinishTime?: string ;
  estimatedFinishTime_not?: string ;
  estimatedFinishTime_in?: string[] ;
  estimatedFinishTime_not_in?: string[] ;
  estimatedFinishTime_lt?: string ;
  estimatedFinishTime_lte?: string ;
  estimatedFinishTime_gt?: string ;
  estimatedFinishTime_gte?: string ;
  estimatedFinishTime_contains?: string ;
  estimatedFinishTime_not_contains?: string ;
  estimatedFinishTime_starts_with?: string ;
  estimatedFinishTime_not_starts_with?: string ;
  estimatedFinishTime_ends_with?: string ;
  estimatedFinishTime_not_ends_with?: string ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  easyId?: string ;
  easyId_not?: string ;
  easyId_in?: string[] ;
  easyId_not_in?: string[] ;
  easyId_lt?: string ;
  easyId_lte?: string ;
  easyId_gt?: string ;
  easyId_gte?: string ;
  easyId_contains?: string ;
  easyId_not_contains?: string ;
  easyId_starts_with?: string ;
  easyId_not_starts_with?: string ;
  easyId_ends_with?: string ;
  easyId_not_ends_with?: string ;
  items_every?: OrderItemWhereInput ;
  items_some?: OrderItemWhereInput ;
  items_none?: OrderItemWhereInput ;
  payment?: PaymentWhereInput ;
  rejectReason?: REJECT_REASON ;
  rejectReason_not?: REJECT_REASON ;
  rejectReason_in?: REJECT_REASON[] ;
  rejectReason_not_in?: REJECT_REASON[] ;
  status?: ORDER_STATUS ;
  status_not?: ORDER_STATUS ;
  status_in?: ORDER_STATUS[] ;
  status_not_in?: ORDER_STATUS[] ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  user?: UserWhereInput ;
  venue?: VenueWhereInput ;
  confirmed?: boolean ;
  confirmed_not?: boolean ;
  comment?: string ;
  comment_not?: string ;
  comment_in?: string[] ;
  comment_not_in?: string[] ;
  comment_lt?: string ;
  comment_lte?: string ;
  comment_gt?: string ;
  comment_gte?: string ;
  comment_contains?: string ;
  comment_not_contains?: string ;
  comment_starts_with?: string ;
  comment_not_starts_with?: string ;
  comment_ends_with?: string ;
  comment_not_ends_with?: string ;
  deliveryLocation?: LocationWhereInput ;
  type?: SERVICE_TYPE ;
  type_not?: SERVICE_TYPE ;
  type_in?: SERVICE_TYPE[] ;
  type_not_in?: SERVICE_TYPE[] ;
  fees_every?: FeeWhereInput ;
  fees_some?: FeeWhereInput ;
  fees_none?: FeeWhereInput ;
  updateToken?: string ;
  updateToken_not?: string ;
  updateToken_in?: string[] ;
  updateToken_not_in?: string[] ;
  updateToken_lt?: string ;
  updateToken_lte?: string ;
  updateToken_gt?: string ;
  updateToken_gte?: string ;
  updateToken_contains?: string ;
  updateToken_not_contains?: string ;
  updateToken_starts_with?: string ;
  updateToken_not_starts_with?: string ;
  updateToken_ends_with?: string ;
  updateToken_not_ends_with?: string ;
  desiredTime?: any ;
  desiredTime_not?: any ;
  desiredTime_in?: any[] ;
  desiredTime_not_in?: any[] ;
  desiredTime_lt?: any ;
  desiredTime_lte?: any ;
  desiredTime_gt?: any ;
  desiredTime_gte?: any ;
  remindTimer?: number ;
  remindTimer_not?: number ;
  remindTimer_in?: number[] ;
  remindTimer_not_in?: number[] ;
  remindTimer_lt?: number ;
  remindTimer_lte?: number ;
  remindTimer_gt?: number ;
  remindTimer_gte?: number ;
  reminded?: boolean ;
  reminded_not?: boolean ;
  basketToken?: string ;
  basketToken_not?: string ;
  basketToken_in?: string[] ;
  basketToken_not_in?: string[] ;
  basketToken_lt?: string ;
  basketToken_lte?: string ;
  basketToken_gt?: string ;
  basketToken_gte?: string ;
  basketToken_contains?: string ;
  basketToken_not_contains?: string ;
  basketToken_starts_with?: string ;
  basketToken_not_starts_with?: string ;
  basketToken_ends_with?: string ;
  basketToken_not_ends_with?: string ;
  isTableOrder?: boolean ;
  isTableOrder_not?: boolean ;
  table?: TableSessionWhereInput ;
  invoiceTarget?: InvoiceTargetWhereInput ;
  immediateInvoice?: boolean ;
  immediateInvoice_not?: boolean ;
  invoiceName?: string ;
  invoiceName_not?: string ;
  invoiceName_in?: string[] ;
  invoiceName_not_in?: string[] ;
  invoiceName_lt?: string ;
  invoiceName_lte?: string ;
  invoiceName_gt?: string ;
  invoiceName_gte?: string ;
  invoiceName_contains?: string ;
  invoiceName_not_contains?: string ;
  invoiceName_starts_with?: string ;
  invoiceName_not_starts_with?: string ;
  invoiceName_ends_with?: string ;
  invoiceName_not_ends_with?: string ;
  hasPrintedReceiptCopy?: boolean ;
  hasPrintedReceiptCopy_not?: boolean ;
  origin?: ORDER_ORIGIN ;
  origin_not?: ORDER_ORIGIN ;
  origin_in?: ORDER_ORIGIN[] ;
  origin_not_in?: ORDER_ORIGIN[] ;
  posDevice?: POSDeviceWhereInput ;
  posOrderUnique?: string ;
  posOrderUnique_not?: string ;
  posOrderUnique_in?: string[] ;
  posOrderUnique_not_in?: string[] ;
  posOrderUnique_lt?: string ;
  posOrderUnique_lte?: string ;
  posOrderUnique_gt?: string ;
  posOrderUnique_gte?: string ;
  posOrderUnique_contains?: string ;
  posOrderUnique_not_contains?: string ;
  posOrderUnique_starts_with?: string ;
  posOrderUnique_not_starts_with?: string ;
  posOrderUnique_ends_with?: string ;
  posOrderUnique_not_ends_with?: string ;
  zone?: ZoneWhereInput ;
  complianceId?: string ;
  complianceId_not?: string ;
  complianceId_in?: string[] ;
  complianceId_not_in?: string[] ;
  complianceId_lt?: string ;
  complianceId_lte?: string ;
  complianceId_gt?: string ;
  complianceId_gte?: string ;
  complianceId_contains?: string ;
  complianceId_not_contains?: string ;
  complianceId_starts_with?: string ;
  complianceId_not_starts_with?: string ;
  complianceId_ends_with?: string ;
  complianceId_not_ends_with?: string ;
  AND?: OrderWhereInput[] ;
  OR?: OrderWhereInput[] ;
  NOT?: OrderWhereInput[] ;
}

export interface OrderWhereUniqueInput {
  id?: string ;
  posOrderUnique?: string ;
}

export interface POSDeviceCreateInput {
  id?: string ;
  lastSeen?: any ;
  name: string;
  deviceOS?: string ;
  claimed?: boolean ;
  company?: CompanyCreateOneWithoutPosDevicesInput ;
  venue: VenueCreateOneWithoutPosDevicesInput;
}

export interface POSDeviceCreateManyWithoutCompanyInput {
  create?: POSDeviceCreateWithoutCompanyInput[] ;
  connect?: POSDeviceWhereUniqueInput[] ;
}

export interface POSDeviceCreateManyWithoutVenueInput {
  create?: POSDeviceCreateWithoutVenueInput[] ;
  connect?: POSDeviceWhereUniqueInput[] ;
}

export interface POSDeviceCreateOneInput {
  create?: POSDeviceCreateInput ;
  connect?: POSDeviceWhereUniqueInput ;
}

export interface POSDeviceCreateWithoutCompanyInput {
  id?: string ;
  lastSeen?: any ;
  name: string;
  deviceOS?: string ;
  claimed?: boolean ;
  venue: VenueCreateOneWithoutPosDevicesInput;
}

export interface POSDeviceCreateWithoutVenueInput {
  id?: string ;
  lastSeen?: any ;
  name: string;
  deviceOS?: string ;
  claimed?: boolean ;
  company?: CompanyCreateOneWithoutPosDevicesInput ;
}

export interface POSDeviceWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  lastSeen?: any ;
  lastSeen_not?: any ;
  lastSeen_in?: any[] ;
  lastSeen_not_in?: any[] ;
  lastSeen_lt?: any ;
  lastSeen_lte?: any ;
  lastSeen_gt?: any ;
  lastSeen_gte?: any ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  deviceOS?: string ;
  deviceOS_not?: string ;
  deviceOS_in?: string[] ;
  deviceOS_not_in?: string[] ;
  deviceOS_lt?: string ;
  deviceOS_lte?: string ;
  deviceOS_gt?: string ;
  deviceOS_gte?: string ;
  deviceOS_contains?: string ;
  deviceOS_not_contains?: string ;
  deviceOS_starts_with?: string ;
  deviceOS_not_starts_with?: string ;
  deviceOS_ends_with?: string ;
  deviceOS_not_ends_with?: string ;
  claimed?: boolean ;
  claimed_not?: boolean ;
  company?: CompanyWhereInput ;
  venue?: VenueWhereInput ;
  AND?: POSDeviceWhereInput[] ;
  OR?: POSDeviceWhereInput[] ;
  NOT?: POSDeviceWhereInput[] ;
}

export interface POSDeviceWhereUniqueInput {
  id?: string ;
}

export interface PageCreateManyWithoutCompanyInput {
  create?: PageCreateWithoutCompanyInput[] ;
  connect?: PageWhereUniqueInput[] ;
}

export interface PageCreateOneWithoutCategoryInput {
  create?: PageCreateWithoutCategoryInput ;
  connect?: PageWhereUniqueInput ;
}

export interface PageCreateOneWithoutNameInput {
  create?: PageCreateWithoutNameInput ;
  connect?: PageWhereUniqueInput ;
}

export interface PageCreateWithoutCategoryInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutPageInput;
  rows: number;
  columns: number;
  deleted?: boolean ;
  buttons?: PageCreatebuttonsInput ;
  company: CompanyCreateOneWithoutPagesInput;
}

export interface PageCreateWithoutCompanyInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutPageInput;
  rows: number;
  columns: number;
  deleted?: boolean ;
  category?: PosCategoryCreateOneWithoutPageInput ;
  buttons?: PageCreatebuttonsInput ;
}

export interface PageCreateWithoutNameInput {
  id?: string ;
  rows: number;
  columns: number;
  deleted?: boolean ;
  category?: PosCategoryCreateOneWithoutPageInput ;
  buttons?: PageCreatebuttonsInput ;
  company: CompanyCreateOneWithoutPagesInput;
}

export interface PageCreatebuttonsInput {
  set?: any[] ;
}

export interface PageWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: TranslatedStringWhereInput ;
  rows?: number ;
  rows_not?: number ;
  rows_in?: number[] ;
  rows_not_in?: number[] ;
  rows_lt?: number ;
  rows_lte?: number ;
  rows_gt?: number ;
  rows_gte?: number ;
  columns?: number ;
  columns_not?: number ;
  columns_in?: number[] ;
  columns_not_in?: number[] ;
  columns_lt?: number ;
  columns_lte?: number ;
  columns_gt?: number ;
  columns_gte?: number ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  category?: PosCategoryWhereInput ;
  company?: CompanyWhereInput ;
  AND?: PageWhereInput[] ;
  OR?: PageWhereInput[] ;
  NOT?: PageWhereInput[] ;
}

export interface PageWhereUniqueInput {
  id?: string ;
}

export interface PaymentCreateManyWithoutUserInput {
  create?: PaymentCreateWithoutUserInput[] ;
  connect?: PaymentWhereUniqueInput[] ;
}

export interface PaymentCreateOneWithoutCreditsTransactionsInput {
  create?: PaymentCreateWithoutCreditsTransactionsInput ;
  connect?: PaymentWhereUniqueInput ;
}

export interface PaymentCreateOneWithoutOrderInput {
  create?: PaymentCreateWithoutOrderInput ;
  connect?: PaymentWhereUniqueInput ;
}

export interface PaymentCreateOneWithoutPointsTransactionsInput {
  create?: PaymentCreateWithoutPointsTransactionsInput ;
  connect?: PaymentWhereUniqueInput ;
}

export interface PaymentCreateOneWithoutPosMetadataInput {
  create?: PaymentCreateWithoutPosMetadataInput ;
  connect?: PaymentWhereUniqueInput ;
}

export interface PaymentCreateOneWithoutTablePaymentInput {
  create?: PaymentCreateWithoutTablePaymentInput ;
  connect?: PaymentWhereUniqueInput ;
}

export interface PaymentCreateWithoutCreditsTransactionsInput {
  amount: number;
  pointsTransactions?: PointsTransactionCreateManyWithoutPaymentInput ;
  credits?: number ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  id?: string ;
  order?: OrderCreateOneWithoutPaymentInput ;
  status?: PAYMENT_STATUS ;
  user?: UserCreateOneWithoutPaymentsInput ;
  type?: string ;
  tablePayment?: TablePaymentSettingCreateOneWithoutPaymentInput ;
  posMetadata?: PosMetadataCreateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentCreateManyWithoutPaymentInput ;
  transactions?: TransactionCreateManyWithoutPaymentInput ;
}

export interface PaymentCreateWithoutOrderInput {
  amount: number;
  pointsTransactions?: PointsTransactionCreateManyWithoutPaymentInput ;
  credits?: number ;
  creditsTransactions?: CreditsTransactionCreateManyWithoutPaymentInput ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  id?: string ;
  status?: PAYMENT_STATUS ;
  user?: UserCreateOneWithoutPaymentsInput ;
  type?: string ;
  tablePayment?: TablePaymentSettingCreateOneWithoutPaymentInput ;
  posMetadata?: PosMetadataCreateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentCreateManyWithoutPaymentInput ;
  transactions?: TransactionCreateManyWithoutPaymentInput ;
}

export interface PaymentCreateWithoutPointsTransactionsInput {
  amount: number;
  credits?: number ;
  creditsTransactions?: CreditsTransactionCreateManyWithoutPaymentInput ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  id?: string ;
  order?: OrderCreateOneWithoutPaymentInput ;
  status?: PAYMENT_STATUS ;
  user?: UserCreateOneWithoutPaymentsInput ;
  type?: string ;
  tablePayment?: TablePaymentSettingCreateOneWithoutPaymentInput ;
  posMetadata?: PosMetadataCreateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentCreateManyWithoutPaymentInput ;
  transactions?: TransactionCreateManyWithoutPaymentInput ;
}

export interface PaymentCreateWithoutPosMetadataInput {
  amount: number;
  pointsTransactions?: PointsTransactionCreateManyWithoutPaymentInput ;
  credits?: number ;
  creditsTransactions?: CreditsTransactionCreateManyWithoutPaymentInput ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  id?: string ;
  order?: OrderCreateOneWithoutPaymentInput ;
  status?: PAYMENT_STATUS ;
  user?: UserCreateOneWithoutPaymentsInput ;
  type?: string ;
  tablePayment?: TablePaymentSettingCreateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentCreateManyWithoutPaymentInput ;
  transactions?: TransactionCreateManyWithoutPaymentInput ;
}

export interface PaymentCreateWithoutTablePaymentInput {
  amount: number;
  pointsTransactions?: PointsTransactionCreateManyWithoutPaymentInput ;
  credits?: number ;
  creditsTransactions?: CreditsTransactionCreateManyWithoutPaymentInput ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  id?: string ;
  order?: OrderCreateOneWithoutPaymentInput ;
  status?: PAYMENT_STATUS ;
  user?: UserCreateOneWithoutPaymentsInput ;
  type?: string ;
  posMetadata?: PosMetadataCreateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentCreateManyWithoutPaymentInput ;
  transactions?: TransactionCreateManyWithoutPaymentInput ;
}

export interface PaymentCreateWithoutUserInput {
  amount: number;
  pointsTransactions?: PointsTransactionCreateManyWithoutPaymentInput ;
  credits?: number ;
  creditsTransactions?: CreditsTransactionCreateManyWithoutPaymentInput ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  id?: string ;
  order?: OrderCreateOneWithoutPaymentInput ;
  status?: PAYMENT_STATUS ;
  type?: string ;
  tablePayment?: TablePaymentSettingCreateOneWithoutPaymentInput ;
  posMetadata?: PosMetadataCreateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentCreateManyWithoutPaymentInput ;
  transactions?: TransactionCreateManyWithoutPaymentInput ;
}

export interface PaymentMethodCreateManyWithoutCompanyInput {
  create?: PaymentMethodCreateWithoutCompanyInput[] ;
  connect?: PaymentMethodWhereUniqueInput[] ;
}

export interface PaymentMethodCreateManyWithoutVenueInput {
  create?: PaymentMethodCreateWithoutVenueInput[] ;
  connect?: PaymentMethodWhereUniqueInput[] ;
}

export interface PaymentMethodCreateWithoutCompanyInput {
  id?: string ;
  internalId: string;
  name: string;
  default?: boolean ;
  deleted?: boolean ;
  venue?: VenueCreateOneWithoutPaymentMethodsInput ;
}

export interface PaymentMethodCreateWithoutVenueInput {
  id?: string ;
  internalId: string;
  name: string;
  default?: boolean ;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutPaymentMethodsInput;
}

export interface PaymentMethodWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  internalId?: string ;
  internalId_not?: string ;
  internalId_in?: string[] ;
  internalId_not_in?: string[] ;
  internalId_lt?: string ;
  internalId_lte?: string ;
  internalId_gt?: string ;
  internalId_gte?: string ;
  internalId_contains?: string ;
  internalId_not_contains?: string ;
  internalId_starts_with?: string ;
  internalId_not_starts_with?: string ;
  internalId_ends_with?: string ;
  internalId_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  default?: boolean ;
  default_not?: boolean ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  company?: CompanyWhereInput ;
  venue?: VenueWhereInput ;
  AND?: PaymentMethodWhereInput[] ;
  OR?: PaymentMethodWhereInput[] ;
  NOT?: PaymentMethodWhereInput[] ;
}

export interface PaymentMethodWhereUniqueInput {
  id?: string ;
}

export interface PaymentWhereInput {
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  pointsTransactions_every?: PointsTransactionWhereInput ;
  pointsTransactions_some?: PointsTransactionWhereInput ;
  pointsTransactions_none?: PointsTransactionWhereInput ;
  credits?: number ;
  credits_not?: number ;
  credits_in?: number[] ;
  credits_not_in?: number[] ;
  credits_lt?: number ;
  credits_lte?: number ;
  credits_gt?: number ;
  credits_gte?: number ;
  creditsTransactions_every?: CreditsTransactionWhereInput ;
  creditsTransactions_some?: CreditsTransactionWhereInput ;
  creditsTransactions_none?: CreditsTransactionWhereInput ;
  yieldedCredits?: number ;
  yieldedCredits_not?: number ;
  yieldedCredits_in?: number[] ;
  yieldedCredits_not_in?: number[] ;
  yieldedCredits_lt?: number ;
  yieldedCredits_lte?: number ;
  yieldedCredits_gt?: number ;
  yieldedCredits_gte?: number ;
  tip?: number ;
  tip_not?: number ;
  tip_in?: number[] ;
  tip_not_in?: number[] ;
  tip_lt?: number ;
  tip_lte?: number ;
  tip_gt?: number ;
  tip_gte?: number ;
  correctedTip?: number ;
  correctedTip_not?: number ;
  correctedTip_in?: number[] ;
  correctedTip_not_in?: number[] ;
  correctedTip_lt?: number ;
  correctedTip_lte?: number ;
  correctedTip_gt?: number ;
  correctedTip_gte?: number ;
  refunded?: number ;
  refunded_not?: number ;
  refunded_in?: number[] ;
  refunded_not_in?: number[] ;
  refunded_lt?: number ;
  refunded_lte?: number ;
  refunded_gt?: number ;
  refunded_gte?: number ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  order?: OrderWhereInput ;
  status?: PAYMENT_STATUS ;
  status_not?: PAYMENT_STATUS ;
  status_in?: PAYMENT_STATUS[] ;
  status_not_in?: PAYMENT_STATUS[] ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  user?: UserWhereInput ;
  type?: string ;
  type_not?: string ;
  type_in?: string[] ;
  type_not_in?: string[] ;
  type_lt?: string ;
  type_lte?: string ;
  type_gt?: string ;
  type_gte?: string ;
  type_contains?: string ;
  type_not_contains?: string ;
  type_starts_with?: string ;
  type_not_starts_with?: string ;
  type_ends_with?: string ;
  type_not_ends_with?: string ;
  tablePayment?: TablePaymentSettingWhereInput ;
  posMetadata?: PosMetadataWhereInput ;
  transactionId?: string ;
  transactionId_not?: string ;
  transactionId_in?: string[] ;
  transactionId_not_in?: string[] ;
  transactionId_lt?: string ;
  transactionId_lte?: string ;
  transactionId_gt?: string ;
  transactionId_gte?: string ;
  transactionId_contains?: string ;
  transactionId_not_contains?: string ;
  transactionId_starts_with?: string ;
  transactionId_not_starts_with?: string ;
  transactionId_ends_with?: string ;
  transactionId_not_ends_with?: string ;
  subPayments_every?: SubPaymentWhereInput ;
  subPayments_some?: SubPaymentWhereInput ;
  subPayments_none?: SubPaymentWhereInput ;
  transactions_every?: TransactionWhereInput ;
  transactions_some?: TransactionWhereInput ;
  transactions_none?: TransactionWhereInput ;
  AND?: PaymentWhereInput[] ;
  OR?: PaymentWhereInput[] ;
  NOT?: PaymentWhereInput[] ;
}

export interface PaymentWhereUniqueInput {
  id?: string ;
}

export interface PointsTransactionCreateManyWithoutMembershipCardInput {
  create?: PointsTransactionCreateWithoutMembershipCardInput[] ;
  connect?: PointsTransactionWhereUniqueInput[] ;
}

export interface PointsTransactionCreateManyWithoutPaymentInput {
  create?: PointsTransactionCreateWithoutPaymentInput[] ;
  connect?: PointsTransactionWhereUniqueInput[] ;
}

export interface PointsTransactionCreateOneWithoutScanInput {
  create?: PointsTransactionCreateWithoutScanInput ;
  connect?: PointsTransactionWhereUniqueInput ;
}

export interface PointsTransactionCreateWithoutMembershipCardInput {
  id?: string ;
  amount: number;
  payment?: PaymentCreateOneWithoutPointsTransactionsInput ;
  scan?: ReceiptPointsScanCreateOneWithoutPointsTransactionInput ;
  source: POINTS_SOURCE_TYPE;
}

export interface PointsTransactionCreateWithoutPaymentInput {
  id?: string ;
  amount: number;
  membershipCard: MembershipCardCreateOneWithoutPointsTransactionsInput;
  scan?: ReceiptPointsScanCreateOneWithoutPointsTransactionInput ;
  source: POINTS_SOURCE_TYPE;
}

export interface PointsTransactionCreateWithoutScanInput {
  id?: string ;
  amount: number;
  membershipCard: MembershipCardCreateOneWithoutPointsTransactionsInput;
  payment?: PaymentCreateOneWithoutPointsTransactionsInput ;
  source: POINTS_SOURCE_TYPE;
}

export interface PointsTransactionWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  membershipCard?: MembershipCardWhereInput ;
  payment?: PaymentWhereInput ;
  scan?: ReceiptPointsScanWhereInput ;
  source?: POINTS_SOURCE_TYPE ;
  source_not?: POINTS_SOURCE_TYPE ;
  source_in?: POINTS_SOURCE_TYPE[] ;
  source_not_in?: POINTS_SOURCE_TYPE[] ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: PointsTransactionWhereInput[] ;
  OR?: PointsTransactionWhereInput[] ;
  NOT?: PointsTransactionWhereInput[] ;
}

export interface PointsTransactionWhereUniqueInput {
  id?: string ;
}

export interface PosCategoryCreateManyWithoutCompanyInput {
  create?: PosCategoryCreateWithoutCompanyInput[] ;
  connect?: PosCategoryWhereUniqueInput[] ;
}

export interface PosCategoryCreateManyWithoutLayoutInput {
  create?: PosCategoryCreateWithoutLayoutInput[] ;
  connect?: PosCategoryWhereUniqueInput[] ;
}

export interface PosCategoryCreateOneWithoutNameInput {
  create?: PosCategoryCreateWithoutNameInput ;
  connect?: PosCategoryWhereUniqueInput ;
}

export interface PosCategoryCreateOneWithoutPageInput {
  create?: PosCategoryCreateWithoutPageInput ;
  connect?: PosCategoryWhereUniqueInput ;
}

export interface PosCategoryCreateWithoutCompanyInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutPosCategoryInput;
  layout: LayoutCreateOneWithoutCategoriesInput;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  page: PageCreateOneWithoutCategoryInput;
}

export interface PosCategoryCreateWithoutLayoutInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutPosCategoryInput;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  page: PageCreateOneWithoutCategoryInput;
  company: CompanyCreateOneWithoutPosCategoriesInput;
}

export interface PosCategoryCreateWithoutNameInput {
  id?: string ;
  layout: LayoutCreateOneWithoutCategoriesInput;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  page: PageCreateOneWithoutCategoryInput;
  company: CompanyCreateOneWithoutPosCategoriesInput;
}

export interface PosCategoryCreateWithoutPageInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutPosCategoryInput;
  layout: LayoutCreateOneWithoutCategoriesInput;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutPosCategoriesInput;
}

export interface PosCategoryWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: TranslatedStringWhereInput ;
  layout?: LayoutWhereInput ;
  color?: string ;
  color_not?: string ;
  color_in?: string[] ;
  color_not_in?: string[] ;
  color_lt?: string ;
  color_lte?: string ;
  color_gt?: string ;
  color_gte?: string ;
  color_contains?: string ;
  color_not_contains?: string ;
  color_starts_with?: string ;
  color_not_starts_with?: string ;
  color_ends_with?: string ;
  color_not_ends_with?: string ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  page?: PageWhereInput ;
  company?: CompanyWhereInput ;
  AND?: PosCategoryWhereInput[] ;
  OR?: PosCategoryWhereInput[] ;
  NOT?: PosCategoryWhereInput[] ;
}

export interface PosCategoryWhereUniqueInput {
  id?: string ;
}

export interface PosMetadataCreateOneWithoutPaymentInput {
  create?: PosMetadataCreateWithoutPaymentInput ;
  connect?: PosMetadataWhereUniqueInput ;
}

export interface PosMetadataCreateOneWithoutTableSessionInput {
  create?: PosMetadataCreateWithoutTableSessionInput ;
  connect?: PosMetadataWhereUniqueInput ;
}

export interface PosMetadataCreateOneWithoutVenueInput {
  create?: PosMetadataCreateWithoutVenueInput ;
  connect?: PosMetadataWhereUniqueInput ;
}

export interface PosMetadataCreateWithoutPaymentInput {
  id?: string ;
  waiterId?: string ;
  staffId?: string ;
  originalAmount: number;
  discounts?: PosMetadataDiscountCreateManyWithoutPosMetadataInput ;
  currency?: CURRENCY ;
  venue?: VenueCreateOneWithoutPosMetadataInput ;
  paidAmount?: number ;
  tip?: number ;
  surcharge?: number ;
  tableSession?: TableSessionCreateOneWithoutPosMetadataInput ;
  terminalTransactions?: TerminalTransactionCreateManyWithoutPosMetadataInput ;
}

export interface PosMetadataCreateWithoutTableSessionInput {
  id?: string ;
  waiterId?: string ;
  staffId?: string ;
  originalAmount: number;
  discounts?: PosMetadataDiscountCreateManyWithoutPosMetadataInput ;
  currency?: CURRENCY ;
  venue?: VenueCreateOneWithoutPosMetadataInput ;
  payment: PaymentCreateOneWithoutPosMetadataInput;
  paidAmount?: number ;
  tip?: number ;
  surcharge?: number ;
  terminalTransactions?: TerminalTransactionCreateManyWithoutPosMetadataInput ;
}

export interface PosMetadataCreateWithoutVenueInput {
  id?: string ;
  waiterId?: string ;
  staffId?: string ;
  originalAmount: number;
  discounts?: PosMetadataDiscountCreateManyWithoutPosMetadataInput ;
  currency?: CURRENCY ;
  payment: PaymentCreateOneWithoutPosMetadataInput;
  paidAmount?: number ;
  tip?: number ;
  surcharge?: number ;
  tableSession?: TableSessionCreateOneWithoutPosMetadataInput ;
  terminalTransactions?: TerminalTransactionCreateManyWithoutPosMetadataInput ;
}

export interface PosMetadataDiscountCreateManyWithoutPosMetadataInput {
  create?: PosMetadataDiscountCreateWithoutPosMetadataInput[] ;
  connect?: PosMetadataDiscountWhereUniqueInput[] ;
}

export interface PosMetadataDiscountCreateWithoutPosMetadataInput {
  id?: string ;
  source: POS_DISCOUNT_SOURCE;
  discountRate: number;
  discountType?: DISCOUNT_TYPE ;
}

export interface PosMetadataDiscountWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  source?: POS_DISCOUNT_SOURCE ;
  source_not?: POS_DISCOUNT_SOURCE ;
  source_in?: POS_DISCOUNT_SOURCE[] ;
  source_not_in?: POS_DISCOUNT_SOURCE[] ;
  discountRate?: number ;
  discountRate_not?: number ;
  discountRate_in?: number[] ;
  discountRate_not_in?: number[] ;
  discountRate_lt?: number ;
  discountRate_lte?: number ;
  discountRate_gt?: number ;
  discountRate_gte?: number ;
  discountType?: DISCOUNT_TYPE ;
  discountType_not?: DISCOUNT_TYPE ;
  discountType_in?: DISCOUNT_TYPE[] ;
  discountType_not_in?: DISCOUNT_TYPE[] ;
  posMetadata?: PosMetadataWhereInput ;
  AND?: PosMetadataDiscountWhereInput[] ;
  OR?: PosMetadataDiscountWhereInput[] ;
  NOT?: PosMetadataDiscountWhereInput[] ;
}

export interface PosMetadataDiscountWhereUniqueInput {
  id?: string ;
}

export interface PosMetadataWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  waiterId?: string ;
  waiterId_not?: string ;
  waiterId_in?: string[] ;
  waiterId_not_in?: string[] ;
  waiterId_lt?: string ;
  waiterId_lte?: string ;
  waiterId_gt?: string ;
  waiterId_gte?: string ;
  waiterId_contains?: string ;
  waiterId_not_contains?: string ;
  waiterId_starts_with?: string ;
  waiterId_not_starts_with?: string ;
  waiterId_ends_with?: string ;
  waiterId_not_ends_with?: string ;
  staffId?: string ;
  staffId_not?: string ;
  staffId_in?: string[] ;
  staffId_not_in?: string[] ;
  staffId_lt?: string ;
  staffId_lte?: string ;
  staffId_gt?: string ;
  staffId_gte?: string ;
  staffId_contains?: string ;
  staffId_not_contains?: string ;
  staffId_starts_with?: string ;
  staffId_not_starts_with?: string ;
  staffId_ends_with?: string ;
  staffId_not_ends_with?: string ;
  originalAmount?: number ;
  originalAmount_not?: number ;
  originalAmount_in?: number[] ;
  originalAmount_not_in?: number[] ;
  originalAmount_lt?: number ;
  originalAmount_lte?: number ;
  originalAmount_gt?: number ;
  originalAmount_gte?: number ;
  discounts_every?: PosMetadataDiscountWhereInput ;
  discounts_some?: PosMetadataDiscountWhereInput ;
  discounts_none?: PosMetadataDiscountWhereInput ;
  currency?: CURRENCY ;
  currency_not?: CURRENCY ;
  currency_in?: CURRENCY[] ;
  currency_not_in?: CURRENCY[] ;
  venue?: VenueWhereInput ;
  payment?: PaymentWhereInput ;
  paidAmount?: number ;
  paidAmount_not?: number ;
  paidAmount_in?: number[] ;
  paidAmount_not_in?: number[] ;
  paidAmount_lt?: number ;
  paidAmount_lte?: number ;
  paidAmount_gt?: number ;
  paidAmount_gte?: number ;
  tip?: number ;
  tip_not?: number ;
  tip_in?: number[] ;
  tip_not_in?: number[] ;
  tip_lt?: number ;
  tip_lte?: number ;
  tip_gt?: number ;
  tip_gte?: number ;
  surcharge?: number ;
  surcharge_not?: number ;
  surcharge_in?: number[] ;
  surcharge_not_in?: number[] ;
  surcharge_lt?: number ;
  surcharge_lte?: number ;
  surcharge_gt?: number ;
  surcharge_gte?: number ;
  tableSession?: TableSessionWhereInput ;
  terminalTransactions_every?: TerminalTransactionWhereInput ;
  terminalTransactions_some?: TerminalTransactionWhereInput ;
  terminalTransactions_none?: TerminalTransactionWhereInput ;
  AND?: PosMetadataWhereInput[] ;
  OR?: PosMetadataWhereInput[] ;
  NOT?: PosMetadataWhereInput[] ;
}

export interface PosMetadataWhereUniqueInput {
  id?: string ;
}

export interface PosTerminalCreateManyWithoutCompanyInput {
  create?: PosTerminalCreateWithoutCompanyInput[] ;
  connect?: PosTerminalWhereUniqueInput[] ;
}

export interface PosTerminalCreateWithoutCompanyInput {
  id?: string ;
  terminal: string;
}

export interface PosTerminalWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  terminal?: string ;
  terminal_not?: string ;
  terminal_in?: string[] ;
  terminal_not_in?: string[] ;
  terminal_lt?: string ;
  terminal_lte?: string ;
  terminal_gt?: string ;
  terminal_gte?: string ;
  terminal_contains?: string ;
  terminal_not_contains?: string ;
  terminal_starts_with?: string ;
  terminal_not_starts_with?: string ;
  terminal_ends_with?: string ;
  terminal_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  AND?: PosTerminalWhereInput[] ;
  OR?: PosTerminalWhereInput[] ;
  NOT?: PosTerminalWhereInput[] ;
}

export interface PosTerminalWhereUniqueInput {
  id?: string ;
  terminal?: string ;
}

export interface PredefinedMessageCreateManyWithoutCompanyInput {
  create?: PredefinedMessageCreateWithoutCompanyInput[] ;
  connect?: PredefinedMessageWhereUniqueInput[] ;
}

export interface PredefinedMessageCreateManyWithoutVenueInput {
  create?: PredefinedMessageCreateWithoutVenueInput[] ;
  connect?: PredefinedMessageWhereUniqueInput[] ;
}

export interface PredefinedMessageCreateWithoutCompanyInput {
  id?: string ;
  message: string;
  type: string;
  deleted?: boolean ;
  venue: VenueCreateOneWithoutPredefinedMessagesInput;
}

export interface PredefinedMessageCreateWithoutVenueInput {
  id?: string ;
  message: string;
  type: string;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutPredefinedMessagesInput;
}

export interface PredefinedMessageWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  message?: string ;
  message_not?: string ;
  message_in?: string[] ;
  message_not_in?: string[] ;
  message_lt?: string ;
  message_lte?: string ;
  message_gt?: string ;
  message_gte?: string ;
  message_contains?: string ;
  message_not_contains?: string ;
  message_starts_with?: string ;
  message_not_starts_with?: string ;
  message_ends_with?: string ;
  message_not_ends_with?: string ;
  type?: string ;
  type_not?: string ;
  type_in?: string[] ;
  type_not_in?: string[] ;
  type_lt?: string ;
  type_lte?: string ;
  type_gt?: string ;
  type_gte?: string ;
  type_contains?: string ;
  type_not_contains?: string ;
  type_starts_with?: string ;
  type_not_starts_with?: string ;
  type_ends_with?: string ;
  type_not_ends_with?: string ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  company?: CompanyWhereInput ;
  venue?: VenueWhereInput ;
  AND?: PredefinedMessageWhereInput[] ;
  OR?: PredefinedMessageWhereInput[] ;
  NOT?: PredefinedMessageWhereInput[] ;
}

export interface PredefinedMessageWhereUniqueInput {
  id?: string ;
}

export interface PriceCreateOneWithoutFeeInput {
  create?: PriceCreateWithoutFeeInput ;
  connect?: PriceWhereUniqueInput ;
}

export interface PriceCreateOneWithoutOrderItemInput {
  create?: PriceCreateWithoutOrderItemInput ;
  connect?: PriceWhereUniqueInput ;
}

export interface PriceCreateWithoutFeeInput {
  amount: number;
  currency: string;
  discount: number;
  id?: string ;
  orderItem?: OrderItemCreateOneWithoutPriceInput ;
  percentageVAT: number;
  subtotal: number;
}

export interface PriceCreateWithoutOrderItemInput {
  amount: number;
  currency: string;
  discount: number;
  id?: string ;
  percentageVAT: number;
  subtotal: number;
  fee?: FeeCreateOneWithoutPriceInput ;
}

export interface PriceWhereInput {
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  currency?: string ;
  currency_not?: string ;
  currency_in?: string[] ;
  currency_not_in?: string[] ;
  currency_lt?: string ;
  currency_lte?: string ;
  currency_gt?: string ;
  currency_gte?: string ;
  currency_contains?: string ;
  currency_not_contains?: string ;
  currency_starts_with?: string ;
  currency_not_starts_with?: string ;
  currency_ends_with?: string ;
  currency_not_ends_with?: string ;
  discount?: number ;
  discount_not?: number ;
  discount_in?: number[] ;
  discount_not_in?: number[] ;
  discount_lt?: number ;
  discount_lte?: number ;
  discount_gt?: number ;
  discount_gte?: number ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  orderItem?: OrderItemWhereInput ;
  percentageVAT?: number ;
  percentageVAT_not?: number ;
  percentageVAT_in?: number[] ;
  percentageVAT_not_in?: number[] ;
  percentageVAT_lt?: number ;
  percentageVAT_lte?: number ;
  percentageVAT_gt?: number ;
  percentageVAT_gte?: number ;
  subtotal?: number ;
  subtotal_not?: number ;
  subtotal_in?: number[] ;
  subtotal_not_in?: number[] ;
  subtotal_lt?: number ;
  subtotal_lte?: number ;
  subtotal_gt?: number ;
  subtotal_gte?: number ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  fee?: FeeWhereInput ;
  AND?: PriceWhereInput[] ;
  OR?: PriceWhereInput[] ;
  NOT?: PriceWhereInput[] ;
}

export interface PriceWhereUniqueInput {
  id?: string ;
}

export interface PromoCodeCreateManyWithoutCompanyInput {
  create?: PromoCodeCreateWithoutCompanyInput[] ;
  connect?: PromoCodeWhereUniqueInput[] ;
}

export interface PromoCodeCreateManyWithoutMembershipLevelInput {
  create?: PromoCodeCreateWithoutMembershipLevelInput[] ;
  connect?: PromoCodeWhereUniqueInput[] ;
}

export interface PromoCodeCreateManyWithoutOfferInput {
  create?: PromoCodeCreateWithoutOfferInput[] ;
  connect?: PromoCodeWhereUniqueInput[] ;
}

export interface PromoCodeCreateManyWithoutUsersInput {
  create?: PromoCodeCreateWithoutUsersInput[] ;
  connect?: PromoCodeWhereUniqueInput[] ;
}

export interface PromoCodeCreateWithoutCompanyInput {
  id?: string ;
  offer?: OfferCreateOneWithoutPromoCodesInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutPromoCodesInput ;
  promoCode: string;
  users?: UserCreateManyWithoutPromoCodesInput ;
}

export interface PromoCodeCreateWithoutMembershipLevelInput {
  id?: string ;
  company?: CompanyCreateOneWithoutPromocodesInput ;
  offer?: OfferCreateOneWithoutPromoCodesInput ;
  promoCode: string;
  users?: UserCreateManyWithoutPromoCodesInput ;
}

export interface PromoCodeCreateWithoutOfferInput {
  id?: string ;
  company?: CompanyCreateOneWithoutPromocodesInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutPromoCodesInput ;
  promoCode: string;
  users?: UserCreateManyWithoutPromoCodesInput ;
}

export interface PromoCodeCreateWithoutUsersInput {
  id?: string ;
  company?: CompanyCreateOneWithoutPromocodesInput ;
  offer?: OfferCreateOneWithoutPromoCodesInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutPromoCodesInput ;
  promoCode: string;
}

export interface PromoCodeWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  company?: CompanyWhereInput ;
  offer?: OfferWhereInput ;
  membershipLevel?: MembershipLevelWhereInput ;
  promoCode?: string ;
  promoCode_not?: string ;
  promoCode_in?: string[] ;
  promoCode_not_in?: string[] ;
  promoCode_lt?: string ;
  promoCode_lte?: string ;
  promoCode_gt?: string ;
  promoCode_gte?: string ;
  promoCode_contains?: string ;
  promoCode_not_contains?: string ;
  promoCode_starts_with?: string ;
  promoCode_not_starts_with?: string ;
  promoCode_ends_with?: string ;
  promoCode_not_ends_with?: string ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  AND?: PromoCodeWhereInput[] ;
  OR?: PromoCodeWhereInput[] ;
  NOT?: PromoCodeWhereInput[] ;
}

export interface PromoCodeWhereUniqueInput {
  id?: string ;
}

export interface ReceiptPointsScanCreateManyWithoutUserInput {
  create?: ReceiptPointsScanCreateWithoutUserInput[] ;
  connect?: ReceiptPointsScanWhereUniqueInput[] ;
}

export interface ReceiptPointsScanCreateOneWithoutPointsTransactionInput {
  create?: ReceiptPointsScanCreateWithoutPointsTransactionInput ;
  connect?: ReceiptPointsScanWhereUniqueInput ;
}

export interface ReceiptPointsScanCreateWithoutPointsTransactionInput {
  id?: string ;
  receiptId: string;
  amount: number;
  verified?: boolean ;
  manual?: boolean ;
  rejected?: boolean ;
  user: UserCreateOneWithoutReceiptPointsScansInput;
}

export interface ReceiptPointsScanCreateWithoutUserInput {
  id?: string ;
  receiptId: string;
  amount: number;
  verified?: boolean ;
  manual?: boolean ;
  rejected?: boolean ;
  pointsTransaction?: PointsTransactionCreateOneWithoutScanInput ;
}

export interface ReceiptPointsScanWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  receiptId?: string ;
  receiptId_not?: string ;
  receiptId_in?: string[] ;
  receiptId_not_in?: string[] ;
  receiptId_lt?: string ;
  receiptId_lte?: string ;
  receiptId_gt?: string ;
  receiptId_gte?: string ;
  receiptId_contains?: string ;
  receiptId_not_contains?: string ;
  receiptId_starts_with?: string ;
  receiptId_not_starts_with?: string ;
  receiptId_ends_with?: string ;
  receiptId_not_ends_with?: string ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  verified?: boolean ;
  verified_not?: boolean ;
  manual?: boolean ;
  manual_not?: boolean ;
  rejected?: boolean ;
  rejected_not?: boolean ;
  pointsTransaction?: PointsTransactionWhereInput ;
  user?: UserWhereInput ;
  AND?: ReceiptPointsScanWhereInput[] ;
  OR?: ReceiptPointsScanWhereInput[] ;
  NOT?: ReceiptPointsScanWhereInput[] ;
}

export interface ReceiptPointsScanWhereUniqueInput {
  id?: string ;
}

export interface ReceiptTemplateCreateManyWithoutCompanyInput {
  create?: ReceiptTemplateCreateWithoutCompanyInput[] ;
  connect?: ReceiptTemplateWhereUniqueInput[] ;
}

export interface ReceiptTemplateCreateOneWithoutImageInput {
  create?: ReceiptTemplateCreateWithoutImageInput ;
  connect?: ReceiptTemplateWhereUniqueInput ;
}

export interface ReceiptTemplateCreateOneWithoutVenueInput {
  create?: ReceiptTemplateCreateWithoutVenueInput ;
  connect?: ReceiptTemplateWhereUniqueInput ;
}

export interface ReceiptTemplateCreateWithoutCompanyInput {
  id?: string ;
  name: string;
  image?: ImageCreateOneWithoutReceiptTemplateInput ;
  introLines?: ReceiptTemplateCreateintroLinesInput ;
  bottomLines?: ReceiptTemplateCreatebottomLinesInput ;
  venue?: VenueCreateOneWithoutReceiptTemplateInput ;
}

export interface ReceiptTemplateCreateWithoutImageInput {
  id?: string ;
  name: string;
  introLines?: ReceiptTemplateCreateintroLinesInput ;
  bottomLines?: ReceiptTemplateCreatebottomLinesInput ;
  company: CompanyCreateOneWithoutReceiptTemplateInput;
  venue?: VenueCreateOneWithoutReceiptTemplateInput ;
}

export interface ReceiptTemplateCreateWithoutVenueInput {
  id?: string ;
  name: string;
  image?: ImageCreateOneWithoutReceiptTemplateInput ;
  introLines?: ReceiptTemplateCreateintroLinesInput ;
  bottomLines?: ReceiptTemplateCreatebottomLinesInput ;
  company: CompanyCreateOneWithoutReceiptTemplateInput;
}

export interface ReceiptTemplateCreatebottomLinesInput {
  set?: string[] ;
}

export interface ReceiptTemplateCreateintroLinesInput {
  set?: string[] ;
}

export interface ReceiptTemplateWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  image?: ImageWhereInput ;
  company?: CompanyWhereInput ;
  venue?: VenueWhereInput ;
  AND?: ReceiptTemplateWhereInput[] ;
  OR?: ReceiptTemplateWhereInput[] ;
  NOT?: ReceiptTemplateWhereInput[] ;
}

export interface ReceiptTemplateWhereUniqueInput {
  id?: string ;
}

export interface RecommendationCreateManyWithoutItemInput {
  create?: RecommendationCreateWithoutItemInput[] ;
  connect?: RecommendationWhereUniqueInput[] ;
}

export interface RecommendationCreateManyWithoutUserInput {
  create?: RecommendationCreateWithoutUserInput[] ;
  connect?: RecommendationWhereUniqueInput[] ;
}

export interface RecommendationCreateManyWithoutVariationsInput {
  create?: RecommendationCreateWithoutVariationsInput[] ;
  connect?: RecommendationWhereUniqueInput[] ;
}

export interface RecommendationCreateWithoutItemInput {
  id?: string ;
  user?: UserCreateOneWithoutRecommendationsInput ;
  variations?: VariationCreateManyWithoutRecommendationsInput ;
}

export interface RecommendationCreateWithoutUserInput {
  id?: string ;
  item?: ItemCreateOneWithoutRecommendationsInput ;
  variations?: VariationCreateManyWithoutRecommendationsInput ;
}

export interface RecommendationCreateWithoutVariationsInput {
  id?: string ;
  item?: ItemCreateOneWithoutRecommendationsInput ;
  user?: UserCreateOneWithoutRecommendationsInput ;
}

export interface RecommendationWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  item?: ItemWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  user?: UserWhereInput ;
  variations_every?: VariationWhereInput ;
  variations_some?: VariationWhereInput ;
  variations_none?: VariationWhereInput ;
  AND?: RecommendationWhereInput[] ;
  OR?: RecommendationWhereInput[] ;
  NOT?: RecommendationWhereInput[] ;
}

export interface RecommendationWhereUniqueInput {
  id?: string ;
}

export interface RefundCreateOneWithoutTransactionsInput {
  create?: RefundCreateWithoutTransactionsInput ;
  connect?: RefundWhereUniqueInput ;
}

export interface RefundCreateWithoutTransactionsInput {
  id?: string ;
  fullRefund?: boolean ;
  tipRefund?: boolean ;
  refundDate?: any ;
  refundSum: number;
  order: OrderCreateOneInput;
  item?: OrderItemCreateOneInput ;
}

export interface RefundMultiPayTipsInput {
  subPaymentId: string;
  tipAmount: number;
}

export interface RefundSurfboardInput {
  paymentId: string;
  amount: number;
  reference: string;
}

export interface RefundWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  fullRefund?: boolean ;
  fullRefund_not?: boolean ;
  tipRefund?: boolean ;
  tipRefund_not?: boolean ;
  refundDate?: any ;
  refundDate_not?: any ;
  refundDate_in?: any[] ;
  refundDate_not_in?: any[] ;
  refundDate_lt?: any ;
  refundDate_lte?: any ;
  refundDate_gt?: any ;
  refundDate_gte?: any ;
  refundSum?: number ;
  refundSum_not?: number ;
  refundSum_in?: number[] ;
  refundSum_not_in?: number[] ;
  refundSum_lt?: number ;
  refundSum_lte?: number ;
  refundSum_gt?: number ;
  refundSum_gte?: number ;
  order?: OrderWhereInput ;
  item?: OrderItemWhereInput ;
  transactions_every?: TransactionWhereInput ;
  transactions_some?: TransactionWhereInput ;
  transactions_none?: TransactionWhereInput ;
  AND?: RefundWhereInput[] ;
  OR?: RefundWhereInput[] ;
  NOT?: RefundWhereInput[] ;
}

export interface RefundWhereUniqueInput {
  id?: string ;
}

export interface RegisterWasteInput {
  venueId: string;
  reason: string;
  comment?: string ;
  posDeviceId: string;
  items: WasteItemInput[];
  createdAt: any;
  staffId?: string ;
}

export interface ReportCreateManyWithoutVenueInput {
  create?: ReportCreateWithoutVenueInput[] ;
  connect?: ReportWhereUniqueInput[] ;
}

export interface ReportCreateWithoutVenueInput {
  id?: string ;
  type?: REPORT_TYPE ;
}

export interface ReportWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  venue?: VenueWhereInput ;
  type?: REPORT_TYPE ;
  type_not?: REPORT_TYPE ;
  type_in?: REPORT_TYPE[] ;
  type_not_in?: REPORT_TYPE[] ;
  AND?: ReportWhereInput[] ;
  OR?: ReportWhereInput[] ;
  NOT?: ReportWhereInput[] ;
}

export interface ReportWhereUniqueInput {
  id?: string ;
}

export interface ReportsServiceCategoryInput {
  id: string;
  name: string;
}

export interface ReservationCreateManyWithoutTableInput {
  create?: ReservationCreateWithoutTableInput[] ;
  connect?: ReservationWhereUniqueInput[] ;
}

export interface ReservationCreateManyWithoutUserInput {
  create?: ReservationCreateWithoutUserInput[] ;
  connect?: ReservationWhereUniqueInput[] ;
}

export interface ReservationCreateWithoutTableInput {
  id?: string ;
  from: any;
  to: any;
  user: UserCreateOneWithoutReservationsInput;
  data?: any ;
  comment?: string ;
  deleted?: boolean ;
}

export interface ReservationCreateWithoutUserInput {
  id?: string ;
  table?: TableCreateOneWithoutReservationsInput ;
  from: any;
  to: any;
  data?: any ;
  comment?: string ;
  deleted?: boolean ;
}

export interface ReservationWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  table?: TableWhereInput ;
  from?: any ;
  from_not?: any ;
  from_in?: any[] ;
  from_not_in?: any[] ;
  from_lt?: any ;
  from_lte?: any ;
  from_gt?: any ;
  from_gte?: any ;
  to?: any ;
  to_not?: any ;
  to_in?: any[] ;
  to_not_in?: any[] ;
  to_lt?: any ;
  to_lte?: any ;
  to_gt?: any ;
  to_gte?: any ;
  user?: UserWhereInput ;
  comment?: string ;
  comment_not?: string ;
  comment_in?: string[] ;
  comment_not_in?: string[] ;
  comment_lt?: string ;
  comment_lte?: string ;
  comment_gt?: string ;
  comment_gte?: string ;
  comment_contains?: string ;
  comment_not_contains?: string ;
  comment_starts_with?: string ;
  comment_not_starts_with?: string ;
  comment_ends_with?: string ;
  comment_not_ends_with?: string ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: ReservationWhereInput[] ;
  OR?: ReservationWhereInput[] ;
  NOT?: ReservationWhereInput[] ;
}

export interface ReservationWhereUniqueInput {
  id?: string ;
}

export interface SalesScoreInput {
  orderCount: number;
  itemCount: number;
  amount: number;
}

export interface SentNotificationCreateManyWithoutNotificationInput {
  create?: SentNotificationCreateWithoutNotificationInput[] ;
  connect?: SentNotificationWhereUniqueInput[] ;
}

export interface SentNotificationCreateManyWithoutUserInput {
  create?: SentNotificationCreateWithoutUserInput[] ;
  connect?: SentNotificationWhereUniqueInput[] ;
}

export interface SentNotificationCreateWithoutNotificationInput {
  id?: string ;
  user: UserCreateOneWithoutSentNotificationsInput;
  successful: boolean;
  sent: any;
  failed: any;
}

export interface SentNotificationCreateWithoutUserInput {
  id?: string ;
  notification: NotificationCreateOneWithoutSentNotificationsInput;
  successful: boolean;
  sent: any;
  failed: any;
}

export interface SentNotificationWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  user?: UserWhereInput ;
  notification?: NotificationWhereInput ;
  successful?: boolean ;
  successful_not?: boolean ;
  AND?: SentNotificationWhereInput[] ;
  OR?: SentNotificationWhereInput[] ;
  NOT?: SentNotificationWhereInput[] ;
}

export interface SentNotificationWhereUniqueInput {
  id?: string ;
}

export interface SocialMediaFeedCreateManyWithoutCompanyInput {
  create?: SocialMediaFeedCreateWithoutCompanyInput[] ;
  connect?: SocialMediaFeedWhereUniqueInput[] ;
}

export interface SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput {
  create?: SocialMediaFeedCreateWithoutSocialMediaCompanyInput[] ;
  connect?: SocialMediaFeedWhereUniqueInput[] ;
}

export interface SocialMediaFeedCreateWithoutCompanyInput {
  id?: string ;
  externalId: string;
  link: string;
  description?: string ;
  mediaType: string;
  mediaUrl?: string ;
  socialMediaCompany?: CompanyCreateOneWithoutSocialMediaFeedInput ;
  type?: SOCIAL_MEDIA ;
}

export interface SocialMediaFeedCreateWithoutSocialMediaCompanyInput {
  id?: string ;
  externalId: string;
  link: string;
  description?: string ;
  mediaType: string;
  mediaUrl?: string ;
  company?: CompanyCreateOneWithoutFeedInput ;
  type?: SOCIAL_MEDIA ;
}

export interface SocialMediaFeedWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  externalId?: string ;
  externalId_not?: string ;
  externalId_in?: string[] ;
  externalId_not_in?: string[] ;
  externalId_lt?: string ;
  externalId_lte?: string ;
  externalId_gt?: string ;
  externalId_gte?: string ;
  externalId_contains?: string ;
  externalId_not_contains?: string ;
  externalId_starts_with?: string ;
  externalId_not_starts_with?: string ;
  externalId_ends_with?: string ;
  externalId_not_ends_with?: string ;
  link?: string ;
  link_not?: string ;
  link_in?: string[] ;
  link_not_in?: string[] ;
  link_lt?: string ;
  link_lte?: string ;
  link_gt?: string ;
  link_gte?: string ;
  link_contains?: string ;
  link_not_contains?: string ;
  link_starts_with?: string ;
  link_not_starts_with?: string ;
  link_ends_with?: string ;
  link_not_ends_with?: string ;
  description?: string ;
  description_not?: string ;
  description_in?: string[] ;
  description_not_in?: string[] ;
  description_lt?: string ;
  description_lte?: string ;
  description_gt?: string ;
  description_gte?: string ;
  description_contains?: string ;
  description_not_contains?: string ;
  description_starts_with?: string ;
  description_not_starts_with?: string ;
  description_ends_with?: string ;
  description_not_ends_with?: string ;
  mediaType?: string ;
  mediaType_not?: string ;
  mediaType_in?: string[] ;
  mediaType_not_in?: string[] ;
  mediaType_lt?: string ;
  mediaType_lte?: string ;
  mediaType_gt?: string ;
  mediaType_gte?: string ;
  mediaType_contains?: string ;
  mediaType_not_contains?: string ;
  mediaType_starts_with?: string ;
  mediaType_not_starts_with?: string ;
  mediaType_ends_with?: string ;
  mediaType_not_ends_with?: string ;
  mediaUrl?: string ;
  mediaUrl_not?: string ;
  mediaUrl_in?: string[] ;
  mediaUrl_not_in?: string[] ;
  mediaUrl_lt?: string ;
  mediaUrl_lte?: string ;
  mediaUrl_gt?: string ;
  mediaUrl_gte?: string ;
  mediaUrl_contains?: string ;
  mediaUrl_not_contains?: string ;
  mediaUrl_starts_with?: string ;
  mediaUrl_not_starts_with?: string ;
  mediaUrl_ends_with?: string ;
  mediaUrl_not_ends_with?: string ;
  socialMediaCompany?: CompanyWhereInput ;
  company?: CompanyWhereInput ;
  type?: SOCIAL_MEDIA ;
  type_not?: SOCIAL_MEDIA ;
  type_in?: SOCIAL_MEDIA[] ;
  type_not_in?: SOCIAL_MEDIA[] ;
  AND?: SocialMediaFeedWhereInput[] ;
  OR?: SocialMediaFeedWhereInput[] ;
  NOT?: SocialMediaFeedWhereInput[] ;
}

export interface SocialMediaFeedWhereUniqueInput {
  id?: string ;
}

export interface StaffCreateInput {
  id?: string ;
  name: string;
  code: string;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutStaffsInput;
  accessLevel: AccessLevelCreateOneInput;
  expenses?: ExpenseCreateManyWithoutStaffInput ;
}

export interface StaffCreateManyWithoutCompanyInput {
  create?: StaffCreateWithoutCompanyInput[] ;
  connect?: StaffWhereUniqueInput[] ;
}

export interface StaffCreateOneInput {
  create?: StaffCreateInput ;
  connect?: StaffWhereUniqueInput ;
}

export interface StaffCreateOneWithoutExpensesInput {
  create?: StaffCreateWithoutExpensesInput ;
  connect?: StaffWhereUniqueInput ;
}

export interface StaffCreateWithoutCompanyInput {
  id?: string ;
  name: string;
  code: string;
  deleted?: boolean ;
  accessLevel: AccessLevelCreateOneInput;
  expenses?: ExpenseCreateManyWithoutStaffInput ;
}

export interface StaffCreateWithoutExpensesInput {
  id?: string ;
  name: string;
  code: string;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutStaffsInput;
  accessLevel: AccessLevelCreateOneInput;
}

export interface StaffWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  code?: string ;
  code_not?: string ;
  code_in?: string[] ;
  code_not_in?: string[] ;
  code_lt?: string ;
  code_lte?: string ;
  code_gt?: string ;
  code_gte?: string ;
  code_contains?: string ;
  code_not_contains?: string ;
  code_starts_with?: string ;
  code_not_starts_with?: string ;
  code_ends_with?: string ;
  code_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  company?: CompanyWhereInput ;
  accessLevel?: AccessLevelWhereInput ;
  expenses_every?: ExpenseWhereInput ;
  expenses_some?: ExpenseWhereInput ;
  expenses_none?: ExpenseWhereInput ;
  AND?: StaffWhereInput[] ;
  OR?: StaffWhereInput[] ;
  NOT?: StaffWhereInput[] ;
}

export interface StaffWhereUniqueInput {
  id?: string ;
}

export interface StampCardCreateManyWithoutCompanyInput {
  create?: StampCardCreateWithoutCompanyInput[] ;
  connect?: StampCardWhereUniqueInput[] ;
}

export interface StampCardCreateManyWithoutItemsInput {
  create?: StampCardCreateWithoutItemsInput[] ;
  connect?: StampCardWhereUniqueInput[] ;
}

export interface StampCardCreateManyWithoutOfferInput {
  create?: StampCardCreateWithoutOfferInput[] ;
  connect?: StampCardWhereUniqueInput[] ;
}

export interface StampCardCreateManyWithoutUsersInput {
  create?: StampCardCreateWithoutUsersInput[] ;
  connect?: StampCardWhereUniqueInput[] ;
}

export interface StampCardCreateManyWithoutVenuesInput {
  create?: StampCardCreateWithoutVenuesInput[] ;
  connect?: StampCardWhereUniqueInput[] ;
}

export interface StampCardCreateOneWithoutDescriptionLangInput {
  create?: StampCardCreateWithoutDescriptionLangInput ;
  connect?: StampCardWhereUniqueInput ;
}

export interface StampCardCreateOneWithoutDetailsInput {
  create?: StampCardCreateWithoutDetailsInput ;
  connect?: StampCardWhereUniqueInput ;
}

export interface StampCardCreateOneWithoutNameLangInput {
  create?: StampCardCreateWithoutNameLangInput ;
  connect?: StampCardWhereUniqueInput ;
}

export interface StampCardCreateOneWithoutStampsInput {
  create?: StampCardCreateWithoutStampsInput ;
  connect?: StampCardWhereUniqueInput ;
}

export interface StampCardCreateWithoutCompanyInput {
  count: number;
  id?: string ;
  items?: ItemCreateManyWithoutStampCardsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringCreateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringCreateOneWithoutStampCardDetailsInput ;
  stamps?: StampCreateManyWithoutStampCardInput ;
  users?: UserCreateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueCreateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferCreateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardCreateWithoutDescriptionLangInput {
  company?: CompanyCreateOneWithoutStampCardsInput ;
  count: number;
  id?: string ;
  items?: ItemCreateManyWithoutStampCardsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutStampCardNameInput ;
  details?: TranslatedStringCreateOneWithoutStampCardDetailsInput ;
  stamps?: StampCreateManyWithoutStampCardInput ;
  users?: UserCreateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueCreateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferCreateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardCreateWithoutDetailsInput {
  company?: CompanyCreateOneWithoutStampCardsInput ;
  count: number;
  id?: string ;
  items?: ItemCreateManyWithoutStampCardsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringCreateOneWithoutStampcardDescriptionInput ;
  stamps?: StampCreateManyWithoutStampCardInput ;
  users?: UserCreateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueCreateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferCreateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardCreateWithoutItemsInput {
  company?: CompanyCreateOneWithoutStampCardsInput ;
  count: number;
  id?: string ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringCreateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringCreateOneWithoutStampCardDetailsInput ;
  stamps?: StampCreateManyWithoutStampCardInput ;
  users?: UserCreateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueCreateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferCreateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardCreateWithoutNameLangInput {
  company?: CompanyCreateOneWithoutStampCardsInput ;
  count: number;
  id?: string ;
  items?: ItemCreateManyWithoutStampCardsInput ;
  name: string;
  descriptionLang?: TranslatedStringCreateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringCreateOneWithoutStampCardDetailsInput ;
  stamps?: StampCreateManyWithoutStampCardInput ;
  users?: UserCreateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueCreateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferCreateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardCreateWithoutOfferInput {
  company?: CompanyCreateOneWithoutStampCardsInput ;
  count: number;
  id?: string ;
  items?: ItemCreateManyWithoutStampCardsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringCreateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringCreateOneWithoutStampCardDetailsInput ;
  stamps?: StampCreateManyWithoutStampCardInput ;
  users?: UserCreateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueCreateManyWithoutStampCardsInput ;
  default?: boolean ;
  icon?: string ;
}

export interface StampCardCreateWithoutStampsInput {
  company?: CompanyCreateOneWithoutStampCardsInput ;
  count: number;
  id?: string ;
  items?: ItemCreateManyWithoutStampCardsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringCreateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringCreateOneWithoutStampCardDetailsInput ;
  users?: UserCreateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueCreateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferCreateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardCreateWithoutUsersInput {
  company?: CompanyCreateOneWithoutStampCardsInput ;
  count: number;
  id?: string ;
  items?: ItemCreateManyWithoutStampCardsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringCreateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringCreateOneWithoutStampCardDetailsInput ;
  stamps?: StampCreateManyWithoutStampCardInput ;
  deleted?: boolean ;
  venues?: VenueCreateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferCreateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardCreateWithoutVenuesInput {
  company?: CompanyCreateOneWithoutStampCardsInput ;
  count: number;
  id?: string ;
  items?: ItemCreateManyWithoutStampCardsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringCreateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringCreateOneWithoutStampCardDetailsInput ;
  stamps?: StampCreateManyWithoutStampCardInput ;
  users?: UserCreateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  default?: boolean ;
  offer?: OfferCreateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardWhereInput {
  company?: CompanyWhereInput ;
  count?: number ;
  count_not?: number ;
  count_in?: number[] ;
  count_not_in?: number[] ;
  count_lt?: number ;
  count_lte?: number ;
  count_gt?: number ;
  count_gte?: number ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  nameLang?: TranslatedStringWhereInput ;
  descriptionLang?: TranslatedStringWhereInput ;
  details?: TranslatedStringWhereInput ;
  stamps_every?: StampWhereInput ;
  stamps_some?: StampWhereInput ;
  stamps_none?: StampWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  venues_every?: VenueWhereInput ;
  venues_some?: VenueWhereInput ;
  venues_none?: VenueWhereInput ;
  default?: boolean ;
  default_not?: boolean ;
  offer?: OfferWhereInput ;
  icon?: string ;
  icon_not?: string ;
  icon_in?: string[] ;
  icon_not_in?: string[] ;
  icon_lt?: string ;
  icon_lte?: string ;
  icon_gt?: string ;
  icon_gte?: string ;
  icon_contains?: string ;
  icon_not_contains?: string ;
  icon_starts_with?: string ;
  icon_not_starts_with?: string ;
  icon_ends_with?: string ;
  icon_not_ends_with?: string ;
  AND?: StampCardWhereInput[] ;
  OR?: StampCardWhereInput[] ;
  NOT?: StampCardWhereInput[] ;
}

export interface StampCardWhereUniqueInput {
  id?: string ;
}

export interface StampCreateManyWithoutStampCardInput {
  create?: StampCreateWithoutStampCardInput[] ;
  connect?: StampWhereUniqueInput[] ;
}

export interface StampCreateManyWithoutUserInput {
  create?: StampCreateWithoutUserInput[] ;
  connect?: StampWhereUniqueInput[] ;
}

export interface StampCreateWithoutStampCardInput {
  id?: string ;
  seen?: boolean ;
  user?: UserCreateOneWithoutStampsInput ;
}

export interface StampCreateWithoutUserInput {
  id?: string ;
  seen?: boolean ;
  stampCard?: StampCardCreateOneWithoutStampsInput ;
}

export interface StampWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  seen?: boolean ;
  seen_not?: boolean ;
  stampCard?: StampCardWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  user?: UserWhereInput ;
  AND?: StampWhereInput[] ;
  OR?: StampWhereInput[] ;
  NOT?: StampWhereInput[] ;
}

export interface StampWhereUniqueInput {
  id?: string ;
}

export interface StationCreateManyWithoutCategoriesInput {
  create?: StationCreateWithoutCategoriesInput[] ;
  connect?: StationWhereUniqueInput[] ;
}

export interface StationCreateManyWithoutCompanyInput {
  create?: StationCreateWithoutCompanyInput[] ;
  connect?: StationWhereUniqueInput[] ;
}

export interface StationCreateManyWithoutItemsInput {
  create?: StationCreateWithoutItemsInput[] ;
  connect?: StationWhereUniqueInput[] ;
}

export interface StationCreateWithoutCategoriesInput {
  id?: string ;
  name: string;
  company: CompanyCreateOneWithoutStationsInput;
  items?: ItemCreateManyWithoutStationsInput ;
  orderStatuses?: StationCreateorderStatusesInput ;
  deleted?: boolean ;
  showAllItems?: boolean ;
  type?: STATION_TYPE ;
  origin?: StationCreateoriginInput ;
  serviceType?: StationCreateserviceTypeInput ;
}

export interface StationCreateWithoutCompanyInput {
  id?: string ;
  name: string;
  items?: ItemCreateManyWithoutStationsInput ;
  categories?: CategoryCreateManyWithoutStationsInput ;
  orderStatuses?: StationCreateorderStatusesInput ;
  deleted?: boolean ;
  showAllItems?: boolean ;
  type?: STATION_TYPE ;
  origin?: StationCreateoriginInput ;
  serviceType?: StationCreateserviceTypeInput ;
}

export interface StationCreateWithoutItemsInput {
  id?: string ;
  name: string;
  company: CompanyCreateOneWithoutStationsInput;
  categories?: CategoryCreateManyWithoutStationsInput ;
  orderStatuses?: StationCreateorderStatusesInput ;
  deleted?: boolean ;
  showAllItems?: boolean ;
  type?: STATION_TYPE ;
  origin?: StationCreateoriginInput ;
  serviceType?: StationCreateserviceTypeInput ;
}

export interface StationCreateorderStatusesInput {
  set?: ORDER_STATUS[] ;
}

export interface StationCreateoriginInput {
  set?: ORDER_ORIGIN[] ;
}

export interface StationCreateserviceTypeInput {
  set?: SERVICE_TYPE[] ;
}

export interface StationWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  categories_every?: CategoryWhereInput ;
  categories_some?: CategoryWhereInput ;
  categories_none?: CategoryWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  showAllItems?: boolean ;
  showAllItems_not?: boolean ;
  type?: STATION_TYPE ;
  type_not?: STATION_TYPE ;
  type_in?: STATION_TYPE[] ;
  type_not_in?: STATION_TYPE[] ;
  AND?: StationWhereInput[] ;
  OR?: StationWhereInput[] ;
  NOT?: StationWhereInput[] ;
}

export interface StationWhereUniqueInput {
  id?: string ;
}

export interface SubPaymentCreateManyWithoutPaymentInput {
  create?: SubPaymentCreateWithoutPaymentInput[] ;
  connect?: SubPaymentWhereUniqueInput[] ;
}

export interface SubPaymentCreateWithoutPaymentInput {
  id?: string ;
  refunded?: number ;
  amount: number;
  status?: PAYMENT_STATUS ;
  tip?: number ;
  correctedTip?: number ;
  type: string;
  transactionId?: string ;
}

export interface SubPaymentInput {
  amount: number;
  status?: PAYMENT_STATUS ;
  type: string;
  tip?: number ;
  transactionId?: string ;
}

export interface SubPaymentWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  refunded?: number ;
  refunded_not?: number ;
  refunded_in?: number[] ;
  refunded_not_in?: number[] ;
  refunded_lt?: number ;
  refunded_lte?: number ;
  refunded_gt?: number ;
  refunded_gte?: number ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  payment?: PaymentWhereInput ;
  status?: PAYMENT_STATUS ;
  status_not?: PAYMENT_STATUS ;
  status_in?: PAYMENT_STATUS[] ;
  status_not_in?: PAYMENT_STATUS[] ;
  tip?: number ;
  tip_not?: number ;
  tip_in?: number[] ;
  tip_not_in?: number[] ;
  tip_lt?: number ;
  tip_lte?: number ;
  tip_gt?: number ;
  tip_gte?: number ;
  correctedTip?: number ;
  correctedTip_not?: number ;
  correctedTip_in?: number[] ;
  correctedTip_not_in?: number[] ;
  correctedTip_lt?: number ;
  correctedTip_lte?: number ;
  correctedTip_gt?: number ;
  correctedTip_gte?: number ;
  type?: string ;
  type_not?: string ;
  type_in?: string[] ;
  type_not_in?: string[] ;
  type_lt?: string ;
  type_lte?: string ;
  type_gt?: string ;
  type_gte?: string ;
  type_contains?: string ;
  type_not_contains?: string ;
  type_starts_with?: string ;
  type_not_starts_with?: string ;
  type_ends_with?: string ;
  type_not_ends_with?: string ;
  transactionId?: string ;
  transactionId_not?: string ;
  transactionId_in?: string[] ;
  transactionId_not_in?: string[] ;
  transactionId_lt?: string ;
  transactionId_lte?: string ;
  transactionId_gt?: string ;
  transactionId_gte?: string ;
  transactionId_contains?: string ;
  transactionId_not_contains?: string ;
  transactionId_starts_with?: string ;
  transactionId_not_starts_with?: string ;
  transactionId_ends_with?: string ;
  transactionId_not_ends_with?: string ;
  AND?: SubPaymentWhereInput[] ;
  OR?: SubPaymentWhereInput[] ;
  NOT?: SubPaymentWhereInput[] ;
}

export interface SubPaymentWhereUniqueInput {
  id?: string ;
}

export interface SurfboardOrderInput {
  reference: string;
  venueId: string;
  terminalId?: string ;
}

export interface SurfboardPaymentInput {
  orderId: string;
  amount: number;
}

export interface TableCreateInput {
  id?: string ;
  deleted?: boolean ;
  venue: VenueCreateOneWithoutTablesInput;
  floorPlan?: FloorPlanCreateOneWithoutTablesInput ;
  reservations?: ReservationCreateManyWithoutTableInput ;
  sessions?: TableSessionCreateManyWithoutTableInput ;
  session?: TableSessionCreateOneWithoutTableActiveInput ;
  users?: UserCreateManyWithoutTableInput ;
  code: string;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableCreateManyInput {
  create?: TableCreateInput[] ;
  connect?: TableWhereUniqueInput[] ;
}

export interface TableCreateManyWithoutFloorPlanInput {
  create?: TableCreateWithoutFloorPlanInput[] ;
  connect?: TableWhereUniqueInput[] ;
}

export interface TableCreateManyWithoutVenueInput {
  create?: TableCreateWithoutVenueInput[] ;
  connect?: TableWhereUniqueInput[] ;
}

export interface TableCreateOneWithoutReservationsInput {
  create?: TableCreateWithoutReservationsInput ;
  connect?: TableWhereUniqueInput ;
}

export interface TableCreateOneWithoutSessionInput {
  create?: TableCreateWithoutSessionInput ;
  connect?: TableWhereUniqueInput ;
}

export interface TableCreateOneWithoutSessionsInput {
  create?: TableCreateWithoutSessionsInput ;
  connect?: TableWhereUniqueInput ;
}

export interface TableCreateOneWithoutUsersInput {
  create?: TableCreateWithoutUsersInput ;
  connect?: TableWhereUniqueInput ;
}

export interface TableCreateWithoutFloorPlanInput {
  id?: string ;
  deleted?: boolean ;
  venue: VenueCreateOneWithoutTablesInput;
  reservations?: ReservationCreateManyWithoutTableInput ;
  sessions?: TableSessionCreateManyWithoutTableInput ;
  session?: TableSessionCreateOneWithoutTableActiveInput ;
  users?: UserCreateManyWithoutTableInput ;
  code: string;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableCreateWithoutReservationsInput {
  id?: string ;
  deleted?: boolean ;
  venue: VenueCreateOneWithoutTablesInput;
  floorPlan?: FloorPlanCreateOneWithoutTablesInput ;
  sessions?: TableSessionCreateManyWithoutTableInput ;
  session?: TableSessionCreateOneWithoutTableActiveInput ;
  users?: UserCreateManyWithoutTableInput ;
  code: string;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableCreateWithoutSessionInput {
  id?: string ;
  deleted?: boolean ;
  venue: VenueCreateOneWithoutTablesInput;
  floorPlan?: FloorPlanCreateOneWithoutTablesInput ;
  reservations?: ReservationCreateManyWithoutTableInput ;
  sessions?: TableSessionCreateManyWithoutTableInput ;
  users?: UserCreateManyWithoutTableInput ;
  code: string;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableCreateWithoutSessionsInput {
  id?: string ;
  deleted?: boolean ;
  venue: VenueCreateOneWithoutTablesInput;
  floorPlan?: FloorPlanCreateOneWithoutTablesInput ;
  reservations?: ReservationCreateManyWithoutTableInput ;
  session?: TableSessionCreateOneWithoutTableActiveInput ;
  users?: UserCreateManyWithoutTableInput ;
  code: string;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableCreateWithoutUsersInput {
  id?: string ;
  deleted?: boolean ;
  venue: VenueCreateOneWithoutTablesInput;
  floorPlan?: FloorPlanCreateOneWithoutTablesInput ;
  reservations?: ReservationCreateManyWithoutTableInput ;
  sessions?: TableSessionCreateManyWithoutTableInput ;
  session?: TableSessionCreateOneWithoutTableActiveInput ;
  code: string;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableCreateWithoutVenueInput {
  id?: string ;
  deleted?: boolean ;
  floorPlan?: FloorPlanCreateOneWithoutTablesInput ;
  reservations?: ReservationCreateManyWithoutTableInput ;
  sessions?: TableSessionCreateManyWithoutTableInput ;
  session?: TableSessionCreateOneWithoutTableActiveInput ;
  users?: UserCreateManyWithoutTableInput ;
  code: string;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableLogInput {
  eventId: string;
  title: string;
  message?: string ;
  staffId?: string ;
  tableId?: string ;
  chequeId: string;
}

export interface TablePaymentSettingCreateManyWithoutTableSessionInput {
  create?: TablePaymentSettingCreateWithoutTableSessionInput[] ;
  connect?: TablePaymentSettingWhereUniqueInput[] ;
}

export interface TablePaymentSettingCreateManyWithoutUserInput {
  create?: TablePaymentSettingCreateWithoutUserInput[] ;
  connect?: TablePaymentSettingWhereUniqueInput[] ;
}

export interface TablePaymentSettingCreateOneWithoutPaymentInput {
  create?: TablePaymentSettingCreateWithoutPaymentInput ;
  connect?: TablePaymentSettingWhereUniqueInput ;
}

export interface TablePaymentSettingCreateOneWithoutSelectedItemsInput {
  create?: TablePaymentSettingCreateWithoutSelectedItemsInput ;
  connect?: TablePaymentSettingWhereUniqueInput ;
}

export interface TablePaymentSettingCreateOneWithoutUserActiveInput {
  create?: TablePaymentSettingCreateWithoutUserActiveInput ;
  connect?: TablePaymentSettingWhereUniqueInput ;
}

export interface TablePaymentSettingCreateWithoutPaymentInput {
  id?: string ;
  userActive?: UserCreateOneWithoutTablePaymentSettingsInput ;
  user: UserCreateOneWithoutTablePaymentSettingsHistoryInput;
  tableSession: TableSessionCreateOneWithoutUserPaymentSettingsInput;
  paymentMethod: string;
  tip?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
  selectedItems?: OrderItemCreateManyWithoutSelectedForPaymentByUserInput ;
}

export interface TablePaymentSettingCreateWithoutSelectedItemsInput {
  id?: string ;
  userActive?: UserCreateOneWithoutTablePaymentSettingsInput ;
  user: UserCreateOneWithoutTablePaymentSettingsHistoryInput;
  tableSession: TableSessionCreateOneWithoutUserPaymentSettingsInput;
  paymentMethod: string;
  payment?: PaymentCreateOneWithoutTablePaymentInput ;
  tip?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
}

export interface TablePaymentSettingCreateWithoutTableSessionInput {
  id?: string ;
  userActive?: UserCreateOneWithoutTablePaymentSettingsInput ;
  user: UserCreateOneWithoutTablePaymentSettingsHistoryInput;
  paymentMethod: string;
  payment?: PaymentCreateOneWithoutTablePaymentInput ;
  tip?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
  selectedItems?: OrderItemCreateManyWithoutSelectedForPaymentByUserInput ;
}

export interface TablePaymentSettingCreateWithoutUserActiveInput {
  id?: string ;
  user: UserCreateOneWithoutTablePaymentSettingsHistoryInput;
  tableSession: TableSessionCreateOneWithoutUserPaymentSettingsInput;
  paymentMethod: string;
  payment?: PaymentCreateOneWithoutTablePaymentInput ;
  tip?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
  selectedItems?: OrderItemCreateManyWithoutSelectedForPaymentByUserInput ;
}

export interface TablePaymentSettingCreateWithoutUserInput {
  id?: string ;
  userActive?: UserCreateOneWithoutTablePaymentSettingsInput ;
  tableSession: TableSessionCreateOneWithoutUserPaymentSettingsInput;
  paymentMethod: string;
  payment?: PaymentCreateOneWithoutTablePaymentInput ;
  tip?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
  selectedItems?: OrderItemCreateManyWithoutSelectedForPaymentByUserInput ;
}

export interface TablePaymentSettingWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  userActive?: UserWhereInput ;
  user?: UserWhereInput ;
  tableSession?: TableSessionWhereInput ;
  paymentMethod?: string ;
  paymentMethod_not?: string ;
  paymentMethod_in?: string[] ;
  paymentMethod_not_in?: string[] ;
  paymentMethod_lt?: string ;
  paymentMethod_lte?: string ;
  paymentMethod_gt?: string ;
  paymentMethod_gte?: string ;
  paymentMethod_contains?: string ;
  paymentMethod_not_contains?: string ;
  paymentMethod_starts_with?: string ;
  paymentMethod_not_starts_with?: string ;
  paymentMethod_ends_with?: string ;
  paymentMethod_not_ends_with?: string ;
  payment?: PaymentWhereInput ;
  tip?: number ;
  tip_not?: number ;
  tip_in?: number[] ;
  tip_not_in?: number[] ;
  tip_lt?: number ;
  tip_lte?: number ;
  tip_gt?: number ;
  tip_gte?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
  billPaymentType_not?: BILL_PAYMENT_TYPE ;
  billPaymentType_in?: BILL_PAYMENT_TYPE[] ;
  billPaymentType_not_in?: BILL_PAYMENT_TYPE[] ;
  selectedItems_every?: OrderItemWhereInput ;
  selectedItems_some?: OrderItemWhereInput ;
  selectedItems_none?: OrderItemWhereInput ;
  AND?: TablePaymentSettingWhereInput[] ;
  OR?: TablePaymentSettingWhereInput[] ;
  NOT?: TablePaymentSettingWhereInput[] ;
}

export interface TablePaymentSettingWhereUniqueInput {
  id?: string ;
}

export interface TableSessionCreateManyWithoutTableInput {
  create?: TableSessionCreateWithoutTableInput[] ;
  connect?: TableSessionWhereUniqueInput[] ;
}

export interface TableSessionCreateManyWithoutUsersInput {
  create?: TableSessionCreateWithoutUsersInput[] ;
  connect?: TableSessionWhereUniqueInput[] ;
}

export interface TableSessionCreateOneWithoutItemsInput {
  create?: TableSessionCreateWithoutItemsInput ;
  connect?: TableSessionWhereUniqueInput ;
}

export interface TableSessionCreateOneWithoutOrdersInput {
  create?: TableSessionCreateWithoutOrdersInput ;
  connect?: TableSessionWhereUniqueInput ;
}

export interface TableSessionCreateOneWithoutPosMetadataInput {
  create?: TableSessionCreateWithoutPosMetadataInput ;
  connect?: TableSessionWhereUniqueInput ;
}

export interface TableSessionCreateOneWithoutTableActiveInput {
  create?: TableSessionCreateWithoutTableActiveInput ;
  connect?: TableSessionWhereUniqueInput ;
}

export interface TableSessionCreateOneWithoutUserPaymentSettingsInput {
  create?: TableSessionCreateWithoutUserPaymentSettingsInput ;
  connect?: TableSessionWhereUniqueInput ;
}

export interface TableSessionCreateWithoutItemsInput {
  id?: string ;
  active?: boolean ;
  posMetadata?: PosMetadataCreateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffCreateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table: TableCreateOneWithoutSessionsInput;
  tableActive?: TableCreateOneWithoutSessionInput ;
  orders?: OrderCreateManyWithoutTableInput ;
  users?: UserCreateManyWithoutTableSessionsInput ;
  covers?: number ;
  userPaymentSettings?: TablePaymentSettingCreateManyWithoutTableSessionInput ;
}

export interface TableSessionCreateWithoutOrdersInput {
  id?: string ;
  active?: boolean ;
  posMetadata?: PosMetadataCreateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffCreateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table: TableCreateOneWithoutSessionsInput;
  tableActive?: TableCreateOneWithoutSessionInput ;
  users?: UserCreateManyWithoutTableSessionsInput ;
  covers?: number ;
  items?: OrderItemCreateManyWithoutTableSessionInput ;
  userPaymentSettings?: TablePaymentSettingCreateManyWithoutTableSessionInput ;
}

export interface TableSessionCreateWithoutPosMetadataInput {
  id?: string ;
  active?: boolean ;
  waiterId?: string ;
  staff?: StaffCreateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table: TableCreateOneWithoutSessionsInput;
  tableActive?: TableCreateOneWithoutSessionInput ;
  orders?: OrderCreateManyWithoutTableInput ;
  users?: UserCreateManyWithoutTableSessionsInput ;
  covers?: number ;
  items?: OrderItemCreateManyWithoutTableSessionInput ;
  userPaymentSettings?: TablePaymentSettingCreateManyWithoutTableSessionInput ;
}

export interface TableSessionCreateWithoutTableActiveInput {
  id?: string ;
  active?: boolean ;
  posMetadata?: PosMetadataCreateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffCreateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table: TableCreateOneWithoutSessionsInput;
  orders?: OrderCreateManyWithoutTableInput ;
  users?: UserCreateManyWithoutTableSessionsInput ;
  covers?: number ;
  items?: OrderItemCreateManyWithoutTableSessionInput ;
  userPaymentSettings?: TablePaymentSettingCreateManyWithoutTableSessionInput ;
}

export interface TableSessionCreateWithoutTableInput {
  id?: string ;
  active?: boolean ;
  posMetadata?: PosMetadataCreateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffCreateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  tableActive?: TableCreateOneWithoutSessionInput ;
  orders?: OrderCreateManyWithoutTableInput ;
  users?: UserCreateManyWithoutTableSessionsInput ;
  covers?: number ;
  items?: OrderItemCreateManyWithoutTableSessionInput ;
  userPaymentSettings?: TablePaymentSettingCreateManyWithoutTableSessionInput ;
}

export interface TableSessionCreateWithoutUserPaymentSettingsInput {
  id?: string ;
  active?: boolean ;
  posMetadata?: PosMetadataCreateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffCreateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table: TableCreateOneWithoutSessionsInput;
  tableActive?: TableCreateOneWithoutSessionInput ;
  orders?: OrderCreateManyWithoutTableInput ;
  users?: UserCreateManyWithoutTableSessionsInput ;
  covers?: number ;
  items?: OrderItemCreateManyWithoutTableSessionInput ;
}

export interface TableSessionCreateWithoutUsersInput {
  id?: string ;
  active?: boolean ;
  posMetadata?: PosMetadataCreateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffCreateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table: TableCreateOneWithoutSessionsInput;
  tableActive?: TableCreateOneWithoutSessionInput ;
  orders?: OrderCreateManyWithoutTableInput ;
  covers?: number ;
  items?: OrderItemCreateManyWithoutTableSessionInput ;
  userPaymentSettings?: TablePaymentSettingCreateManyWithoutTableSessionInput ;
}

export interface TableSessionWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  active?: boolean ;
  active_not?: boolean ;
  posMetadata?: PosMetadataWhereInput ;
  waiterId?: string ;
  waiterId_not?: string ;
  waiterId_in?: string[] ;
  waiterId_not_in?: string[] ;
  waiterId_lt?: string ;
  waiterId_lte?: string ;
  waiterId_gt?: string ;
  waiterId_gte?: string ;
  waiterId_contains?: string ;
  waiterId_not_contains?: string ;
  waiterId_starts_with?: string ;
  waiterId_not_starts_with?: string ;
  waiterId_ends_with?: string ;
  waiterId_not_ends_with?: string ;
  staff?: StaffWhereInput ;
  locked?: boolean ;
  locked_not?: boolean ;
  checkId?: string ;
  checkId_not?: string ;
  checkId_in?: string[] ;
  checkId_not_in?: string[] ;
  checkId_lt?: string ;
  checkId_lte?: string ;
  checkId_gt?: string ;
  checkId_gte?: string ;
  checkId_contains?: string ;
  checkId_not_contains?: string ;
  checkId_starts_with?: string ;
  checkId_not_starts_with?: string ;
  checkId_ends_with?: string ;
  checkId_not_ends_with?: string ;
  assistance?: boolean ;
  assistance_not?: boolean ;
  table?: TableWhereInput ;
  tableActive?: TableWhereInput ;
  orders_every?: OrderWhereInput ;
  orders_some?: OrderWhereInput ;
  orders_none?: OrderWhereInput ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  covers?: number ;
  covers_not?: number ;
  covers_in?: number[] ;
  covers_not_in?: number[] ;
  covers_lt?: number ;
  covers_lte?: number ;
  covers_gt?: number ;
  covers_gte?: number ;
  items_every?: OrderItemWhereInput ;
  items_some?: OrderItemWhereInput ;
  items_none?: OrderItemWhereInput ;
  userPaymentSettings_every?: TablePaymentSettingWhereInput ;
  userPaymentSettings_some?: TablePaymentSettingWhereInput ;
  userPaymentSettings_none?: TablePaymentSettingWhereInput ;
  AND?: TableSessionWhereInput[] ;
  OR?: TableSessionWhereInput[] ;
  NOT?: TableSessionWhereInput[] ;
}

export interface TableSessionWhereUniqueInput {
  id?: string ;
}

export interface TableWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  venue?: VenueWhereInput ;
  floorPlan?: FloorPlanWhereInput ;
  reservations_every?: ReservationWhereInput ;
  reservations_some?: ReservationWhereInput ;
  reservations_none?: ReservationWhereInput ;
  sessions_every?: TableSessionWhereInput ;
  sessions_some?: TableSessionWhereInput ;
  sessions_none?: TableSessionWhereInput ;
  session?: TableSessionWhereInput ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  code?: string ;
  code_not?: string ;
  code_in?: string[] ;
  code_not_in?: string[] ;
  code_lt?: string ;
  code_lte?: string ;
  code_gt?: string ;
  code_gte?: string ;
  code_contains?: string ;
  code_not_contains?: string ;
  code_starts_with?: string ;
  code_not_starts_with?: string ;
  code_ends_with?: string ;
  code_not_ends_with?: string ;
  capacity?: number ;
  capacity_not?: number ;
  capacity_in?: number[] ;
  capacity_not_in?: number[] ;
  capacity_lt?: number ;
  capacity_lte?: number ;
  capacity_gt?: number ;
  capacity_gte?: number ;
  posX?: number ;
  posX_not?: number ;
  posX_in?: number[] ;
  posX_not_in?: number[] ;
  posX_lt?: number ;
  posX_lte?: number ;
  posX_gt?: number ;
  posX_gte?: number ;
  posY?: number ;
  posY_not?: number ;
  posY_in?: number[] ;
  posY_not_in?: number[] ;
  posY_lt?: number ;
  posY_lte?: number ;
  posY_gt?: number ;
  posY_gte?: number ;
  width?: number ;
  width_not?: number ;
  width_in?: number[] ;
  width_not_in?: number[] ;
  width_lt?: number ;
  width_lte?: number ;
  width_gt?: number ;
  width_gte?: number ;
  height?: number ;
  height_not?: number ;
  height_in?: number[] ;
  height_not_in?: number[] ;
  height_lt?: number ;
  height_lte?: number ;
  height_gt?: number ;
  height_gte?: number ;
  rotation?: number ;
  rotation_not?: number ;
  rotation_in?: number[] ;
  rotation_not_in?: number[] ;
  rotation_lt?: number ;
  rotation_lte?: number ;
  rotation_gt?: number ;
  rotation_gte?: number ;
  AND?: TableWhereInput[] ;
  OR?: TableWhereInput[] ;
  NOT?: TableWhereInput[] ;
}

export interface TableWhereUniqueInput {
  id?: string ;
}

export interface TerminalTransactionCreateManyWithoutPosMetadataInput {
  create?: TerminalTransactionCreateWithoutPosMetadataInput[] ;
  connect?: TerminalTransactionWhereUniqueInput[] ;
}

export interface TerminalTransactionCreateWithoutPosMetadataInput {
  id?: string ;
  archiveId: string;
}

export interface TerminalTransactionWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  archiveId?: string ;
  archiveId_not?: string ;
  archiveId_in?: string[] ;
  archiveId_not_in?: string[] ;
  archiveId_lt?: string ;
  archiveId_lte?: string ;
  archiveId_gt?: string ;
  archiveId_gte?: string ;
  archiveId_contains?: string ;
  archiveId_not_contains?: string ;
  archiveId_starts_with?: string ;
  archiveId_not_starts_with?: string ;
  archiveId_ends_with?: string ;
  archiveId_not_ends_with?: string ;
  posMetadata?: PosMetadataWhereInput ;
  AND?: TerminalTransactionWhereInput[] ;
  OR?: TerminalTransactionWhereInput[] ;
  NOT?: TerminalTransactionWhereInput[] ;
}

export interface TerminalTransactionWhereUniqueInput {
  id?: string ;
}

export interface TimeRangeCreateOneWithoutAvailabilitiesInput {
  create?: TimeRangeCreateWithoutAvailabilitiesInput ;
  connect?: TimeRangeWhereUniqueInput ;
}

export interface TimeRangeCreateWithoutAvailabilitiesInput {
  end?: string ;
  id?: string ;
  start?: string ;
}

export interface TimeRangeWhereInput {
  availabilities_every?: AvailabilityWhereInput ;
  availabilities_some?: AvailabilityWhereInput ;
  availabilities_none?: AvailabilityWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  end?: string ;
  end_not?: string ;
  end_in?: string[] ;
  end_not_in?: string[] ;
  end_lt?: string ;
  end_lte?: string ;
  end_gt?: string ;
  end_gte?: string ;
  end_contains?: string ;
  end_not_contains?: string ;
  end_starts_with?: string ;
  end_not_starts_with?: string ;
  end_ends_with?: string ;
  end_not_ends_with?: string ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  start?: string ;
  start_not?: string ;
  start_in?: string[] ;
  start_not_in?: string[] ;
  start_lt?: string ;
  start_lte?: string ;
  start_gt?: string ;
  start_gte?: string ;
  start_contains?: string ;
  start_not_contains?: string ;
  start_starts_with?: string ;
  start_not_starts_with?: string ;
  start_ends_with?: string ;
  start_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: TimeRangeWhereInput[] ;
  OR?: TimeRangeWhereInput[] ;
  NOT?: TimeRangeWhereInput[] ;
}

export interface TimeRangeWhereUniqueInput {
  id?: string ;
}

export interface TipScoreInput {
  count: number;
  amount: number;
}

export interface TransactionCreateManyWithoutPaymentInput {
  create?: TransactionCreateWithoutPaymentInput[] ;
  connect?: TransactionWhereUniqueInput[] ;
}

export interface TransactionCreateWithoutPaymentInput {
  id?: string ;
  amount: number;
  type: string;
  transactionId?: string ;
  refund?: RefundCreateOneWithoutTransactionsInput ;
}

export interface TransactionInput {
  amount: number;
  type: string;
  transactionId?: string ;
}

export interface TransactionWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  type?: string ;
  type_not?: string ;
  type_in?: string[] ;
  type_not_in?: string[] ;
  type_lt?: string ;
  type_lte?: string ;
  type_gt?: string ;
  type_gte?: string ;
  type_contains?: string ;
  type_not_contains?: string ;
  type_starts_with?: string ;
  type_not_starts_with?: string ;
  type_ends_with?: string ;
  type_not_ends_with?: string ;
  transactionId?: string ;
  transactionId_not?: string ;
  transactionId_in?: string[] ;
  transactionId_not_in?: string[] ;
  transactionId_lt?: string ;
  transactionId_lte?: string ;
  transactionId_gt?: string ;
  transactionId_gte?: string ;
  transactionId_contains?: string ;
  transactionId_not_contains?: string ;
  transactionId_starts_with?: string ;
  transactionId_not_starts_with?: string ;
  transactionId_ends_with?: string ;
  transactionId_not_ends_with?: string ;
  payment?: PaymentWhereInput ;
  refund?: RefundWhereInput ;
  AND?: TransactionWhereInput[] ;
  OR?: TransactionWhereInput[] ;
  NOT?: TransactionWhereInput[] ;
}

export interface TransactionWhereUniqueInput {
  id?: string ;
}

export interface TranslatedStringCreateOneWithoutCategoryDescriptionInput {
  create?: TranslatedStringCreateWithoutCategoryDescriptionInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutCategoryNameInput {
  create?: TranslatedStringCreateWithoutCategoryNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutCompanyReferralBodyInput {
  create?: TranslatedStringCreateWithoutCompanyReferralBodyInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput {
  create?: TranslatedStringCreateWithoutCompanyReferralShareMessageInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutCompanyReferralTitleInput {
  create?: TranslatedStringCreateWithoutCompanyReferralTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutContentSubTitleInput {
  create?: TranslatedStringCreateWithoutContentSubTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutContentTextInput {
  create?: TranslatedStringCreateWithoutContentTextInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutContentTitleInput {
  create?: TranslatedStringCreateWithoutContentTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutDeliveryRateMessageInput {
  create?: TranslatedStringCreateWithoutDeliveryRateMessageInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutDeliveryRateNameInput {
  create?: TranslatedStringCreateWithoutDeliveryRateNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutExpressPageDescriptionInput {
  create?: TranslatedStringCreateWithoutExpressPageDescriptionInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutExpressPageTitleInput {
  create?: TranslatedStringCreateWithoutExpressPageTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutItemAllergiesInput {
  create?: TranslatedStringCreateWithoutItemAllergiesInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutItemDescriptionInput {
  create?: TranslatedStringCreateWithoutItemDescriptionInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutItemSizeNameInput {
  create?: TranslatedStringCreateWithoutItemSizeNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutItemTitleInput {
  create?: TranslatedStringCreateWithoutItemTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutLayoutInput {
  create?: TranslatedStringCreateWithoutLayoutInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput {
  create?: TranslatedStringCreateWithoutMembershipLevelDescriptionInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutMembershipLevelTitleInput {
  create?: TranslatedStringCreateWithoutMembershipLevelTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutMenuNameInput {
  create?: TranslatedStringCreateWithoutMenuNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutNotifBodyInput {
  create?: TranslatedStringCreateWithoutNotifBodyInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutNotifTitleInput {
  create?: TranslatedStringCreateWithoutNotifTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutOfferDescriptionInput {
  create?: TranslatedStringCreateWithoutOfferDescriptionInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutOfferNameInput {
  create?: TranslatedStringCreateWithoutOfferNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutOfferStageDescriptionInput {
  create?: TranslatedStringCreateWithoutOfferStageDescriptionInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutOfferStageTitleInput {
  create?: TranslatedStringCreateWithoutOfferStageTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutOfferYieldNameInput {
  create?: TranslatedStringCreateWithoutOfferYieldNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutPageInput {
  create?: TranslatedStringCreateWithoutPageInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutPosCategoryInput {
  create?: TranslatedStringCreateWithoutPosCategoryInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutStampCardDetailsInput {
  create?: TranslatedStringCreateWithoutStampCardDetailsInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutStampCardNameInput {
  create?: TranslatedStringCreateWithoutStampCardNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutStampcardDescriptionInput {
  create?: TranslatedStringCreateWithoutStampcardDescriptionInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutUpsellInput {
  create?: TranslatedStringCreateWithoutUpsellInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutVariationGroupNameInput {
  create?: TranslatedStringCreateWithoutVariationGroupNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutVariationNameInput {
  create?: TranslatedStringCreateWithoutVariationNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutVenueNameInput {
  create?: TranslatedStringCreateWithoutVenueNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateWithoutCategoryDescriptionInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutCategoryNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutCompanyReferralBodyInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutCompanyReferralShareMessageInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutCompanyReferralTitleInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutContentSubTitleInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutContentTextInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutContentTitleInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutDeliveryRateMessageInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutDeliveryRateNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutExpressPageDescriptionInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutExpressPageTitleInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutItemAllergiesInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutItemDescriptionInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutItemSizeNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutItemTitleInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutLayoutInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutMembershipLevelDescriptionInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutMembershipLevelTitleInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutMenuNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutNotifBodyInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutNotifTitleInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutOfferDescriptionInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutOfferNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutOfferStageDescriptionInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutOfferStageTitleInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutOfferYieldNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutPageInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutPosCategoryInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutStampCardDetailsInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutStampCardNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutStampcardDescriptionInput {
  id?: string ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutUpsellInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutVariationGroupNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutVariationNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutVenueNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  stampcardDescription?: StampCardWhereInput ;
  itemDescription?: ItemWhereInput ;
  itemTitle?: ItemWhereInput ;
  itemAllergies?: ItemWhereInput ;
  deliveryRateMessage?: DeliveryRateWhereInput ;
  deliveryRateName?: DeliveryRateWhereInput ;
  categoryDescription?: CategoryWhereInput ;
  categoryName?: CategoryWhereInput ;
  itemSizeName?: ItemSizeWhereInput ;
  menuName?: MenuWhereInput ;
  offerDescription?: OfferWhereInput ;
  offerName?: OfferWhereInput ;
  variationName?: VariationWhereInput ;
  venueName?: VenueWhereInput ;
  variationGroupName?: VariationGroupWhereInput ;
  stampCardName?: StampCardWhereInput ;
  contentTitle?: ContentWhereInput ;
  contentSubTitle?: ContentWhereInput ;
  contentText?: ContentWhereInput ;
  notifTitle?: NotificationWhereInput ;
  notifBody?: NotificationWhereInput ;
  membershipLevelTitle?: MembershipLevelWhereInput ;
  membershipLevelDescription?: MembershipLevelWhereInput ;
  offerStageTitle?: OfferStageWhereInput ;
  offerStageDescription?: OfferStageWhereInput ;
  companyReferralTitle?: CompanyWhereInput ;
  companyReferralBody?: CompanyWhereInput ;
  companyReferralShareMessage?: CompanyWhereInput ;
  offerYieldName?: OfferYieldEventWhereInput ;
  stampCardDetails?: StampCardWhereInput ;
  layout?: LayoutWhereInput ;
  posCategory?: PosCategoryWhereInput ;
  page?: PageWhereInput ;
  upsell?: UpsellWhereInput ;
  expressPageTitle?: ExpressPageWhereInput ;
  expressPageDescription?: ExpressPageWhereInput ;
  en?: string ;
  en_not?: string ;
  en_in?: string[] ;
  en_not_in?: string[] ;
  en_lt?: string ;
  en_lte?: string ;
  en_gt?: string ;
  en_gte?: string ;
  en_contains?: string ;
  en_not_contains?: string ;
  en_starts_with?: string ;
  en_not_starts_with?: string ;
  en_ends_with?: string ;
  en_not_ends_with?: string ;
  se?: string ;
  se_not?: string ;
  se_in?: string[] ;
  se_not_in?: string[] ;
  se_lt?: string ;
  se_lte?: string ;
  se_gt?: string ;
  se_gte?: string ;
  se_contains?: string ;
  se_not_contains?: string ;
  se_starts_with?: string ;
  se_not_starts_with?: string ;
  se_ends_with?: string ;
  se_not_ends_with?: string ;
  no?: string ;
  no_not?: string ;
  no_in?: string[] ;
  no_not_in?: string[] ;
  no_lt?: string ;
  no_lte?: string ;
  no_gt?: string ;
  no_gte?: string ;
  no_contains?: string ;
  no_not_contains?: string ;
  no_starts_with?: string ;
  no_not_starts_with?: string ;
  no_ends_with?: string ;
  no_not_ends_with?: string ;
  es?: string ;
  es_not?: string ;
  es_in?: string[] ;
  es_not_in?: string[] ;
  es_lt?: string ;
  es_lte?: string ;
  es_gt?: string ;
  es_gte?: string ;
  es_contains?: string ;
  es_not_contains?: string ;
  es_starts_with?: string ;
  es_not_starts_with?: string ;
  es_ends_with?: string ;
  es_not_ends_with?: string ;
  pt?: string ;
  pt_not?: string ;
  pt_in?: string[] ;
  pt_not_in?: string[] ;
  pt_lt?: string ;
  pt_lte?: string ;
  pt_gt?: string ;
  pt_gte?: string ;
  pt_contains?: string ;
  pt_not_contains?: string ;
  pt_starts_with?: string ;
  pt_not_starts_with?: string ;
  pt_ends_with?: string ;
  pt_not_ends_with?: string ;
  AND?: TranslatedStringWhereInput[] ;
  OR?: TranslatedStringWhereInput[] ;
  NOT?: TranslatedStringWhereInput[] ;
}

export interface TranslatedStringWhereUniqueInput {
  id?: string ;
}

export interface UpdateActiveLicenseInput {
  deviceId?: string ;
  venueId?: string ;
  price?: number ;
}

export interface UpdateLoyaltyUserInput {
  email?: string ;
  name?: string ;
  personalIdentityNumber?: string ;
}

export interface UpdateUserMetadataInput {
  userId: string;
  companyId: string;
  address?: string ;
  zip?: string ;
  city?: string ;
  orgNumber?: string ;
  invoiceType?: INVOICE_TYPE ;
}

export interface UpdateVenueMetadataInput {
  venueId: string;
  zip?: string ;
  cashFloat?: number ;
  beeperList?: string[] ;
  hasIndividualEOD?: boolean ;
  googlePlaceId?: string ;
  pauseOnlineOrdersUntil?: string ;
  discountExcludedCategoryIds?: string[] ;
  useCoursesInKDS?: boolean ;
  lateAfterMinutesInKDS?: number ;
}

export interface UpsellCreateManyWithoutCompanyInput {
  create?: UpsellCreateWithoutCompanyInput[] ;
  connect?: UpsellWhereUniqueInput[] ;
}

export interface UpsellCreateManyWithoutItemsInput {
  create?: UpsellCreateWithoutItemsInput[] ;
  connect?: UpsellWhereUniqueInput[] ;
}

export interface UpsellCreateManyWithoutItemsUsedOnInput {
  create?: UpsellCreateWithoutItemsUsedOnInput[] ;
  connect?: UpsellWhereUniqueInput[] ;
}

export interface UpsellCreateOneWithoutNameInput {
  create?: UpsellCreateWithoutNameInput ;
  connect?: UpsellWhereUniqueInput ;
}

export interface UpsellCreateOneWithoutUsedOnInput {
  create?: UpsellCreateWithoutUsedOnInput ;
  connect?: UpsellWhereUniqueInput ;
}

export interface UpsellCreateWithoutCompanyInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutUpsellInput;
  deleted?: boolean ;
  items?: ItemCreateManyWithoutUsedAsUpsellOnInput ;
  usedOn?: ItemCreateManyWithoutUpsellInput ;
  itemsUsedOn?: ItemCreateManyWithoutUpsalesInput ;
  displayOrder?: number ;
}

export interface UpsellCreateWithoutItemsInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutUpsellInput;
  company: CompanyCreateOneWithoutUpsellsInput;
  deleted?: boolean ;
  usedOn?: ItemCreateManyWithoutUpsellInput ;
  itemsUsedOn?: ItemCreateManyWithoutUpsalesInput ;
  displayOrder?: number ;
}

export interface UpsellCreateWithoutItemsUsedOnInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutUpsellInput;
  company: CompanyCreateOneWithoutUpsellsInput;
  deleted?: boolean ;
  items?: ItemCreateManyWithoutUsedAsUpsellOnInput ;
  usedOn?: ItemCreateManyWithoutUpsellInput ;
  displayOrder?: number ;
}

export interface UpsellCreateWithoutNameInput {
  id?: string ;
  company: CompanyCreateOneWithoutUpsellsInput;
  deleted?: boolean ;
  items?: ItemCreateManyWithoutUsedAsUpsellOnInput ;
  usedOn?: ItemCreateManyWithoutUpsellInput ;
  itemsUsedOn?: ItemCreateManyWithoutUpsalesInput ;
  displayOrder?: number ;
}

export interface UpsellCreateWithoutUsedOnInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutUpsellInput;
  company: CompanyCreateOneWithoutUpsellsInput;
  deleted?: boolean ;
  items?: ItemCreateManyWithoutUsedAsUpsellOnInput ;
  itemsUsedOn?: ItemCreateManyWithoutUpsalesInput ;
  displayOrder?: number ;
}

export interface UpsellWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: TranslatedStringWhereInput ;
  company?: CompanyWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  usedOn_every?: ItemWhereInput ;
  usedOn_some?: ItemWhereInput ;
  usedOn_none?: ItemWhereInput ;
  itemsUsedOn_every?: ItemWhereInput ;
  itemsUsedOn_some?: ItemWhereInput ;
  itemsUsedOn_none?: ItemWhereInput ;
  displayOrder?: number ;
  displayOrder_not?: number ;
  displayOrder_in?: number[] ;
  displayOrder_not_in?: number[] ;
  displayOrder_lt?: number ;
  displayOrder_lte?: number ;
  displayOrder_gt?: number ;
  displayOrder_gte?: number ;
  AND?: UpsellWhereInput[] ;
  OR?: UpsellWhereInput[] ;
  NOT?: UpsellWhereInput[] ;
}

export interface UpsellWhereUniqueInput {
  id?: string ;
}

export interface UserCommentCreateManyWithoutAuthorInput {
  create?: UserCommentCreateWithoutAuthorInput[] ;
  connect?: UserCommentWhereUniqueInput[] ;
}

export interface UserCommentCreateManyWithoutUserInput {
  create?: UserCommentCreateWithoutUserInput[] ;
  connect?: UserCommentWhereUniqueInput[] ;
}

export interface UserCommentCreateWithoutAuthorInput {
  id?: string ;
  deleted?: boolean ;
  user: UserCreateOneWithoutCommentsInput;
  comment: string;
}

export interface UserCommentCreateWithoutUserInput {
  id?: string ;
  deleted?: boolean ;
  author: UserCreateOneWithoutWrittenCommentsInput;
  comment: string;
}

export interface UserCommentWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  author?: UserWhereInput ;
  user?: UserWhereInput ;
  comment?: string ;
  comment_not?: string ;
  comment_in?: string[] ;
  comment_not_in?: string[] ;
  comment_lt?: string ;
  comment_lte?: string ;
  comment_gt?: string ;
  comment_gte?: string ;
  comment_contains?: string ;
  comment_not_contains?: string ;
  comment_starts_with?: string ;
  comment_not_starts_with?: string ;
  comment_ends_with?: string ;
  comment_not_ends_with?: string ;
  AND?: UserCommentWhereInput[] ;
  OR?: UserCommentWhereInput[] ;
  NOT?: UserCommentWhereInput[] ;
}

export interface UserCommentWhereUniqueInput {
  id?: string ;
}

export interface UserCreateInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateManyWithoutCompanyInput {
  create?: UserCreateWithoutCompanyInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutMembershipLevelInput {
  create?: UserCreateWithoutMembershipLevelInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutNotificationsInput {
  create?: UserCreateWithoutNotificationsInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutOfferYieldEventsInput {
  create?: UserCreateWithoutOfferYieldEventsInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutOffersInput {
  create?: UserCreateWithoutOffersInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutPreviousSegmentsInput {
  create?: UserCreateWithoutPreviousSegmentsInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutPromoCodesInput {
  create?: UserCreateWithoutPromoCodesInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutSegmentsInput {
  create?: UserCreateWithoutSegmentsInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutStampCardsInput {
  create?: UserCreateWithoutStampCardsInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutTableInput {
  create?: UserCreateWithoutTableInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutTableSessionsInput {
  create?: UserCreateWithoutTableSessionsInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutVenuesInput {
  create?: UserCreateWithoutVenuesInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateOneWithoutCommentsInput {
  create?: UserCreateWithoutCommentsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutCreditBankInput {
  create?: UserCreateWithoutCreditBankInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutLocationsInput {
  create?: UserCreateWithoutLocationsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutMembershipAssignmentsInput {
  create?: UserCreateWithoutMembershipAssignmentsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutMembershipCardInput {
  create?: UserCreateWithoutMembershipCardInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutMembershipTradeinsInput {
  create?: UserCreateWithoutMembershipTradeinsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutOrdersInput {
  create?: UserCreateWithoutOrdersInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutPaymentsInput {
  create?: UserCreateWithoutPaymentsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutReceiptPointsScansInput {
  create?: UserCreateWithoutReceiptPointsScansInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutRecommendationsInput {
  create?: UserCreateWithoutRecommendationsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutReferalInput {
  create?: UserCreateWithoutReferalInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutReferralsInput {
  create?: UserCreateWithoutReferralsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutReservationsInput {
  create?: UserCreateWithoutReservationsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutSentNotificationsInput {
  create?: UserCreateWithoutSentNotificationsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutStampsInput {
  create?: UserCreateWithoutStampsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutTablePaymentSettingsHistoryInput {
  create?: UserCreateWithoutTablePaymentSettingsHistoryInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutTablePaymentSettingsInput {
  create?: UserCreateWithoutTablePaymentSettingsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutTokensInput {
  create?: UserCreateWithoutTokensInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutWrittenCommentsInput {
  create?: UserCreateWithoutWrittenCommentsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateWithoutCommentsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutCompanyInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutCreditBankInput {
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutLocationsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutMembershipAssignmentsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutMembershipCardInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutMembershipLevelInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutMembershipTradeinsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutNotificationsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutOfferYieldEventsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutOffersInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutOrdersInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutPaymentsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutPreviousSegmentsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutPromoCodesInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutReceiptPointsScansInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
}

export interface UserCreateWithoutRecommendationsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutReferalInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutReferralsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutReservationsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutSegmentsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutSentNotificationsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutStampCardsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutStampsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutTableInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutTablePaymentSettingsHistoryInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutTablePaymentSettingsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutTableSessionsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutTokensInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutVenuesInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutWrittenCommentsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateaccessInput {
  set?: string[] ;
}

export interface UserCreateusedOffersInput {
  set?: string[] ;
}

export interface UserMetadataInput {
  id: string;
  address?: string ;
  city?: string ;
  zip?: string ;
  orgNumber?: string ;
}

export interface UserReferralCreateManyWithoutReferrerInput {
  create?: UserReferralCreateWithoutReferrerInput[] ;
  connect?: UserReferralWhereUniqueInput[] ;
}

export interface UserReferralCreateOneWithoutUserInput {
  create?: UserReferralCreateWithoutUserInput ;
  connect?: UserReferralWhereUniqueInput ;
}

export interface UserReferralCreateWithoutReferrerInput {
  id?: string ;
  user: UserCreateOneWithoutReferalInput;
  code: string;
  activated?: boolean ;
}

export interface UserReferralCreateWithoutUserInput {
  id?: string ;
  referrer: UserCreateOneWithoutReferralsInput;
  code: string;
  activated?: boolean ;
}

export interface UserReferralWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  user?: UserWhereInput ;
  referrer?: UserWhereInput ;
  code?: string ;
  code_not?: string ;
  code_in?: string[] ;
  code_not_in?: string[] ;
  code_lt?: string ;
  code_lte?: string ;
  code_gt?: string ;
  code_gte?: string ;
  code_contains?: string ;
  code_not_contains?: string ;
  code_starts_with?: string ;
  code_not_starts_with?: string ;
  code_ends_with?: string ;
  code_not_ends_with?: string ;
  activated?: boolean ;
  activated_not?: boolean ;
  AND?: UserReferralWhereInput[] ;
  OR?: UserReferralWhereInput[] ;
  NOT?: UserReferralWhereInput[] ;
}

export interface UserReferralWhereUniqueInput {
  id?: string ;
}

export interface UserSegmentCreateManyWithoutCompanyInput {
  create?: UserSegmentCreateWithoutCompanyInput[] ;
  connect?: UserSegmentWhereUniqueInput[] ;
}

export interface UserSegmentCreateManyWithoutContentsInput {
  create?: UserSegmentCreateWithoutContentsInput[] ;
  connect?: UserSegmentWhereUniqueInput[] ;
}

export interface UserSegmentCreateManyWithoutPreviousUsersInput {
  create?: UserSegmentCreateWithoutPreviousUsersInput[] ;
  connect?: UserSegmentWhereUniqueInput[] ;
}

export interface UserSegmentCreateManyWithoutUsersInput {
  create?: UserSegmentCreateWithoutUsersInput[] ;
  connect?: UserSegmentWhereUniqueInput[] ;
}

export interface UserSegmentCreateManyWithoutYieldEventsInput {
  create?: UserSegmentCreateWithoutYieldEventsInput[] ;
  connect?: UserSegmentWhereUniqueInput[] ;
}

export interface UserSegmentCreateWithoutCompanyInput {
  id?: string ;
  name: string;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  users?: UserCreateManyWithoutSegmentsInput ;
  previousUsers?: UserCreateManyWithoutPreviousSegmentsInput ;
  triggers?: any ;
  history?: any ;
  yieldEvents?: OfferYieldEventCreateManyWithoutSegmentsInput ;
  contents?: ContentCreateManyWithoutSegmentsInput ;
  deleted?: boolean ;
}

export interface UserSegmentCreateWithoutContentsInput {
  id?: string ;
  company?: CompanyCreateOneWithoutSegmentsInput ;
  name: string;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  users?: UserCreateManyWithoutSegmentsInput ;
  previousUsers?: UserCreateManyWithoutPreviousSegmentsInput ;
  triggers?: any ;
  history?: any ;
  yieldEvents?: OfferYieldEventCreateManyWithoutSegmentsInput ;
  deleted?: boolean ;
}

export interface UserSegmentCreateWithoutPreviousUsersInput {
  id?: string ;
  company?: CompanyCreateOneWithoutSegmentsInput ;
  name: string;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  users?: UserCreateManyWithoutSegmentsInput ;
  triggers?: any ;
  history?: any ;
  yieldEvents?: OfferYieldEventCreateManyWithoutSegmentsInput ;
  contents?: ContentCreateManyWithoutSegmentsInput ;
  deleted?: boolean ;
}

export interface UserSegmentCreateWithoutUsersInput {
  id?: string ;
  company?: CompanyCreateOneWithoutSegmentsInput ;
  name: string;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  previousUsers?: UserCreateManyWithoutPreviousSegmentsInput ;
  triggers?: any ;
  history?: any ;
  yieldEvents?: OfferYieldEventCreateManyWithoutSegmentsInput ;
  contents?: ContentCreateManyWithoutSegmentsInput ;
  deleted?: boolean ;
}

export interface UserSegmentCreateWithoutYieldEventsInput {
  id?: string ;
  company?: CompanyCreateOneWithoutSegmentsInput ;
  name: string;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  users?: UserCreateManyWithoutSegmentsInput ;
  previousUsers?: UserCreateManyWithoutPreviousSegmentsInput ;
  triggers?: any ;
  history?: any ;
  contents?: ContentCreateManyWithoutSegmentsInput ;
  deleted?: boolean ;
}

export interface UserSegmentWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  company?: CompanyWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  startDate?: any ;
  startDate_not?: any ;
  startDate_in?: any[] ;
  startDate_not_in?: any[] ;
  startDate_lt?: any ;
  startDate_lte?: any ;
  startDate_gt?: any ;
  startDate_gte?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodType_not?: SEGMENT_PERIOD ;
  periodType_in?: SEGMENT_PERIOD[] ;
  periodType_not_in?: SEGMENT_PERIOD[] ;
  periodNumber?: number ;
  periodNumber_not?: number ;
  periodNumber_in?: number[] ;
  periodNumber_not_in?: number[] ;
  periodNumber_lt?: number ;
  periodNumber_lte?: number ;
  periodNumber_gt?: number ;
  periodNumber_gte?: number ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  previousUsers_every?: UserWhereInput ;
  previousUsers_some?: UserWhereInput ;
  previousUsers_none?: UserWhereInput ;
  yieldEvents_every?: OfferYieldEventWhereInput ;
  yieldEvents_some?: OfferYieldEventWhereInput ;
  yieldEvents_none?: OfferYieldEventWhereInput ;
  contents_every?: ContentWhereInput ;
  contents_some?: ContentWhereInput ;
  contents_none?: ContentWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: UserSegmentWhereInput[] ;
  OR?: UserSegmentWhereInput[] ;
  NOT?: UserSegmentWhereInput[] ;
}

export interface UserSegmentWhereUniqueInput {
  id?: string ;
}

export interface UserWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  creditBank?: CreditBankWhereInput ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  image?: string ;
  image_not?: string ;
  image_in?: string[] ;
  image_not_in?: string[] ;
  image_lt?: string ;
  image_lte?: string ;
  image_gt?: string ;
  image_gte?: string ;
  image_contains?: string ;
  image_not_contains?: string ;
  image_starts_with?: string ;
  image_not_starts_with?: string ;
  image_ends_with?: string ;
  image_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  venueLimited?: boolean ;
  venueLimited_not?: boolean ;
  offers_every?: OfferWhereInput ;
  offers_some?: OfferWhereInput ;
  offers_none?: OfferWhereInput ;
  orders_every?: OrderWhereInput ;
  orders_some?: OrderWhereInput ;
  orders_none?: OrderWhereInput ;
  payments_every?: PaymentWhereInput ;
  payments_some?: PaymentWhereInput ;
  payments_none?: PaymentWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  language?: string ;
  language_not?: string ;
  language_in?: string[] ;
  language_not_in?: string[] ;
  language_lt?: string ;
  language_lte?: string ;
  language_gt?: string ;
  language_gte?: string ;
  language_contains?: string ;
  language_not_contains?: string ;
  language_starts_with?: string ;
  language_not_starts_with?: string ;
  language_ends_with?: string ;
  language_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  devices_every?: DeviceWhereInput ;
  devices_some?: DeviceWhereInput ;
  devices_none?: DeviceWhereInput ;
  stampCards_every?: StampCardWhereInput ;
  stampCards_some?: StampCardWhereInput ;
  stampCards_none?: StampCardWhereInput ;
  stamps_every?: StampWhereInput ;
  stamps_some?: StampWhereInput ;
  stamps_none?: StampWhereInput ;
  tokens_every?: OfferTokenWhereInput ;
  tokens_some?: OfferTokenWhereInput ;
  tokens_none?: OfferTokenWhereInput ;
  venues_every?: VenueWhereInput ;
  venues_some?: VenueWhereInput ;
  venues_none?: VenueWhereInput ;
  locations_every?: LocationWhereInput ;
  locations_some?: LocationWhereInput ;
  locations_none?: LocationWhereInput ;
  creditCards_every?: CreditCardWhereInput ;
  creditCards_some?: CreditCardWhereInput ;
  creditCards_none?: CreditCardWhereInput ;
  recommendations_every?: RecommendationWhereInput ;
  recommendations_some?: RecommendationWhereInput ;
  recommendations_none?: RecommendationWhereInput ;
  membershipLevel?: MembershipLevelWhereInput ;
  membershipCard?: MembershipCardWhereInput ;
  facebookId?: string ;
  facebookId_not?: string ;
  facebookId_in?: string[] ;
  facebookId_not_in?: string[] ;
  facebookId_lt?: string ;
  facebookId_lte?: string ;
  facebookId_gt?: string ;
  facebookId_gte?: string ;
  facebookId_contains?: string ;
  facebookId_not_contains?: string ;
  facebookId_starts_with?: string ;
  facebookId_not_starts_with?: string ;
  facebookId_ends_with?: string ;
  facebookId_not_ends_with?: string ;
  promoCodes_every?: PromoCodeWhereInput ;
  promoCodes_some?: PromoCodeWhereInput ;
  promoCodes_none?: PromoCodeWhereInput ;
  email?: string ;
  email_not?: string ;
  email_in?: string[] ;
  email_not_in?: string[] ;
  email_lt?: string ;
  email_lte?: string ;
  email_gt?: string ;
  email_gte?: string ;
  email_contains?: string ;
  email_not_contains?: string ;
  email_starts_with?: string ;
  email_not_starts_with?: string ;
  email_ends_with?: string ;
  email_not_ends_with?: string ;
  notifications_every?: NotificationWhereInput ;
  notifications_some?: NotificationWhereInput ;
  notifications_none?: NotificationWhereInput ;
  sentNotifications_every?: SentNotificationWhereInput ;
  sentNotifications_some?: SentNotificationWhereInput ;
  sentNotifications_none?: SentNotificationWhereInput ;
  password?: string ;
  password_not?: string ;
  password_in?: string[] ;
  password_not_in?: string[] ;
  password_lt?: string ;
  password_lte?: string ;
  password_gt?: string ;
  password_gte?: string ;
  password_contains?: string ;
  password_not_contains?: string ;
  password_starts_with?: string ;
  password_not_starts_with?: string ;
  password_ends_with?: string ;
  password_not_ends_with?: string ;
  referralCode?: string ;
  referralCode_not?: string ;
  referralCode_in?: string[] ;
  referralCode_not_in?: string[] ;
  referralCode_lt?: string ;
  referralCode_lte?: string ;
  referralCode_gt?: string ;
  referralCode_gte?: string ;
  referralCode_contains?: string ;
  referralCode_not_contains?: string ;
  referralCode_starts_with?: string ;
  referralCode_not_starts_with?: string ;
  referralCode_ends_with?: string ;
  referralCode_not_ends_with?: string ;
  referal?: UserReferralWhereInput ;
  referrals_every?: UserReferralWhereInput ;
  referrals_some?: UserReferralWhereInput ;
  referrals_none?: UserReferralWhereInput ;
  phone?: string ;
  phone_not?: string ;
  phone_in?: string[] ;
  phone_not_in?: string[] ;
  phone_lt?: string ;
  phone_lte?: string ;
  phone_gt?: string ;
  phone_gte?: string ;
  phone_contains?: string ;
  phone_not_contains?: string ;
  phone_starts_with?: string ;
  phone_not_starts_with?: string ;
  phone_ends_with?: string ;
  phone_not_ends_with?: string ;
  events_every?: EventWhereInput ;
  events_some?: EventWhereInput ;
  events_none?: EventWhereInput ;
  logs_every?: LogWhereInput ;
  logs_some?: LogWhereInput ;
  logs_none?: LogWhereInput ;
  role?: ROLE ;
  role_not?: ROLE ;
  role_in?: ROLE[] ;
  role_not_in?: ROLE[] ;
  segments_every?: UserSegmentWhereInput ;
  segments_some?: UserSegmentWhereInput ;
  segments_none?: UserSegmentWhereInput ;
  previousSegments_every?: UserSegmentWhereInput ;
  previousSegments_some?: UserSegmentWhereInput ;
  previousSegments_none?: UserSegmentWhereInput ;
  activated?: boolean ;
  activated_not?: boolean ;
  blocked?: boolean ;
  blocked_not?: boolean ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  lastLogin?: any ;
  lastLogin_not?: any ;
  lastLogin_in?: any[] ;
  lastLogin_not_in?: any[] ;
  lastLogin_lt?: any ;
  lastLogin_lte?: any ;
  lastLogin_gt?: any ;
  lastLogin_gte?: any ;
  personalNumber?: string ;
  personalNumber_not?: string ;
  personalNumber_in?: string[] ;
  personalNumber_not_in?: string[] ;
  personalNumber_lt?: string ;
  personalNumber_lte?: string ;
  personalNumber_gt?: string ;
  personalNumber_gte?: string ;
  personalNumber_contains?: string ;
  personalNumber_not_contains?: string ;
  personalNumber_starts_with?: string ;
  personalNumber_not_starts_with?: string ;
  personalNumber_ends_with?: string ;
  personalNumber_not_ends_with?: string ;
  ofLegalAge?: boolean ;
  ofLegalAge_not?: boolean ;
  offerYieldEvents_every?: OfferYieldEventWhereInput ;
  offerYieldEvents_some?: OfferYieldEventWhereInput ;
  offerYieldEvents_none?: OfferYieldEventWhereInput ;
  reservations_every?: ReservationWhereInput ;
  reservations_some?: ReservationWhereInput ;
  reservations_none?: ReservationWhereInput ;
  table?: TableWhereInput ;
  tableSessions_every?: TableSessionWhereInput ;
  tableSessions_some?: TableSessionWhereInput ;
  tableSessions_none?: TableSessionWhereInput ;
  tablePaymentSettings?: TablePaymentSettingWhereInput ;
  tablePaymentSettingsHistory_every?: TablePaymentSettingWhereInput ;
  tablePaymentSettingsHistory_some?: TablePaymentSettingWhereInput ;
  tablePaymentSettingsHistory_none?: TablePaymentSettingWhereInput ;
  membershipTradeins_every?: MembershipTradeinWhereInput ;
  membershipTradeins_some?: MembershipTradeinWhereInput ;
  membershipTradeins_none?: MembershipTradeinWhereInput ;
  membershipAssignments_every?: MembershipAssignmentWhereInput ;
  membershipAssignments_some?: MembershipAssignmentWhereInput ;
  membershipAssignments_none?: MembershipAssignmentWhereInput ;
  username?: string ;
  username_not?: string ;
  username_in?: string[] ;
  username_not_in?: string[] ;
  username_lt?: string ;
  username_lte?: string ;
  username_gt?: string ;
  username_gte?: string ;
  username_contains?: string ;
  username_not_contains?: string ;
  username_starts_with?: string ;
  username_not_starts_with?: string ;
  username_ends_with?: string ;
  username_not_ends_with?: string ;
  shouldUpdatePassword?: boolean ;
  shouldUpdatePassword_not?: boolean ;
  comments_every?: UserCommentWhereInput ;
  comments_some?: UserCommentWhereInput ;
  comments_none?: UserCommentWhereInput ;
  writtenComments_every?: UserCommentWhereInput ;
  writtenComments_some?: UserCommentWhereInput ;
  writtenComments_none?: UserCommentWhereInput ;
  receiptPointsScans_every?: ReceiptPointsScanWhereInput ;
  receiptPointsScans_some?: ReceiptPointsScanWhereInput ;
  receiptPointsScans_none?: ReceiptPointsScanWhereInput ;
  AND?: UserWhereInput[] ;
  OR?: UserWhereInput[] ;
  NOT?: UserWhereInput[] ;
}

export interface UserWhereUniqueInput {
  id?: string ;
  phone?: string ;
  username?: string ;
}

export interface VariationCreateManyWithoutCompanyInput {
  create?: VariationCreateWithoutCompanyInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutDefaultOnItemsInput {
  create?: VariationCreateWithoutDefaultOnItemsInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutGroupInput {
  create?: VariationCreateWithoutGroupInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutImageInput {
  create?: VariationCreateWithoutImageInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutItemsInput {
  create?: VariationCreateWithoutItemsInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutMenuEntryInput {
  create?: VariationCreateWithoutMenuEntryInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutOrderItemsInput {
  create?: VariationCreateWithoutOrderItemsInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutPreselectedOnGroupsInput {
  create?: VariationCreateWithoutPreselectedOnGroupsInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutRecommendationsInput {
  create?: VariationCreateWithoutRecommendationsInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutRemovedFromInput {
  create?: VariationCreateWithoutRemovedFromInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutSizeUsesInput {
  create?: VariationCreateWithoutSizeUsesInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateOneWithoutAppliedVariationsInput {
  create?: VariationCreateWithoutAppliedVariationsInput ;
  connect?: VariationWhereUniqueInput ;
}

export interface VariationCreateOneWithoutArticleMapInput {
  create?: VariationCreateWithoutArticleMapInput ;
  connect?: VariationWhereUniqueInput ;
}

export interface VariationCreateOneWithoutNameLangInput {
  create?: VariationCreateWithoutNameLangInput ;
  connect?: VariationWhereUniqueInput ;
}

export interface VariationCreateOneWithoutOrderItemSizesInput {
  create?: VariationCreateWithoutOrderItemSizesInput ;
  connect?: VariationWhereUniqueInput ;
}

export interface VariationCreateWithoutAppliedVariationsInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutArticleMapInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutCompanyInput {
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutDefaultOnItemsInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutGroupInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutImageInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutItemsInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutMenuEntryInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutNameLangInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutOrderItemSizesInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutOrderItemsInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutPreselectedOnGroupsInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutRecommendationsInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutRemovedFromInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutSizeUsesInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreatetagsInput {
  set?: string[] ;
}

export interface VariationGroupCreateManyWithoutCompanyInput {
  create?: VariationGroupCreateWithoutCompanyInput[] ;
  connect?: VariationGroupWhereUniqueInput[] ;
}

export interface VariationGroupCreateManyWithoutPreselectedVariationsInput {
  create?: VariationGroupCreateWithoutPreselectedVariationsInput[] ;
  connect?: VariationGroupWhereUniqueInput[] ;
}

export interface VariationGroupCreateManyWithoutVariationsInput {
  create?: VariationGroupCreateWithoutVariationsInput[] ;
  connect?: VariationGroupWhereUniqueInput[] ;
}

export interface VariationGroupCreateOneWithoutApplicationsInput {
  create?: VariationGroupCreateWithoutApplicationsInput ;
  connect?: VariationGroupWhereUniqueInput ;
}

export interface VariationGroupCreateOneWithoutTitleInput {
  create?: VariationGroupCreateWithoutTitleInput ;
  connect?: VariationGroupWhereUniqueInput ;
}

export interface VariationGroupCreateWithoutApplicationsInput {
  id?: string ;
  company: CompanyCreateOneWithoutVariationGroupsInput;
  title?: TranslatedStringCreateOneWithoutVariationGroupNameInput ;
  type: VARIATION_TYPE;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  variations?: VariationCreateManyWithoutGroupInput ;
  preselectedVariations?: VariationCreateManyWithoutPreselectedOnGroupsInput ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupCreateWithoutCompanyInput {
  id?: string ;
  title?: TranslatedStringCreateOneWithoutVariationGroupNameInput ;
  type: VARIATION_TYPE;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  variations?: VariationCreateManyWithoutGroupInput ;
  preselectedVariations?: VariationCreateManyWithoutPreselectedOnGroupsInput ;
  applications?: AppliedVariationCreateManyWithoutGroupInput ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupCreateWithoutPreselectedVariationsInput {
  id?: string ;
  company: CompanyCreateOneWithoutVariationGroupsInput;
  title?: TranslatedStringCreateOneWithoutVariationGroupNameInput ;
  type: VARIATION_TYPE;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  variations?: VariationCreateManyWithoutGroupInput ;
  applications?: AppliedVariationCreateManyWithoutGroupInput ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupCreateWithoutTitleInput {
  id?: string ;
  company: CompanyCreateOneWithoutVariationGroupsInput;
  type: VARIATION_TYPE;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  variations?: VariationCreateManyWithoutGroupInput ;
  preselectedVariations?: VariationCreateManyWithoutPreselectedOnGroupsInput ;
  applications?: AppliedVariationCreateManyWithoutGroupInput ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupCreateWithoutVariationsInput {
  id?: string ;
  company: CompanyCreateOneWithoutVariationGroupsInput;
  title?: TranslatedStringCreateOneWithoutVariationGroupNameInput ;
  type: VARIATION_TYPE;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  preselectedVariations?: VariationCreateManyWithoutPreselectedOnGroupsInput ;
  applications?: AppliedVariationCreateManyWithoutGroupInput ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  title?: TranslatedStringWhereInput ;
  type?: VARIATION_TYPE ;
  type_not?: VARIATION_TYPE ;
  type_in?: VARIATION_TYPE[] ;
  type_not_in?: VARIATION_TYPE[] ;
  variationClass?: VARIATION_CLASS ;
  variationClass_not?: VARIATION_CLASS ;
  variationClass_in?: VARIATION_CLASS[] ;
  variationClass_not_in?: VARIATION_CLASS[] ;
  limitMin?: number ;
  limitMin_not?: number ;
  limitMin_in?: number[] ;
  limitMin_not_in?: number[] ;
  limitMin_lt?: number ;
  limitMin_lte?: number ;
  limitMin_gt?: number ;
  limitMin_gte?: number ;
  limitMax?: number ;
  limitMax_not?: number ;
  limitMax_in?: number[] ;
  limitMax_not_in?: number[] ;
  limitMax_lt?: number ;
  limitMax_lte?: number ;
  limitMax_gt?: number ;
  limitMax_gte?: number ;
  required?: boolean ;
  required_not?: boolean ;
  variations_every?: VariationWhereInput ;
  variations_some?: VariationWhereInput ;
  variations_none?: VariationWhereInput ;
  preselectedVariations_every?: VariationWhereInput ;
  preselectedVariations_some?: VariationWhereInput ;
  preselectedVariations_none?: VariationWhereInput ;
  applications_every?: AppliedVariationWhereInput ;
  applications_some?: AppliedVariationWhereInput ;
  applications_none?: AppliedVariationWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  AND?: VariationGroupWhereInput[] ;
  OR?: VariationGroupWhereInput[] ;
  NOT?: VariationGroupWhereInput[] ;
}

export interface VariationGroupWhereUniqueInput {
  id?: string ;
}

export interface VariationWhereInput {
  company?: CompanyWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  menuEntry?: MenuEntryWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  nameLang?: TranslatedStringWhereInput ;
  orderItems_every?: OrderItemWhereInput ;
  orderItems_some?: OrderItemWhereInput ;
  orderItems_none?: OrderItemWhereInput ;
  removedFrom_every?: OrderItemWhereInput ;
  removedFrom_some?: OrderItemWhereInput ;
  removedFrom_none?: OrderItemWhereInput ;
  price?: number ;
  price_not?: number ;
  price_in?: number[] ;
  price_not_in?: number[] ;
  price_lt?: number ;
  price_lte?: number ;
  price_gt?: number ;
  price_gte?: number ;
  absolutePrice?: boolean ;
  absolutePrice_not?: boolean ;
  orderItemSizes_every?: OrderItemWhereInput ;
  orderItemSizes_some?: OrderItemWhereInput ;
  orderItemSizes_none?: OrderItemWhereInput ;
  sizeUses_every?: ItemSizeWhereInput ;
  sizeUses_some?: ItemSizeWhereInput ;
  sizeUses_none?: ItemSizeWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  defaultOnItems_every?: ItemWhereInput ;
  defaultOnItems_some?: ItemWhereInput ;
  defaultOnItems_none?: ItemWhereInput ;
  appliedVariations_every?: AppliedVariationWhereInput ;
  appliedVariations_some?: AppliedVariationWhereInput ;
  appliedVariations_none?: AppliedVariationWhereInput ;
  recommendations_every?: RecommendationWhereInput ;
  recommendations_some?: RecommendationWhereInput ;
  recommendations_none?: RecommendationWhereInput ;
  articleMap?: ArticleMapWhereInput ;
  group_every?: VariationGroupWhereInput ;
  group_some?: VariationGroupWhereInput ;
  group_none?: VariationGroupWhereInput ;
  preselectedOnGroups_every?: VariationGroupWhereInput ;
  preselectedOnGroups_some?: VariationGroupWhereInput ;
  preselectedOnGroups_none?: VariationGroupWhereInput ;
  image?: ImageWhereInput ;
  asItem?: ItemWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  highlighted?: boolean ;
  highlighted_not?: boolean ;
  allergen?: ALLERGEN ;
  allergen_not?: ALLERGEN ;
  allergen_in?: ALLERGEN[] ;
  allergen_not_in?: ALLERGEN[] ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  AND?: VariationWhereInput[] ;
  OR?: VariationWhereInput[] ;
  NOT?: VariationWhereInput[] ;
}

export interface VariationWhereUniqueInput {
  id?: string ;
}

export interface VenueCreateManyWithoutCompanyInput {
  create?: VenueCreateWithoutCompanyInput[] ;
  connect?: VenueWhereUniqueInput[] ;
}

export interface VenueCreateManyWithoutDeliveryRatesInput {
  create?: VenueCreateWithoutDeliveryRatesInput[] ;
  connect?: VenueWhereUniqueInput[] ;
}

export interface VenueCreateManyWithoutImageInput {
  create?: VenueCreateWithoutImageInput[] ;
  connect?: VenueWhereUniqueInput[] ;
}

export interface VenueCreateManyWithoutLocalDeliveriesInput {
  create?: VenueCreateWithoutLocalDeliveriesInput[] ;
  connect?: VenueWhereUniqueInput[] ;
}

export interface VenueCreateManyWithoutOffersInput {
  create?: VenueCreateWithoutOffersInput[] ;
  connect?: VenueWhereUniqueInput[] ;
}

export interface VenueCreateManyWithoutStampCardsInput {
  create?: VenueCreateWithoutStampCardsInput[] ;
  connect?: VenueWhereUniqueInput[] ;
}

export interface VenueCreateManyWithoutUsersInput {
  create?: VenueCreateWithoutUsersInput[] ;
  connect?: VenueWhereUniqueInput[] ;
}

export interface VenueCreateOneWithoutAvailabilitiesInput {
  create?: VenueCreateWithoutAvailabilitiesInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutExpensesInput {
  create?: VenueCreateWithoutExpensesInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutFloorPlansInput {
  create?: VenueCreateWithoutFloorPlansInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutInvoiceTargetsInput {
  create?: VenueCreateWithoutInvoiceTargetsInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutLocationInput {
  create?: VenueCreateWithoutLocationInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutMenusInput {
  create?: VenueCreateWithoutMenusInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutNameLangInput {
  create?: VenueCreateWithoutNameLangInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutOrdersInput {
  create?: VenueCreateWithoutOrdersInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutPaymentMethodsInput {
  create?: VenueCreateWithoutPaymentMethodsInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutPosDevicesInput {
  create?: VenueCreateWithoutPosDevicesInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutPosMetadataInput {
  create?: VenueCreateWithoutPosMetadataInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutPredefinedMessagesInput {
  create?: VenueCreateWithoutPredefinedMessagesInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutReceiptTemplateInput {
  create?: VenueCreateWithoutReceiptTemplateInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutTablesInput {
  create?: VenueCreateWithoutTablesInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateWithoutAvailabilitiesInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutCompanyInput {
  active: boolean;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutDeliveryRatesInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutExpensesInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutFloorPlansInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutImageInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutInvoiceTargetsInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutLocalDeliveriesInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutLocationInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutMenusInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutNameLangInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutOffersInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutOrdersInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutPaymentMethodsInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutPosDevicesInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutPosMetadataInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutPredefinedMessagesInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutReceiptTemplateInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutStampCardsInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutTablesInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutUsersInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueWhereInput {
  active?: boolean ;
  active_not?: boolean ;
  company?: CompanyWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  deliveryRates_every?: DeliveryRateWhereInput ;
  deliveryRates_some?: DeliveryRateWhereInput ;
  deliveryRates_none?: DeliveryRateWhereInput ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  image?: ImageWhereInput ;
  location?: LocationWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  nameLang?: TranslatedStringWhereInput ;
  orders_every?: OrderWhereInput ;
  orders_some?: OrderWhereInput ;
  orders_none?: OrderWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  menus_every?: AppliedMenuWhereInput ;
  menus_some?: AppliedMenuWhereInput ;
  menus_none?: AppliedMenuWhereInput ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  availabilities_every?: AvailabilityWhereInput ;
  availabilities_some?: AvailabilityWhereInput ;
  availabilities_none?: AvailabilityWhereInput ;
  stampCards_every?: StampCardWhereInput ;
  stampCards_some?: StampCardWhereInput ;
  stampCards_none?: StampCardWhereInput ;
  organizationId?: string ;
  organizationId_not?: string ;
  organizationId_in?: string[] ;
  organizationId_not_in?: string[] ;
  organizationId_lt?: string ;
  organizationId_lte?: string ;
  organizationId_gt?: string ;
  organizationId_gte?: string ;
  organizationId_contains?: string ;
  organizationId_not_contains?: string ;
  organizationId_starts_with?: string ;
  organizationId_not_starts_with?: string ;
  organizationId_ends_with?: string ;
  organizationId_not_ends_with?: string ;
  phone?: string ;
  phone_not?: string ;
  phone_in?: string[] ;
  phone_not_in?: string[] ;
  phone_lt?: string ;
  phone_lte?: string ;
  phone_gt?: string ;
  phone_gte?: string ;
  phone_contains?: string ;
  phone_not_contains?: string ;
  phone_starts_with?: string ;
  phone_not_starts_with?: string ;
  phone_ends_with?: string ;
  phone_not_ends_with?: string ;
  minimumDeliveryFee?: number ;
  minimumDeliveryFee_not?: number ;
  minimumDeliveryFee_in?: number[] ;
  minimumDeliveryFee_not_in?: number[] ;
  minimumDeliveryFee_lt?: number ;
  minimumDeliveryFee_lte?: number ;
  minimumDeliveryFee_gt?: number ;
  minimumDeliveryFee_gte?: number ;
  supportEmail?: string ;
  supportEmail_not?: string ;
  supportEmail_in?: string[] ;
  supportEmail_not_in?: string[] ;
  supportEmail_lt?: string ;
  supportEmail_lte?: string ;
  supportEmail_gt?: string ;
  supportEmail_gte?: string ;
  supportEmail_contains?: string ;
  supportEmail_not_contains?: string ;
  supportEmail_starts_with?: string ;
  supportEmail_not_starts_with?: string ;
  supportEmail_ends_with?: string ;
  supportEmail_not_ends_with?: string ;
  lastSeenOnline?: any ;
  lastSeenOnline_not?: any ;
  lastSeenOnline_in?: any[] ;
  lastSeenOnline_not_in?: any[] ;
  lastSeenOnline_lt?: any ;
  lastSeenOnline_lte?: any ;
  lastSeenOnline_gt?: any ;
  lastSeenOnline_gte?: any ;
  lastSeenVersion?: string ;
  lastSeenVersion_not?: string ;
  lastSeenVersion_in?: string[] ;
  lastSeenVersion_not_in?: string[] ;
  lastSeenVersion_lt?: string ;
  lastSeenVersion_lte?: string ;
  lastSeenVersion_gt?: string ;
  lastSeenVersion_gte?: string ;
  lastSeenVersion_contains?: string ;
  lastSeenVersion_not_contains?: string ;
  lastSeenVersion_starts_with?: string ;
  lastSeenVersion_not_starts_with?: string ;
  lastSeenVersion_ends_with?: string ;
  lastSeenVersion_not_ends_with?: string ;
  bookingServiceId?: string ;
  bookingServiceId_not?: string ;
  bookingServiceId_in?: string[] ;
  bookingServiceId_not_in?: string[] ;
  bookingServiceId_lt?: string ;
  bookingServiceId_lte?: string ;
  bookingServiceId_gt?: string ;
  bookingServiceId_gte?: string ;
  bookingServiceId_contains?: string ;
  bookingServiceId_not_contains?: string ;
  bookingServiceId_starts_with?: string ;
  bookingServiceId_not_starts_with?: string ;
  bookingServiceId_ends_with?: string ;
  bookingServiceId_not_ends_with?: string ;
  openingSoon?: boolean ;
  openingSoon_not?: boolean ;
  offers_every?: OfferWhereInput ;
  offers_some?: OfferWhereInput ;
  offers_none?: OfferWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  localDeliveries?: LocalDeliveryOptionsWhereInput ;
  tables_every?: TableWhereInput ;
  tables_some?: TableWhereInput ;
  tables_none?: TableWhereInput ;
  reports_every?: ReportWhereInput ;
  reports_some?: ReportWhereInput ;
  reports_none?: ReportWhereInput ;
  legalName?: string ;
  legalName_not?: string ;
  legalName_in?: string[] ;
  legalName_not_in?: string[] ;
  legalName_lt?: string ;
  legalName_lte?: string ;
  legalName_gt?: string ;
  legalName_gte?: string ;
  legalName_contains?: string ;
  legalName_not_contains?: string ;
  legalName_starts_with?: string ;
  legalName_not_starts_with?: string ;
  legalName_ends_with?: string ;
  legalName_not_ends_with?: string ;
  posMetadata?: PosMetadataWhereInput ;
  posDevices_every?: POSDeviceWhereInput ;
  posDevices_some?: POSDeviceWhereInput ;
  posDevices_none?: POSDeviceWhereInput ;
  receiptTemplate?: ReceiptTemplateWhereInput ;
  staffIdleTimeout?: number ;
  staffIdleTimeout_not?: number ;
  staffIdleTimeout_in?: number[] ;
  staffIdleTimeout_not_in?: number[] ;
  staffIdleTimeout_lt?: number ;
  staffIdleTimeout_lte?: number ;
  staffIdleTimeout_gt?: number ;
  staffIdleTimeout_gte?: number ;
  invoiceTargets_every?: InvoiceTargetWhereInput ;
  invoiceTargets_some?: InvoiceTargetWhereInput ;
  invoiceTargets_none?: InvoiceTargetWhereInput ;
  paymentMethods_every?: PaymentMethodWhereInput ;
  paymentMethods_some?: PaymentMethodWhereInput ;
  paymentMethods_none?: PaymentMethodWhereInput ;
  floorPlans_every?: FloorPlanWhereInput ;
  floorPlans_some?: FloorPlanWhereInput ;
  floorPlans_none?: FloorPlanWhereInput ;
  predefinedMessages_every?: PredefinedMessageWhereInput ;
  predefinedMessages_some?: PredefinedMessageWhereInput ;
  predefinedMessages_none?: PredefinedMessageWhereInput ;
  expenses_every?: ExpenseWhereInput ;
  expenses_some?: ExpenseWhereInput ;
  expenses_none?: ExpenseWhereInput ;
  printBong?: boolean ;
  printBong_not?: boolean ;
  timezone?: string ;
  timezone_not?: string ;
  timezone_in?: string[] ;
  timezone_not_in?: string[] ;
  timezone_lt?: string ;
  timezone_lte?: string ;
  timezone_gt?: string ;
  timezone_gte?: string ;
  timezone_contains?: string ;
  timezone_not_contains?: string ;
  timezone_starts_with?: string ;
  timezone_not_starts_with?: string ;
  timezone_ends_with?: string ;
  timezone_not_ends_with?: string ;
  AND?: VenueWhereInput[] ;
  OR?: VenueWhereInput[] ;
  NOT?: VenueWhereInput[] ;
}

export interface VenueWhereUniqueInput {
  id?: string ;
}

export interface WasteItemInput {
  itemId: string;
  title?: string ;
  fraction?: number ;
  cost?: number ;
}

export interface ZoneCreateInput {
  id?: string ;
  name: string;
  deleted?: boolean ;
  tables?: TableCreateManyInput ;
  company: CompanyCreateOneWithoutZonesInput;
}

export interface ZoneCreateManyWithoutCompanyInput {
  create?: ZoneCreateWithoutCompanyInput[] ;
  connect?: ZoneWhereUniqueInput[] ;
}

export interface ZoneCreateOneInput {
  create?: ZoneCreateInput ;
  connect?: ZoneWhereUniqueInput ;
}

export interface ZoneCreateWithoutCompanyInput {
  id?: string ;
  name: string;
  deleted?: boolean ;
  tables?: TableCreateManyInput ;
}

export interface ZoneWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  tables_every?: TableWhereInput ;
  tables_some?: TableWhereInput ;
  tables_none?: TableWhereInput ;
  company?: CompanyWhereInput ;
  AND?: ZoneWhereInput[] ;
  OR?: ZoneWhereInput[] ;
  NOT?: ZoneWhereInput[] ;
}

export interface ZoneWhereUniqueInput {
  id?: string ;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
